export const DM_EVENT = {
    update: 'dmChangeCart',
    addMontage: 'dmAddMontage',
    delMontage: 'dmDelMontage',
};
export const LS_CART_KEY = '_ductmaster_cart';
export const KeysThatCanBeDeleted = ['Оснастка', 'Ral', 'Система', 'Этаж'];
export const MATERIALS = {
    calcZV_elements: [
        '<h4 title=\'Оцинкованная сталь\' onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/Оцинкованная сталь.mp3`).play();\'>1️⃣➖Оц. <input checked class=\'option-input radio\' type=\'radio\' id1=\'1\' name=\'TypeSteel\' value=\'Gost\' title=\'Выбирайте ГОСТ 14918-2020\'><a href=\'#popmake-6359\' title=\'ГОСТ 14918-2020\' ><h4 style=\'color:#0000ff;\'>ГОСТ 14918-2020</h4></a> <input class=\'option-input radio\' type=\'radio\' id2=\'2\' name=\'TypeSteel\' value=\'NoGost\' title=\'Выбирайте ТУ\'>ТУ</h4>',
        '<h4 title=\'Оцинкованная сталь стандарт до ➕8️⃣0️⃣°С Кратковременно до ➕2️⃣0️⃣0️⃣°С. Отн. влажность до 60%\' >2️⃣➖Оц. цинк 8️⃣0️⃣➖1️⃣0️⃣0️⃣ г/м²</h4>',
        '<h4>3️⃣➖Оц. <a title=\'ГОСТ 14918-80\' href=\'#popmake-5882\'><h4 style=\'color:#0000ff;\'>ГОСТ</h4></a> цинк г/м2 <input checked class=\'option-input radio\' type=\'radio\' id1=\'1\' name=\'Цинк\' value=\'цинк 140 г/м2\' title=\'Выбирайте цинк 140 г/м2 \'> 140 <input class=\'option-input radio\' type=\'radio\' id2=\'2\' name=\'Цинк\' value=\'цинк 275 г/м2\' title=\'Выбирайте цинк 275 г/м2 \'> 275 <a href=\'#popmake-5992\'><h4 style=\'color:#0000ff;\'>СП 60.13330.2012</h4></a>',
        '<h4 title=\'Оцинкованная сталь Тонколистовая холоднокатаная (сталь без покрытия) ГОСТ 16523-70, ГОСТ 19903-74 до 80°С\' >5️⃣➖Тонколистовая холоднокатаная <a href=\'#popmake-\'><h4 style=\'color:#0000ff;\'>ГОСТ</h4></a> до 80°С</h4>',
        '<h4>6️⃣➖Оц. Б Ст3КП <input checked class=\'option-input radio\' type=\'radio\' id1=\'1\' name=\'Б Ст3КП\' value=\'ГОСТ24751-81\' title=\'Выбирайте ГОСТ 24751-81 \'><a href=\'#popmake-\' title=\'ГОСТ 24751-81 \' ><h4 style=\'color:#0000ff;\'>ГОСТ 24751-81</h4></a> <input class=\'option-input radio\' type=\'radio\' id2=\'2\' name=\'Б Ст3КП\' value=\'Гост16523–70\' title=\'Выбирайте ГОСТ 16523–70 \'><a href=\'#popmake-5994\' title=\'ГОСТ 16523–70\' ><h4 style=\'color:#0000ff;\'>ГОСТ 16523–70</h4></a>',
        '<h4 title=\'Оцинкованная сталь ДЫМОУДАЛЕНИЕ до ➕500°С (кратковременно до ➕700°С)\' >8️⃣➖Оц. <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/SVCtAXT.gif\' alt=\'\' style=\'width: 70px; height: auto;\'/>ДЫМОУДАЛЕНИЕ</h4>',
        '<h4 title=\'Нержавеющая сталь\' >9️⃣➖08Х18Н10 (AISI 304) пищевые, матовые <a href=\'#popmake-\'><h4 style=\'color:#0000ff;\'>ГОСТ 5632-72</h4></a>',
        '<h4 title=\'Нержавеющая сталь\'>1️⃣0️⃣➖AISI 304 пищевые <input checked class=\'option-input radio\' type=\'radio\' id1=\'1\' name=\'TypeSteeAISI\' value=\'AISI304 пищевые, зеркальные\' title=\'Выбирайте 08Х18Н10 AISI304 пищевые, зеркальные\'><a href=\'#popmake-\' title=\'Нержавеющая сталь 08Х18Н10 AISI 304 пищевые, зеркальные\' ><h4 style=\'color:#0000ff;\'>зеркальные</h4></a> <input class=\'option-input radio\' type=\'radio\' id2=\'2\' name=\'TypeSteeAISI\' value=\'AISI304 пищевые, шлифованные\' title=\'Выбирайте AISI304 пищевые, шлифованные\'><a href=\'#popmake-\' title=\'Нержавеющая сталь 08Х18Н10 (AISI 304) пищевые, шлифованные\' ><h4 style=\'color:#0000ff;\'>шлифованные</h4></a>',
        '<h4 title=\'Нержавеющая сталь\'>1️⃣2️⃣➖08Х17, 08Х18Н10 AISI 201 декоративные, рифлёные</h4>',
        '<h4 title=\'Нержавеющая сталь 10Х17Н13М2, 03Х17Н13АМ3, AISI 316L кислотостойкие с молибденом\' >1️⃣3️⃣➖AISI 316L кислотостойкие с молибденом</h4>',
        '<h4 title=\'Нержавеющая сталь\'>1️⃣4️⃣➖12Х18Н10Т, AISI 321 с содержанием титана</h4>',
        '<h4 title=\'Нержавеющая сталь\'>1️⃣5️⃣➖12Х15Г9НД (AISI 201) технические, матовые</h4>',
        '<h4 title=\'Нержавеющая сталь\'>1️⃣6️⃣➖08Х17 (AISI 430) технические, матовые</h4>',
        '<h4 title=\'Нержавеющая сталь\'>1️⃣7️⃣➖08Х17 (AISI 430) технические, шлифованные</h4>',
        '<h4 title=\'Нержавеющая сталь\'>1️⃣8️⃣➖08Х17 (AISI 430) технические, зеркальные</h4>',
        '<h4>1️⃣9️⃣➖Нержавеющая сталь листы жаропрочные</h4>',
        '<h4 title=\'\'>2️⃣1️⃣➖Чёрная сталь(Аспирация) <a href=\'#popmake-\'><h4 style=\'color:#0000ff;\'>ГОСТ 16523-97</h4></a>',
        '<h4>2️⃣2️⃣➖Материал заказчика</h4>',
        '<h4 title=\'Алюминий до ➕2️⃣0️⃣0️⃣°С (кратковременно до ➕3️⃣0️⃣0️⃣°С)\' >2️⃣3️⃣➖Алюминий до ➕2️⃣0️⃣0️⃣°С</h4>',
        '<h4 title=\'\'>2️⃣4️⃣➖Текстильные воздуховоды</h4>',
        '<h4 title=\'\'>2️⃣5️⃣➖Гальванизация</h4>',
        '<h4 title=\'\'>2️⃣6️⃣➖Нержавеющая сталь <input checked class=\'option-input radio\' type=\'radio\' id1=\'1\' name=\'TypeAISISteel\' value=\'Gost\' title=\'Выбирайте AISI316\'><a href=\'#popmake-\'><h4 style=\'color:#0000ff;\'>AISI 316</h4></a> <input class=\'option-input radio\' type=\'radio\' id2=\'2\' name=\'TypeAISISteel\' value=\'Gost\' title=\'Выбирайте AISI321\'><a href=\'#popmake-\'><h4 style=\'color:#0000ff;\'>AISI 321</h4></a>',
    ],
    ACmaster_elements: [
        '<h4>ПВХ➖<input checked class=\'option-input radio\' type=\'radio\' id1=\'1\' name=\'ПВХ\' value=\'ГОСТ30673-99\' title=\'Выбирайте ГОСТ 30673-99 \'><a href=\'#popmake-6020\'><h4 style=\'color:#0000ff;\'>ПВХ ГОСТ</h4></a>  <input class=\'option-input radio\' type=\'radio\' id2=\'2\' name=\'ПВХ\' value=\'ПВХ-Дерево\' title=\'Выбирайте ПВХ-Дерево \'>ПВХ➖Дерево <input class=\'option-input radio\' type=\'radio\' id3=\'3\' name=\'ПВХ\' value=\'ПВХ-Allum.\' title=\'Выбирайте ПВХ-Allum. \'>ПВХ➖Allum.</h4>',
        '<h4>Allum.➖<a href=\'#popmake-6013\'><h4 style=\'color:#0000ff;\'>ГОСТ 21519-2022</h4></a>',
        '<h4 title=\'\'>Дерево➖<a href=\'#popmake-6011\'><h4 style=\'color:#0000ff;\'>ГОСТ 24700-99</h4></a>',
        '<h4 title=\'\'>Дерево-Allum.</h4>',
        '<h4 title=\'\'>Стеклокомпозит</h4>',
        '<h4 title=\'\'>Стекло <a href=\'#popmake-6158\'><h4 style=\'color:#0000ff;\'>ГОСТ 111-2001</h4></a>',
        '<h4 title=\'\'>Мягкие окна</h4>',
        '<h4 title=\'\'>2️⃣0️⃣➖Пластик (химически стойкие)</h4>',
        '<h4 title=\'\'>2️⃣8️⃣➖100% полиэстер с PU-покрытием 160г/м²</h4>',
        '<h4 title=\'\'>2️⃣9️⃣➖100% полиэстер с PU-покрытием 220г/м²</h4>',
        '<h4 title=\'\'>3️⃣0️⃣➖98% полиэстер огнестойкий антистатический</h4>',
        '<h4 title=\'\'>3️⃣1️⃣➖100% полиэфир</h4>',
        '<h4 title=\'\'>3️⃣2️⃣➖100% полиэфир слабогорючий</h4>',
        '<h4 title=\'\'>3️⃣3️⃣➖100% полиамид</h4>',
        '<h4 title=\'\'>3️⃣4️⃣➖<img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/Упаковка.png\' class=\'scale\' style=\'width: 50px; height: auto;\'/>Картонные🤔</h4>',
    ],
    Ultra_elements: [
        '<h4>ПВХ➖<input checked class=\'option-input radio\' type=\'radio\' id1=\'1\' name=\'ПВХ\' value=\'ГОСТ30673-99\' title=\'Выбирайте ГОСТ 30673-99 \'><a href=\'#popmake-6020\'><h4 style=\'color:#0000ff;\'>ПВХ ГОСТ</h4></a>  <input class=\'option-input radio\' type=\'radio\' id2=\'2\' name=\'ПВХ\' value=\'ПВХ-Дерево\' title=\'Выбирайте ПВХ-Дерево \'>ПВХ➖Дерево <input class=\'option-input radio\' type=\'radio\' id3=\'3\' name=\'ПВХ\' value=\'ПВХ-Allum.\' title=\'Выбирайте ПВХ-Allum. \'>ПВХ➖Allum.</h4>',
        '<h4>Allum.➖<a href=\'#popmake-6013\'><h4 style=\'color:#0000ff;\'>ГОСТ 21519-2022</h4></a>',
        '<h4 title=\'\'>Дерево➖<a href=\'#popmake-6011\'><h4 style=\'color:#0000ff;\'>ГОСТ 24700-99</h4></a>',
        '<h4 title=\'\'>Дерево-Allum.</h4>',
        '<h4 title=\'\'>Стеклокомпозит</h4>',
        '<h4 title=\'\'>Стекло <a href=\'#popmake-6158\'><h4 style=\'color:#0000ff;\'>ГОСТ 111-2001</h4></a>',
        '<h4 title=\'\'>Мягкие окна</h4>',
        '<h4 title=\'\'>2️⃣0️⃣➖Пластик (химически стойкие)</h4>',
        '<h4 title=\'\'>2️⃣8️⃣➖100% полиэстер с PU-покрытием 160г/м²</h4>',
        '<h4 title=\'\'>2️⃣9️⃣➖100% полиэстер с PU-покрытием 220г/м²</h4>',
        '<h4 title=\'\'>3️⃣0️⃣➖98% полиэстер огнестойкий антистатический</h4>',
        '<h4 title=\'\'>3️⃣1️⃣➖100% полиэфир</h4>',
        '<h4 title=\'\'>3️⃣2️⃣➖100% полиэфир слабогорючий</h4>',
        '<h4 title=\'\'>3️⃣3️⃣➖100% полиамид</h4>',
        '<h4 title=\'\'>3️⃣4️⃣➖<img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/Упаковка.png\' class=\'scale\' style=\'width: 50px; height: auto;\'/>Картонные🤔</h4>',
    ],
    Concrete_elements: [
        '<h4>ПВХ➖<input checked class=\'option-input radio\' type=\'radio\' id1=\'1\' name=\'ПВХ\' value=\'ГОСТ30673-99\' title=\'Выбирайте ГОСТ 30673-99 \'><a href=\'#popmake-6020\'><h4 style=\'color:#0000ff;\'>ПВХ ГОСТ</h4></a>  <input class=\'option-input radio\' type=\'radio\' id2=\'2\' name=\'ПВХ\' value=\'ПВХ-Дерево\' title=\'Выбирайте ПВХ-Дерево \'>ПВХ➖Дерево <input class=\'option-input radio\' type=\'radio\' id3=\'3\' name=\'ПВХ\' value=\'ПВХ-Allum.\' title=\'Выбирайте ПВХ-Allum. \'>ПВХ➖Allum.</h4>',
        '<h4>Allum.➖<a href=\'#popmake-6013\'><h4 style=\'color:#0000ff;\'>ГОСТ 21519-2022</h4></a>',
        '<h4 title=\'\'>Дерево➖<a href=\'#popmake-6011\'><h4 style=\'color:#0000ff;\'>ГОСТ 24700-99</h4></a>',
        '<h4 title=\'\'>Дерево-Allum.</h4>',
        '<h4 title=\'\'>Стеклокомпозит</h4>',
        '<h4 title=\'\'>Стекло <a href=\'#popmake-6158\'><h4 style=\'color:#0000ff;\'>ГОСТ 111-2001</h4></a>',
        '<h4 title=\'\'>Мягкие окна</h4>',
        '<h4 title=\'\'>2️⃣0️⃣➖Пластик (химически стойкие)</h4>',
        '<h4 title=\'\'>2️⃣8️⃣➖100% полиэстер с PU-покрытием 160г/м²</h4>',
        '<h4 title=\'\'>2️⃣9️⃣➖100% полиэстер с PU-покрытием 220г/м²</h4>',
        '<h4 title=\'\'>3️⃣0️⃣➖98% полиэстер огнестойкий антистатический</h4>',
        '<h4 title=\'\'>3️⃣1️⃣➖100% полиэфир</h4>',
        '<h4 title=\'\'>3️⃣2️⃣➖100% полиэфир слабогорючий</h4>',
        '<h4 title=\'\'>3️⃣3️⃣➖100% полиамид</h4>',
        '<h4 title=\'\'>3️⃣4️⃣➖<img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/Упаковка.png\' class=\'scale\' style=\'width: 50px; height: auto;\'/>Картонные🤔</h4>',
    ],
};
export const SECTIONS = {
    calcZV_elements: [
        '<h4 title=\'Прямоугольное сечение\' onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/rectangular.mp3`).play();\'>Прямоугольное <img title=\'Воздуховод прямоугольный, прямик, патрубок\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/1-2-1.png\' class=\'scale\' alt=\'1-1-1\' style=\'width: 50px; height: auto;\' ></h4>',
        '<h3>⭕Круглое</h3>',
        '<h3><img src=\'/wp-content/uploads/2024/catalog/oval.png\' alt=\'\' class=\'scale\' style=\'width: 30px; height: auto; \'/>Овальное</h3>',
        '<h3>Полукруг</h3>',
        '<h3>⏹️Прямоугольное Ткань</h3>',
        '<h3>⭕Круглое Ткань</h3>',
        '<h3><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Ткань/Полукруг Ткань.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto; \'/>Полукруг Ткань</h3>',
        '<h3><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Ткань/Квадрант ткань.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto; \'/>Квадрант Ткань</h3>',
        '<h3><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Ткань/Сегмент ткань.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto; \'/>Сегмент Ткань</h3>',
        '<h3><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Ткань/Сектор ткань.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto; \'/>🔻Сектор Ткань</h3>',
        '<h3>Ultra<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/1. шкаф автоматики.gif\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto; \'/></h3>',
        '<h3>Сад и огород</h3>',
        '<h3>Кровля</h3>',
        '<h3><img src=\'/wp-content/themes/mesmerize-child/assets/img/Водоподготовка/1. Водоподготовка.jpeg\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto; \'/>WaterFilter</h3>',
        '<h3>🪞<img src=\'/wp-content/uploads/2024/catalog/mirror.gif\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto; \'/>Зеркала</h3>',
        '<h3>🌹Цветы</h3>',
        '<h3>Окна<img src=\'/wp-content/uploads/2024/catalog/okna.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto; \'/></h3>',
        '<h3><img src=\'/wp-content/uploads/2024/catalog/шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto; \'/>Шкаф</h3>',
        '<h3><img src=\'/wp-content/uploads/2024/catalog/Мастер потолков.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto; \'/>Мастер потолков</h3>',
        '<h3>Дымоходы одностенные</h3>',
        '<h3>Дымоходы сэндвич(двухстенные)</h3>',
        '<h3>Дымоходы 3х контурные</h3>',
        '<h3>⚙️Service HVAC</h3>',
        '<h3>⚙️Service окна<img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Service/Service.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto; \'/></h3>',
        '<h3>Отделка</h3>',
        '<h3><img src=\'/wp-content/uploads/2023/07/HR.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto; \'/>HR</h3>',
        '<h3>Heatman</h3>',
        '<h3>Инертные материалы</h3>',
        '<h3><img src=\'/wp-content/themes/mesmerize-child/assets/img/Бетон/beton.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto; \'/>Бетон</h3>',
    ],
    ACmaster_elements: [
        '<h3>Сплит-система<img src=\'/wp-content/themes/mesmerize-child/assets/img/Кондиционер/1. Монтаж кондиционера сплит-система.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto; \'/></h3>',
        'VRV',
    ],
    Ultra_elements: [
        'Шкаф автоматики',
        'Шкафы'
    ],
    Concrete_elements: [
        'Бетон',
        'Песок',
    ]
};
export const ALERT_MSG = {
    ERROR: 'При создании спецификации произошла ошибка',
    NO_COUNT: 'Параметр "Количество" задан не верно. Попробуйте исправить значение',
    ITEM_ADDED: 'Новая позиция была успешно добавлена в корзину!',
    SOME_WENT_WRONG: 'Что-то пошло не так =( Мы уже приступили к решению проблемы.',
    WAS_NO_SENT: 'Что-то пошло не так, счёт не был сгенерирован. Мы уже приступили к решению проблемы.',
    AGREEMENT: 'Для того что бы отправить заказ необходимо согласиться с обработкой персональных данных',
    SUCCESS: 'Мы успешно получили ваш заказ и уже занимаемся им!',
    NO_CALCULATE: 'Не удалось рассчитать. Попробуйте ввести другие параметры для расчёта',
};
export const densityFieldOptions = [
    { value: 'H', text: '<h3>Н➖1.61 л/сек/м при 400Па</h3>' },
    { value: 'П', text: '<h3>П➖0.53 л/сек/м при 400Па</h3>' },
    { value: 'A', text: '<h3>A➖1.32 л/сек/м при 400Па</h3>' },
    { value: 'B', text: '<h3>B➖0.44 л/сек/м при 400Па</h3>' },
    { value: 'C', text: '<h3>C➖0.15 л/сек/м при 400Па</h3>' },
    { value: 'D', text: '<h3>D➖коэффициент утечки 0,18 м³/(ч*м²)</h3>' },
    { value: 'Fr', text: '<h3>Герметизация огнестойким герметиком  +150С</h3>' },
    { value: 'T', text: '<h3>Герметизация термостойким герметиком</h3>' },
];
export const CalcFormSelectOptions = {
    flange: [
        '<h4><img title=\'Фланец оц.Шина20/уголок65\' onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange20.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' style=\'width: 40px; height: auto;\' /> 2️⃣0️⃣</h4>',
        '<h4><img title=\'Фланец оц.Шина30/уголок105\' onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange30.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' style=\'width: 40px; height: auto;\' /> 3️⃣0️⃣</h4>',
        '<h4>TDCIII <img title=\'Фланец оц.TDCIII20\' onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/TDC3.mp3`).play();\'src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 2️⃣0️⃣ </h4>',
        '<h4>TDCIII <img title=\'Фланец оц.TDCIII30\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 3️⃣0️⃣</h4>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/germetik.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Силикон\' /></input> <input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/Герметизация термостойким герметиком.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'🌡️Термостойкий герметик\' /></input> <input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/Герметизация огнестойким герметиком ➕150°С.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'🔥Огнестойкий герметик ➕150°С\' /></input>',
        '<h4><img src=\'/wp-content/uploads/2022/03/лента уплот.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Уплотнительная лента\' /> <input class=\'cb pristine\' type=\'checkbox\' > 1️⃣0️⃣</input><input class=\'cb pristine\' type=\'checkbox\' >1️⃣5️⃣</input><input class=\'cb pristine\' type=\'checkbox\' >2️⃣0️⃣</input></h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\'> <img title=\'Шнур базальтовый огнезащитный BOS-Cord\' src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/Шнур базальтовый огнезащитный.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /></input> <input class=\'cb pristine\' type=\'checkbox\'> <img title=\'Шнур асбестовый огнезащитный\' src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/Шнур асбестовый.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /></input></h4>',
        '<h4>оц. <img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange20.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' style=\'width: 40px; height: auto;\'/> ш20/у65</h4>',
        '<h4>оц. <img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange30.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' style=\'width: 40px; height: auto;\'/> ш30/у105</h4>',
        '<h4>оц. <img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange40.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' style=\'width: 40px; height: auto;\'/> ш40/у105</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/скотч металл.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Скотч металлический\' /> <input class=\'\' type=\'radio\' name=\'Tape\' value=\'50\' checked > 5️⃣0️⃣</input> <input class=\'\' type=\'radio\' name=\'Tape\' value=\'75\' >7️⃣5️⃣</input>  <input class=\'\' type=\'radio\' name=\'Tape\' value=\'100\' >1️⃣0️⃣0️⃣</input></h4>',
        '<h4>TDF <img title=\'Фланец оц.TDF20\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 2️⃣0️⃣</h4>',
        '<h4>TDF <img title=\'Фланец оц.TDF30\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 3️⃣0️⃣</h4>',
        '<h4>Выброс <a href=\'#popmake-6450\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/3. прямой скошенный.png\' class=\'scale\' style=\'width: 50px; height: auto;\'></a> горизонтальный</h4>',
        '<h4>---</h4>',
        '<input class=\'cb pristine\' type=\'number\'>Врезка круглая</input>',
        '<input class=\'cb pristine\' type=\'number\'>Врезка прямоугольная</input>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/.png\' class=\'scale\' alt=\'\' />Врезка круглая</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/.png\' class=\'scale\' alt=\'\' />Врезка прямоугольная</h4>',
        '<h4><img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange40.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' /> 4️⃣0️⃣  <img src=\'/wp-content/uploads/2022/03/Уголок.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Уголок\' /> <input class=\'\' type=\'radio\' name=\'Corner\' value=\'65\' checked > 6️⃣5️⃣</input> <input class=\'\' type=\'radio\' name=\'Corner\' value=\'95\' > 9️⃣5️⃣</input>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20-0.7/у65-2</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20-0.7/у65-2.3</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20-0.7/у65-2.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20-0.7/у65-3</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш30-0.9/у105-3</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш40-1.2/у105-3</h4>',
        '<h4>оц. <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' /> <img src=\'/wp-content/uploads/2022/03/Шина.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Шина\' />2️⃣0️⃣<img src=\'/wp-content/uploads/2022/03/Уголок.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Уголок 65\' />6️⃣5️⃣<img src=\'/wp-content/uploads/2022/03/Саморез.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Саморез\' /></h4>',
        '<h4>оц. <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' /> <img src=\'/wp-content/uploads/2022/03/Шина.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Шина\' />2️⃣0️⃣<img src=\'/wp-content/uploads/2022/03/Уголок.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Уголок 65\' />6️⃣5️⃣<img src=\'/wp-content/uploads/2022/03/Заклепка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Заклепка\' /></h4>',
        '<h4>оц. <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' /> <img src=\'/wp-content/uploads/2022/03/Шина.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Шина\' />2️⃣0️⃣<img src=\'/wp-content/uploads/2022/03/Уголок.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Уголок 65\' />6️⃣5️⃣<img src=\'/wp-content/uploads/2022/03/Точечная сварка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Точечная сварка\' /></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш30/у105усил.саморез</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш30/у105усил.заклепка</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш15/у53</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш15/у60</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш30К/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.шГерм.20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.шГерм.20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.шГерм.30/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.шГерм.15/у53</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.шГерм.15/у60</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.шГерм.30К/у105</h4>',
        '<h4>оц.TDC <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 2️⃣0️⃣</h4>',
        '<h4>оц.TDC <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 3️⃣0️⃣</h4>',
        '<h4>оц.TDF <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 2️⃣0️⃣</h4>',
        '<h4>оц.TDF <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 3️⃣0️⃣</h4>',
        '<h4>TDC20 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> AISI430</h4>',
        '<h4>TDC20 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> AISI430</h4>',
        '<h4>TDC30 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> AISI430</h4>',
        '<h4>TDC30 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDC20 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDC20 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDC30 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDC30 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF20 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF20 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF30 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF30 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF20 AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF20 AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF30 AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF30 AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDF30 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш20/у65)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш30/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш15/у53)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш15/у60)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш30К/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 5х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 12.5х12.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Отбортовка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Отбортовка 15</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Отбортовка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Отбортовка 3️⃣0️⃣</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/раструб.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />➕Раструб мама</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/раструб.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />➖Раструб папа</h4>',
        '<h4><img title=\'Ниппель оцинкованный\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' class=\'scale\' style=\'width: 50px; height: auto;\' > оц.</h4>',
        '<h4><img title=\'Ниппель AISI304\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' class=\'scale\' style=\'width: 50px; height: auto;\' > AISI304</h4>',
        '<h4><img title=\'Ниппель AISI430\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' class=\'scale\' style=\'width: 50px; height: auto;\' > AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' class=\'scale\' style=\'width: 50px; height: auto;\' >Муфта оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' class=\'scale\' style=\'width: 50px; height: auto;\' >Муфта нерж.AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' class=\'scale\' style=\'width: 50px; height: auto;\' >Муфта нерж.AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/reika.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />Z-Рейка оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/reika.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />C-Рейка оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/reika.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />Рейка нерж.AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/reika.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />Рейка нерж.AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный Листовая сталь 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI430-ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI430-ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI430-ш30/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI304-ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI304-ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI304-ш30/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI430-ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI430-ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI430-ш30/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI304-ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI304-ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI304-ш30/у105</h4>',
    ],
    kflange: [
        '<h4>---</h4>',
        '<h4><img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange20.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />оц.ш30/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />TDC20 оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDC30 оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDF20 оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDF30 оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.ш20/у65)усил.саморез</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.ш20/у65)усил.заклепка</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.ш30/у105)усил.саморез</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.ш30/у105)усил.заклепка</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.ш20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.ш15/у53)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.ш15/у60)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.ш30К/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.шГерм.20/у65)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.шГерм.20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.шГерм.30/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.шГерм.15/у53)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.шГерм.15/у60)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />(оц.шГерм.30К/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDC20 AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDC30 AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDC20 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDC30 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDF20 AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDF30 AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDF20 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/TDC3.png\' style=\'width: 50px; height: auto;\' />TDF30 AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />свободный(оц.ш20/у65)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />свободный(оц.ш20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />свободный(оц.ш30/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />свободный(оц.ш15/у53)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />свободный(оц.ш15/у60)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' alt=\'12-2-1\' />свободный(оц.ш30К/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' style=\'width: 50px; height: auto;\' />Сетка 5х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 12.5х12.5</h4>',
        '<h4>Отбортовка 15</h4>',
        '<h4>Отбортовка 30</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/раструб.png\' style=\'width: 50px; height: auto;\' />Раструб мама</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/раструб.png\' style=\'width: 50px; height: auto;\' />Раструб папа</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' style=\'width: 50px; height: auto;\' >Ниппель оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' style=\'width: 50px; height: auto;\' >Ниппель нерж.AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' style=\'width: 50px; height: auto;\' >Ниппель нерж.AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' style=\'width: 50px; height: auto;\' >Муфта оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' style=\'width: 50px; height: auto;\' >Муфта нерж.AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-4.png\' style=\'width: 50px; height: auto;\' >Муфта нерж.AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/reika.png\' style=\'width: 100px; height: auto;\' />Рейка оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/reika.png\' style=\'width: 100px; height: auto;\' />Рейка нерж.AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/reika.png\' style=\'width: 100px; height: auto;\' />Рейка нерж.AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />(AISI430-ш20/у65)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />(AISI430-ш20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />(AISI430-ш30/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />(AISI304-ш20/у65)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />(AISI304-ш20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />(AISI304-ш30/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />свободный(AISI430-ш20/у65)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />свободный(AISI430-ш20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />свободный(AISI430-ш30/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />свободный(AISI304-ш20/у65)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />свободный(AISI304-ш20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' style=\'width: 50px; height: auto;\' />свободный(AISI304-ш30/у105)</h4>',
    ],
    blackflange: [
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Уголок 25х25х4',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Уголок 32х32х4',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Уголок 40х40х4',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Уголок 50х50х5',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Уголок 25х25х4',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Уголок 32х32х4',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Уголок 40х40х4',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Уголок 50х50х5',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.5',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Полоса 2.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Полоса 3.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Полоса 4.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец свободный углер.ст.Полоса 6.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.5',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Полоса 2.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Полоса 3.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Полоса 4.0',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' style=\'width: 100px; height: auto;\' />Фланец приварной углер.ст.Полоса 6.0',
        '---',
    ],
    otvodskos: [
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 12.5х12.5</h4>',
        '<h4>Решетка</h4>',
        '<h4>Решетка + Сетка 12.5х12.5</h4>',
        '<h4>Решетка + Сетка 5х5</h4>',
        '<h4><img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange20.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш30/у105</h4>',
        '<h4>---</h4>',
    ],
    zontosnastkakr: [
        '---',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 5х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 12.5х12.5</h4>',
    ],
    order: ['1', '2', '3', '4'],
    earth: ['---', '⏚'],
    HeatWaterType: ['R', 'L'],
    HeatType: ['Вода', 'Пропиленгликоль', 'Этиленгликоль', 'Пар', 'Масло'],
    LimitSwitch: ['---', 'Да'],
    tape: [
        '---',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Упаковка/Пленка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Пленка</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Упаковка/Пленка пузырьковая.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Пленка пузырьковая</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Упаковка/Картон.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Картон</h4>',
        'Обрешетка',
        '<input class=\'cb pristine\' type=\'checkbox\' checked>Бережная загрузка</input>',
    ],
    oilmotor: [
        '4',
        'Lukoil',
        'Castrol',
        'Country',
        'Elf',
        'EURONOL',
        'Fanfaro',
        'Felix',
        'Highway',
        'IDEMITSU',
        'Liqui Moly',
        'Lubex',
        'LUXE',
        'STANDART',
        'SUPER (полусинтетика)',
        'Mazda',
        'MITASU',
        'Mobil',
        'Motul',
        'Nissan',
        'NORD OIL',
        'ROLF',
        'Shell',
        'SINTEC',
        'TEBOIL',
        'Total',
        'ZIC',
        'Роснефть',
        'На ваш выбор',
    ],
    oilmotorcount: ['4', '1', 'Бочка', 'На розлив'],
    oilkpp: [
        '4',
        'Lukoil',
        'Castrol',
        'Country',
        'Elf',
        'EURONOL',
        'Fanfaro',
        'Felix',
        'Highway',
        'IDEMITSU',
        'Liqui Moly',
        'Lubex',
        'LUXE',
        'STANDART',
        'SUPER (полусинтетика)',
        'Mazda',
        'MITASU',
        'Mobil',
        'Motul',
        'Nissan',
        'NORD OIL',
        'ROLF',
        'Shell',
        'SINTEC',
        'TEBOIL',
        'Total',
        'ZIC',
        'Роснефть',
        'На ваш выбор',
    ],
    oilkppcount1: ['4', '1', 'Бочка', 'На розлив'],
    noise: ['---', 'Да'],
    flex: ['---', '2шт', '1шт'],
    rama: [
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\' checked> <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/rama.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> Рама</input>',
        'Оц.<img src=\'/wp-content/uploads/2022/03/кранштейн кондиционера.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H400❌L420➖30кг. Ral➖9003',
        'Оц.<img src=\'/wp-content/uploads/2022/03/кранштейн кондиционера.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H415❌L450➖50кг. Ral➖9003',
        'Оц.<img src=\'/wp-content/uploads/2022/03/кранштейн кондиционера.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H500❌L600➖100кг. Ral➖9003',
        'Оц.<img src=\'/wp-content/uploads/2022/03/Кранштейн кондиционера 1000х700.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H830❌L677➖150кг. Ral➖9003',
        'Оц.<img src=\'/wp-content/uploads/2022/03/Кранштейн кондиционера 1000х700.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H1000❌L700➖150кг. Ral➖9003',
    ],
    flexradial: [
        '---',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/flexradial.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>in➕out',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/flexradial-in.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>in',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/flexradial-out.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>out',
    ],
    springradial: [
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\' > 2️⃣шт</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' checked> 4️⃣шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' checked> <img src=\'/wp-content/uploads/2022/03/Кожух защитный.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Кожух защитный</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > 5️⃣шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > 6️⃣шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > 1️⃣шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > 3️⃣шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > 7️⃣шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > 8️⃣шт.</input>',
        'ДО 38 <img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 12,2Кг',
        'ДО 39 <img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 21,9Кг',
        'ДО 40 <img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 33,9Кг',
        'ДО 41 <img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 54Кг',
        'ДО 42 <img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 94,2Кг',
        'ДО 43 <img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 164,8Кг',
        'ДО 44 <img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 238,4Кг',
        'ДО 45 <img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 378,8Кг',
        'ДО 38 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/ДОСтальная пластина.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 12,2Кг',
        'ДО 39 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/ДОСтальная пластина.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 21,9Кг',
        'ДО 40 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/ДОСтальная пластина.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 33,9Кг',
        'ДО 41 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/ДОСтальная пластина.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 54Кг',
        'ДО 42 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/ДОСтальная пластина.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 94,2Кг',
        'ДО 43 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/ДОСтальная пластина.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 164,8Кг',
        'ДО 44 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/ДОСтальная пластина.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 238,4Кг',
        'ДО 45 <img src=\'/wp-content/themes/mesmerize-child/assets/img/Buttons/ДОСтальная пластина.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 378,8Кг',
        'ВР <img src=\'/wp-content/uploads/2022/03/cond/ВР201.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 201',
        'ВР <img src=\'/wp-content/uploads/2022/03/cond/ВР201.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 202',
        'ВР <img src=\'/wp-content/uploads/2022/03/cond/ВР201.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ',
    ],
    typeradial: [
        'Общего назначения',
        'Теплостойкое',
        'Коррозионностойкое ',
        'Коррозионностойкое теплостойкое',
        'Взрывозащищенное',
        'Взрывозащищенное теплостойкое',
        'Взрывозащищенное коррозионностойкое теплостойкое',
        'Взрывозащищенное коррозионностойкое',
        'Сейсмостойкое',
        'Дымоудаление 400°С',
        'Дымоудаление 600°С',
    ],
    direction: ['Левое', 'Правое', 'Не важно'],
    angleradial: ['0', '45', '90', '135', '270', '315'],
    'Исполнение': ['---', 'Внутреннее', 'Наружное'],
    'ТипУстановки': [
        '---', 'Приточная',
        'Вытяжная',
        'Приточно-вытяжная',
        'Вертикальная',
        'Горизонтальная',
    ],
    'ВоздухопроизводительностьIN': ['---', '100', '500', '1000', '5000', '10000', '15000'],
    'ВоздухопроизводительностьOUT': ['---', '100', '500', '1000', '5000', '10000', '15000'],
    'РасполагаемыйНапорIN': ['---', '100', '1000'],
    'РасполагаемыйНапорOUT': ['---', '100', '1000'],
    WinterIN: ['---', 'Внутреннее', 'Наружное'],
    WinterOUT: ['---', 'Внутреннее', 'Наружное'],
    SummerIN: ['---', 'Внутреннее', 'Наружное'],
    SummerOUT: ['---', 'Внутреннее', 'Наружное'],
    FilterInOne: ['---', 'Внутреннее', 'Наружное'],
    FilterInTwo: ['---', 'Внутреннее', 'Наружное'],
    FilterOutOne: ['---', 'Внутреннее', 'Наружное'],
    HeatOneEl: ['---', 'Внутреннее', 'Наружное'],
    HeatOneW: ['---', 'Внутреннее', 'Наружное'],
    HeatTwoEl: ['---', 'Внутреннее', 'Наружное'],
    HeatTwoW: ['---', 'Внутреннее', 'Наружное'],
    CoolW: ['---', 'Внутреннее', 'Наружное'],
    CoolForane: ['---', 'Внутреннее', 'Наружное'],
    Humi: ['---', 'Внутреннее', 'Наружное', 'Наружное'],
    ThermoUtil: ['---', 'Внутреннее', 'Наружное', 'Наружное'],
    VentDrive: ['---', 'Клиноременная передача', 'Прямой привод', 'Прямоточный(Plug Fan)', 'Односкоростной', 'Двухскоростной', 'Многоскоростной', 'Плавное регулирование'],
    Option: ['---', 'Шумоглушитель', 'Клапан', 'Гибкие вставки'],
    SpecialDim: ['---', 'Шумоглушитель', 'Клапан', 'Гибкие вставки'],
    Automatic: ['---', 'Встроенная', 'Modbus'],
    crate: ['---', 'Да'],
    frompoint: [
        'Томск',
        'Абаза',
        'Абакан',
        'Абдулино',
        'Абинск',
        'Агидель',
        'Агрыз',
        'Адыгейск',
        'Азнакаево',
        'Азов',
        'Ак-Довурак',
        'Аксай',
        'Алагир',
        'Алапаевск',
        'Алатырь',
        'Алдан',
        'Алейск',
        'Александров',
        'Александровск',
        'Александровск-Сахалинский',
        'Алексеевка',
        'Алексин',
        'Алзамай',
        'Алупка',
        'Алушта',
        'Альметьевск',
        'Амурск',
        'Анадырь',
        'Анапа',
        'Ангарск',
        'Андреаполь',
        'Анжеро-Судженск',
        'Анива',
        'Апатиты',
        'Апрелевка',
        'Апшеронск',
        'Арамиль',
        'Аргун',
        'Ардатов',
        'Ардон',
        'Арзамас',
        'Аркадак',
        'Армавир',
        'Армянск',
        'Арсеньев',
        'Арск',
        'Артём',
        'Артёмовск',
        'Артёмовский',
        'Архангельск',
        'Асбест',
        'Асино',
        'Астрахань',
        'Аткарск',
        'Ахтубинск',
        'Ачинск',
        'Аша',
        'Бабаево',
        'Бабушкин',
        'Бавлы',
        'Багратионовск',
        'Байкальск',
        'Баймак',
        'Бакал',
        'Баксан',
        'Балабаново',
        'Балаково',
        'Балахна',
        'Балашиха',
        'Балашов',
        'Балей',
        'Балтийск',
        'Барабинск',
        'Барнаул',
        'Барыш',
        'Батайск',
        'Бахчисарай',
        'Бежецк',
        'Белая Калитва',
        'Белая Холуница',
        'Белгород',
        'Белебей',
        'Белёв',
        'Белинский',
        'Белово',
        'Белогорск',
        'Белогорск',
        'Белозерск',
        'Белокуриха',
        'Беломорск',
        'Белоозёрский',
        'Белорецк',
        'Белореченск',
        'Белоусово',
        'Белоярский',
        'Белый',
        'Бердск',
        'Березники',
        'Берёзовский',
        'Берёзовский',
        'Беслан',
        'Бийск',
        'Бикин',
        'Билибино',
        'Биробиджан',
        'Бирск',
        'Бирюсинск',
        'Бирюч',
        'Благовещенск',
        'Благовещенск',
        'Благодарный',
        'Бобров',
        'Богданович',
        'Богородицк',
        'Богородск',
        'Боготол',
        'Богучар',
        'Бодайбо',
        'Бокситогорск',
        'Болгар',
        'Бологое',
        'Болотное',
        'Болохово',
        'Болхов',
        'Большой Камень',
        'Бор',
        'Борзя',
        'Борисоглебск',
        'Боровичи',
        'Боровск',
        'Бородино',
        'Братск',
        'Бронницы',
        'Брянск',
        'Бугульма',
        'Бугуруслан',
        'Будённовск',
        'Бузулук',
        'Буинск',
        'Буй',
        'Буйнакск',
        'Бутурлиновка',
        'Валдай',
        'Валуйки',
        'Велиж',
        'Великие Луки',
        'Великий Новгород',
        'Великий Устюг',
        'Вельск',
        'Венёв',
        'Верещагино',
        'Верея',
        'Верхнеуральск',
        'Верхний Тагил',
        'Верхний Уфалей',
        'Верхняя Пышма',
        'Верхняя Салда',
        'Верхняя Тура',
        'Верхотурье',
        'Верхоянск',
        'Весьегонск',
        'Ветлуга',
        'Видное',
        'Вилюйск',
        'Вилючинск',
        'Вихоревка',
        'Вичуга',
        'Владивосток',
        'Владикавказ',
        'Владимир',
        'Волгоград',
        'Волгодонск',
        'Волгореченск',
        'Волжск',
        'Волжский',
        'Вологда',
        'Володарск',
        'Волоколамск',
        'Волосово',
        'Волхов',
        'Волчанск',
        'Вольск',
        'Воркута',
        'Воронеж',
        'Ворсма',
        'Воскресенск',
        'Воткинск',
        'Всеволожск',
        'Вуктыл',
        'Выборг',
        'Выкса',
        'Высоковск',
        'Высоцк',
        'Вытегра',
        'Вышний Волочёк',
        'Вяземский',
        'Вязники',
        'Вязьма',
        'Вятские Поляны',
        'Гаврилов Посад',
        'Гаврилов-Ям',
        'Гагарин',
        'Гаджиево',
        'Гай',
        'Галич',
        'Гатчина',
        'Гвардейск',
        'Гдов',
        'Геленджик',
        'Георгиевск',
        'Глазов',
        'Голицыно',
        'Горбатов',
        'Горно-Алтайск',
        'Горнозаводск',
        'Горняк',
        'Городец',
        'Городище',
        'Городовиковск',
        'Гороховец',
        'Горячий Ключ',
        'Грайворон',
        'Гремячинск',
        'Грозный',
        'Грязи',
        'Грязовец',
        'Губаха',
        'Губкин',
        'Губкинский',
        'Гудермес',
        'Гуково',
        'Гулькевичи',
        'Гурьевск',
        'Гурьевск',
        'Гусев',
        'Гусиноозёрск',
        'Гусь-Хрустальный',
        'Давлеканово',
        'Дагестанские Огни',
        'Далматово',
        'Дальнегорск',
        'Дальнереченск',
        'Данилов',
        'Данков',
        'Дегтярск',
        'Дедовск',
        'Демидов',
        'Дербент',
        'Десногорск',
        'Джанкой',
        'Дзержинск',
        'Дзержинский',
        'Дивногорск',
        'Дигора',
        'Димитровград',
        'Дмитриев',
        'Дмитров',
        'Дмитровск',
        'Дно',
        'Добрянка',
        'Долгопрудный',
        'Долинск',
        'Домодедово',
        'Донецк',
        'Донской',
        'Дорогобуж',
        'Дрезна',
        'Дубна',
        'Дубовка',
        'Дудинка',
        'Духовщина',
        'Дюртюли',
        'Дятьково',
        'Евпатория',
        'Егорьевск',
        'Ейск',
        'Екатеринбург',
        'Елабуга',
        'Елец',
        'Елизово',
        'Ельня',
        'Еманжелинск',
        'Емва',
        'Енисейск',
        'Ермолино',
        'Ершов',
        'Ессентуки',
        'Ефремов',
        'Железноводск',
        'Железногорск',
        'Железногорск',
        'Железногорск-Илимский',
        'Жердевка',
        'Жигулёвск',
        'Жиздра',
        'Жирновск',
        'Жуков',
        'Жуковка',
        'Жуковский',
        'Завитинск',
        'Заводоуковск',
        'Заволжск',
        'Заволжье',
        'Задонск',
        'Заинск',
        'Закаменск',
        'Заозёрный',
        'Заозёрск',
        'Западная Двина',
        'Заполярный',
        'Зарайск',
        'Заречный',
        'Заречный',
        'Заринск',
        'Звенигово',
        'Звенигород',
        'Зверево',
        'Зеленогорск',
        'Зеленоградск',
        'Зеленодольск',
        'Зеленокумск',
        'Зерноград',
        'Зея',
        'Зима',
        'Златоуст',
        'Злынка',
        'Змеиногорск',
        'Знаменск',
        'Зубцов',
        'Зуевка',
        'Ивангород',
        'Иваново',
        'Ивантеевка',
        'Ивдель',
        'Игарка',
        'Ижевск',
        'Избербаш',
        'Изобильный',
        'Иланский',
        'Инза',
        'Иннополис',
        'Инсар',
        'Инта',
        'Ипатово',
        'Ирбит',
        'Иркутск',
        'Исилькуль',
        'Искитим',
        'Истра',
        'Ишим',
        'Ишимбай',
        'Йошкар-Ола',
        'Кадников',
        'Казань',
        'Калач',
        'Калач-на-Дону',
        'Калачинск',
        'Калининград',
        'Калининск',
        'Калтан',
        'Калуга',
        'Калязин',
        'Камбарка',
        'Каменка',
        'Каменногорск',
        'Каменск-Уральский',
        'Каменск-Шахтинский',
        'Камень-на-Оби',
        'Камешково',
        'Камызяк',
        'Камышин',
        'Камышлов',
        'Канаш',
        'Кандалакша',
        'Канск',
        'Карабаново',
        'Карабаш',
        'Карабулак',
        'Карасук',
        'Карачаевск',
        'Карачев',
        'Каргат',
        'Каргополь',
        'Карпинск',
        'Карталы',
        'Касимов',
        'Касли',
        'Каспийск',
        'Катав-Ивановск',
        'Катайск',
        'Качканар',
        'Кашин',
        'Кашира',
        'Кедровый',
        'Кемерово',
        'Кемь',
        'Керчь',
        'Кизел',
        'Кизилюрт',
        'Кизляр',
        'Кимовск',
        'Кимры',
        'Кингисепп',
        'Кинель',
        'Кинешма',
        'Киреевск',
        'Киренск',
        'Киржач',
        'Кириллов',
        'Кириши',
        'Киров',
        'Киров',
        'Кировград',
        'Кирово-Чепецк',
        'Кировск',
        'Кировск',
        'Кирс',
        'Кирсанов',
        'Киселёвск',
        'Кисловодск',
        'Клин',
        'Клинцы',
        'Княгинино',
        'Ковдор',
        'Ковров',
        'Ковылкино',
        'Когалым',
        'Кодинск',
        'Козельск',
        'Козловка',
        'Козьмодемьянск',
        'Кола',
        'Кологрив',
        'Коломна',
        'Колпашево',
        'Кольчугино',
        'Коммунар',
        'Комсомольск',
        'Комсомольск-на-Амуре',
        'Конаково',
        'Кондопога',
        'Кондрово',
        'Константиновск',
        'Копейск',
        'Кораблино',
        'Кореновск',
        'Коркино',
        'Королёв',
        'Короча',
        'Корсаков',
        'Коряжма',
        'Костерёво',
        'Костомукша',
        'Кострома',
        'Котельники',
        'Котельниково',
        'Котельнич',
        'Котлас',
        'Котово',
        'Котовск',
        'Кохма',
        'Красавино',
        'Красноармейск',
        'Красноармейск',
        'Красновишерск',
        'Красногорск',
        'Краснодар',
        'Краснозаводск',
        'Краснознаменск',
        'Краснознаменск',
        'Краснокаменск',
        'Краснокамск',
        'Красноперекопск',
        'Краснослободск',
        'Краснослободск',
        'Краснотурьинск',
        'Красноуральск',
        'Красноуфимск',
        'Красноярск',
        'Красный Кут',
        'Красный Сулин',
        'Красный Холм',
        'Кремёнки',
        'Кропоткин',
        'Крымск',
        'Кстово',
        'Кубинка',
        'Кувандык',
        'Кувшиново',
        'Кудрово',
        'Кудымкар',
        'Кузнецк',
        'Куйбышев',
        'Кукмор',
        'Кулебаки',
        'Кумертау',
        'Кунгур',
        'Купино',
        'Курган',
        'Курганинск',
        'Курильск',
        'Курлово',
        'Куровское',
        'Курск',
        'Куртамыш',
        'Курчалой',
        'Курчатов',
        'Куса',
        'Кушва',
        'Кызыл',
        'Кыштым',
        'Кяхта',
        'Лабинск',
        'Лабытнанги',
        'Лагань',
        'Ладушкин',
        'Лаишево',
        'Лакинск',
        'Лангепас',
        'Лахденпохья',
        'Лебедянь',
        'Лениногорск',
        'Ленинск',
        'Ленинск-Кузнецкий',
        'Ленск',
        'Лермонтов',
        'Лесной',
        'Лесозаводск',
        'Лесосибирск',
        'Ливны',
        'Ликино-Дулёво',
        'Липецк',
        'Липки',
        'Лиски',
        'Лихославль',
        'Лобня',
        'Лодейное Поле',
        'Лосино-Петровский',
        'Луга',
        'Луза',
        'Лукоянов',
        'Луховицы',
        'Лысково',
        'Лысьва',
        'Лыткарино',
        'Льгов',
        'Любань',
        'Люберцы',
        'Любим',
        'Людиново',
        'Лянтор',
        'Магадан',
        'Магас',
        'Магнитогорск',
        'Майкоп',
        'Майский',
        'Макаров',
        'Макарьев',
        'Макушино',
        'Малая Вишера',
        'Малгобек',
        'Малмыж',
        'Малоархангельск',
        'Малоярославец',
        'Мамадыш',
        'Мамоново',
        'Мантурово',
        'Мариинск',
        'Мариинский Посад',
        'Маркс',
        'Махачкала',
        'Мглин',
        'Мегион',
        'Медвежьегорск',
        'Медногорск',
        'Медынь',
        'Межгорье',
        'Междуреченск',
        'Мезень',
        'Меленки',
        'Мелеуз',
        'Менделеевск',
        'Мензелинск',
        'Мещовск',
        'Миасс',
        'Микунь',
        'Миллерово',
        'Минеральные Воды',
        'Минусинск',
        'Миньяр',
        'Мирный',
        'Мирный',
        'Михайлов',
        'Михайловка',
        'Михайловск',
        'Михайловск',
        'Мичуринск',
        'Могоча',
        'Можайск',
        'Можга',
        'Моздок',
        'Мончегорск',
        'Морозовск',
        'Моршанск',
        'Мосальск',
        'Москва',
        'Муравленко',
        'Мураши',
        'Мурино',
        'Мурманск',
        'Муром',
        'Мценск',
        'Мыски',
        'Мытищи',
        'Мышкин',
        'Набережные Челны',
        'Навашино',
        'Наволоки',
        'Надым',
        'Назарово',
        'Назрань',
        'Называевск',
        'Нальчик',
        'Нариманов',
        'Наро-Фоминск',
        'Нарткала',
        'Нарьян-Мар',
        'Находка',
        'Невель',
        'Невельск',
        'Невинномысск',
        'Невьянск',
        'Нелидово',
        'Неман',
        'Нерехта',
        'Нерчинск',
        'Нерюнгри',
        'Нестеров',
        'Нефтегорск',
        'Нефтекамск',
        'Нефтекумск',
        'Нефтеюганск',
        'Нея',
        'Нижневартовск',
        'Нижнекамск',
        'Нижнеудинск',
        'Нижние Серги',
        'Нижний Ломов',
        'Нижний Новгород',
        'Нижний Тагил',
        'Нижняя Салда',
        'Нижняя Тура',
        'Николаевск',
        'Николаевск-на-Амуре',
        'Никольск',
        'Никольск',
        'Никольское',
        'Новая Ладога',
        'Новая Ляля',
        'Новоалександровск',
        'Новоалтайск',
        'Новоаннинский',
        'Нововоронеж',
        'Новодвинск',
        'Новозыбков',
        'Новокубанск',
        'Новокузнецк',
        'Новокуйбышевск',
        'Новомичуринск',
        'Новомосковск',
        'Новопавловск',
        'Новоржев',
        'Новороссийск',
        'Новосибирск',
        'Новосиль',
        'Новосокольники',
        'Новотроицк',
        'Новоузенск',
        'Новоульяновск',
        'Новоуральск',
        'Новохопёрск',
        'Новочебоксарск',
        'Новочеркасск',
        'Новошахтинск',
        'Новый Оскол',
        'Новый Уренгой',
        'Ногинск',
        'Нолинск',
        'Норильск',
        'Ноябрьск',
        'Нурлат',
        'Нытва',
        'Нюрба',
        'Нягань',
        'Нязепетровск',
        'Няндома',
        'Облучье',
        'Обнинск',
        'Обоянь',
        'Обь',
        'Одинцово',
        'Озёрск',
        'Озёрск',
        'Озёры',
        'Октябрьск',
        'Октябрьский',
        'Окуловка',
        'Олёкминск',
        'Оленегорск',
        'Олонец',
        'Омск',
        'Омутнинск',
        'Онега',
        'Опочка',
        'Орёл',
        'Оренбург',
        'Орехово-Зуево',
        'Орлов',
        'Орск',
        'Оса',
        'Осинники',
        'Осташков',
        'Остров',
        'Островной',
        'Острогожск',
        'Отрадное',
        'Отрадный',
        'Оха',
        'Оханск',
        'Очёр',
        'Павлово',
        'Павловск',
        'Павловский Посад',
        'Палласовка',
        'Партизанск',
        'Певек',
        'Пенза',
        'Первомайск',
        'Первоуральск',
        'Перевоз',
        'Пересвет',
        'Переславль-Залесский',
        'Пермь',
        'Пестово',
        'Петров Вал',
        'Петровск',
        'Петровск-Забайкальский',
        'Петрозаводск',
        'Петропавловск-Камчатский',
        'Петухово',
        'Петушки',
        'Печора',
        'Пикалёво',
        'Пионерский',
        'Питкяранта',
        'Плавск',
        'Пласт',
        'Плёс',
        'Поворино',
        'Подольск',
        'Подпорожье',
        'Покачи',
        'Покров',
        'Покровск',
        'Полевской',
        'Полесск',
        'Полысаево',
        'Полярные Зори',
        'Полярный',
        'Поронайск',
        'Порхов',
        'Похвистнево',
        'Почеп',
        'Починок',
        'Пошехонье',
        'Правдинск',
        'Приволжск',
        'Приморск',
        'Приморск',
        'Приморско-Ахтарск',
        'Приозерск',
        'Прокопьевск',
        'Пролетарск',
        'Протвино',
        'Прохладный',
        'Псков',
        'Пугачёв',
        'Пудож',
        'Пустошка',
        'Пучеж',
        'Пушкино',
        'Пущино',
        'Пыталово',
        'Пыть-Ях',
        'Пятигорск',
        'Радужный',
        'Радужный',
        'Райчихинск',
        'Раменское',
        'Рассказово',
        'Ревда',
        'Реж',
        'Реутов',
        'Ржев',
        'Родники',
        'Рославль',
        'Россошь',
        'Ростов',
        'Ростов-на-Дону',
        'Рошаль',
        'Ртищево',
        'Рубцовск',
        'Рудня',
        'Руза',
        'Рузаевка',
        'Рыбинск',
        'Рыбное',
        'Рыльск',
        'Ряжск',
        'Рязань',
        'Саки',
        'Салават',
        'Салаир',
        'Салехард',
        'Сальск',
        'Самара',
        'Санкт-Петербург',
        'Саранск',
        'Сарапул',
        'Саратов',
        'Саров',
        'Сасово',
        'Сатка',
        'Сафоново',
        'Саяногорск',
        'Саянск',
        'Светлогорск',
        'Светлоград',
        'Светлый',
        'Светогорск',
        'Свирск',
        'Свободный',
        'Себеж',
        'Севастополь',
        'Северо-Курильск',
        'Северобайкальск',
        'Северодвинск',
        'Североморск',
        'Североуральск',
        'Северск',
        'Севск',
        'Сегежа',
        'Сельцо',
        'Семёнов',
        'Семикаракорск',
        'Семилуки',
        'Сенгилей',
        'Серафимович',
        'Сергач',
        'Сергиев Посад',
        'Сердобск',
        'Серов',
        'Серпухов',
        'Сертолово',
        'Сибай',
        'Сим',
        'Симферополь',
        'Сковородино',
        'Скопин',
        'Славгород',
        'Славск',
        'Славянск-на-Кубани',
        'Сланцы',
        'Слободской',
        'Слюдянка',
        'Смоленск',
        'Снежинск',
        'Снежногорск',
        'Собинка',
        'Советск',
        'Советск',
        'Советск',
        'Советская Гавань',
        'Советский',
        'Сокол',
        'Солигалич',
        'Соликамск',
        'Солнечногорск',
        'Соль-Илецк',
        'Сольвычегодск',
        'Сольцы',
        'Сорочинск',
        'Сорск',
        'Сортавала',
        'Сосенский',
        'Сосновка',
        'Сосновоборск',
        'Сосновый Бор',
        'Сосногорск',
        'Сочи',
        'Спас-Деменск',
        'Спас-Клепики',
        'Спасск',
        'Спасск-Дальний',
        'Спасск-Рязанский',
        'Среднеколымск',
        'Среднеуральск',
        'Сретенск',
        'Ставрополь',
        'Старая Купавна',
        'Старая Русса',
        'Старица',
        'Стародуб',
        'Старый Крым',
        'Старый Оскол',
        'Стерлитамак',
        'Стрежевой',
        'Строитель',
        'Струнино',
        'Ступино',
        'Суворов',
        'Судак',
        'Суджа',
        'Судогда',
        'Суздаль',
        'Сунжа',
        'Суоярви',
        'Сураж',
        'Сургут',
        'Суровикино',
        'Сурск',
        'Сусуман',
        'Сухиничи',
        'Сухой Лог',
        'Сызрань',
        'Сыктывкар',
        'Сысерть',
        'Сычёвка',
        'Сясьстрой',
        'Тавда',
        'Таганрог',
        'Тайга',
        'Тайшет',
        'Талдом',
        'Талица',
        'Тамбов',
        'Тара',
        'Тарко-Сале',
        'Таруса',
        'Татарск',
        'Таштагол',
        'Тверь',
        'Теберда',
        'Тейково',
        'Темников',
        'Темрюк',
        'Терек',
        'Тетюши',
        'Тимашёвск',
        'Тихвин',
        'Тихорецк',
        'Тобольск',
        'Тогучин',
        'Тольятти',
        'Томари',
        'Томмот',
        'Топки',
        'Торжок',
        'Торопец',
        'Тосно',
        'Тотьма',
        'Трёхгорный',
        'Троицк',
        'Трубчевск',
        'Туапсе',
        'Туймазы',
        'Тула',
        'Тулун',
        'Туран',
        'Туринск',
        'Тутаев',
        'Тында',
        'Тырныауз',
        'Тюкалинск',
        'Тюмень',
        'Уварово',
        'Углегорск',
        'Углич',
        'Удачный',
        'Удомля',
        'Ужур',
        'Узловая',
        'Улан-Удэ',
        'Ульяновск',
        'Унеча',
        'Урай',
        'Урень',
        'Уржум',
        'Урус-Мартан',
        'Урюпинск',
        'Усинск',
        'Усмань',
        'Усолье',
        'Усолье-Сибирское',
        'Уссурийск',
        'Усть-Джегута',
        'Усть-Илимск',
        'Усть-Катав',
        'Усть-Кут',
        'Усть-Лабинск',
        'Устюжна',
        'Уфа',
        'Ухта',
        'Учалы',
        'Уяр',
        'Фатеж',
        'Феодосия',
        'Фокино',
        'Фокино',
        'Фролово',
        'Фрязино',
        'Фурманов',
        'Хабаровск',
        'Хадыженск',
        'Ханты-Мансийск',
        'Харабали',
        'Харовск',
        'Хасавюрт',
        'Хвалынск',
        'Хилок',
        'Химки',
        'Холм',
        'Холмск',
        'Хотьково',
        'Цивильск',
        'Цимлянск',
        'Циолковский',
        'Чадан',
        'Чайковский',
        'Чапаевск',
        'Чаплыгин',
        'Чебаркуль',
        'Чебоксары',
        'Чегем',
        'Чекалин',
        'Челябинск',
        'Чердынь',
        'Черемхово',
        'Черепаново',
        'Череповец',
        'Черкесск',
        'Чёрмоз',
        'Черноголовка',
        'Черногорск',
        'Чернушка',
        'Черняховск',
        'Чехов',
        'Чистополь',
        'Чита',
        'Чкаловск',
        'Чудово',
        'Чулым',
        'Чусовой',
        'Чухлома',
        'Шагонар',
        'Шадринск',
        'Шали',
        'Шарыпово',
        'Шарья',
        'Шатура',
        'Шахты',
        'Шахунья',
        'Шацк',
        'Шебекино',
        'Шелехов',
        'Шенкурск',
        'Шилка',
        'Шимановск',
        'Шиханы',
        'Шлиссельбург',
        'Шумерля',
        'Шумиха',
        'Шуя',
        'Щёкино',
        'Щёлкино',
        'Щёлково',
        'Щигры',
        'Щучье',
        'Электрогорск',
        'Электросталь',
        'Электроугли',
        'Элиста',
        'Энгельс',
        'Эртиль',
        'Югорск',
        'Южа',
        'Южно-Сахалинск',
        'Южно-Сухокумск',
        'Южноуральск',
        'Юрга',
        'Юрьев-Польский',
        'Юрьевец',
        'Юрюзань',
        'Юхнов',
        'Ядрин',
        'Якутск',
        'Ялта',
        'Ялуторовск',
        'Янаул',
        'Яранск',
        'Яровое',
        'Ярославль',
        'Ярцево',
        'Ясногорск',
        'Ясный',
        'Яхрома',
    ],
    topoint: [
        'Томск',
        'Абаза',
        'Абакан',
        'Абдулино',
        'Абинск',
        'Агидель',
        'Агрыз',
        'Адыгейск',
        'Азнакаево',
        'Азов',
        'Ак-Довурак',
        'Аксай',
        'Алагир',
        'Алапаевск',
        'Алатырь',
        'Алдан',
        'Алейск',
        'Александров',
        'Александровск',
        'Александровск-Сахалинский',
        'Алексеевка',
        'Алексин',
        'Алзамай',
        'Алупка',
        'Алушта',
        'Альметьевск',
        'Амурск',
        'Анадырь',
        'Анапа',
        'Ангарск',
        'Андреаполь',
        'Анжеро-Судженск',
        'Анива',
        'Апатиты',
        'Апрелевка',
        'Апшеронск',
        'Арамиль',
        'Аргун',
        'Ардатов',
        'Ардон',
        'Арзамас',
        'Аркадак',
        'Армавир',
        'Армянск',
        'Арсеньев',
        'Арск',
        'Артём',
        'Артёмовск',
        'Артёмовский',
        'Архангельск',
        'Асбест',
        'Асино',
        'Астрахань',
        'Аткарск',
        'Ахтубинск',
        'Ачинск',
        'Аша',
        'Бабаево',
        'Бабушкин',
        'Бавлы',
        'Багратионовск',
        'Байкальск',
        'Баймак',
        'Бакал',
        'Баксан',
        'Балабаново',
        'Балаково',
        'Балахна',
        'Балашиха',
        'Балашов',
        'Балей',
        'Балтийск',
        'Барабинск',
        'Барнаул',
        'Барыш',
        'Батайск',
        'Бахчисарай',
        'Бежецк',
        'Белая Калитва',
        'Белая Холуница',
        'Белгород',
        'Белебей',
        'Белёв',
        'Белинский',
        'Белово',
        'Белогорск',
        'Белогорск',
        'Белозерск',
        'Белокуриха',
        'Беломорск',
        'Белоозёрский',
        'Белорецк',
        'Белореченск',
        'Белоусово',
        'Белоярский',
        'Белый',
        'Бердск',
        'Березники',
        'Берёзовский',
        'Берёзовский',
        'Беслан',
        'Бийск',
        'Бикин',
        'Билибино',
        'Биробиджан',
        'Бирск',
        'Бирюсинск',
        'Бирюч',
        'Благовещенск',
        'Благовещенск',
        'Благодарный',
        'Бобров',
        'Богданович',
        'Богородицк',
        'Богородск',
        'Боготол',
        'Богучар',
        'Бодайбо',
        'Бокситогорск',
        'Болгар',
        'Бологое',
        'Болотное',
        'Болохово',
        'Болхов',
        'Большой Камень',
        'Бор',
        'Борзя',
        'Борисоглебск',
        'Боровичи',
        'Боровск',
        'Бородино',
        'Братск',
        'Бронницы',
        'Брянск',
        'Бугульма',
        'Бугуруслан',
        'Будённовск',
        'Бузулук',
        'Буинск',
        'Буй',
        'Буйнакск',
        'Бутурлиновка',
        'Валдай',
        'Валуйки',
        'Велиж',
        'Великие Луки',
        'Великий Новгород',
        'Великий Устюг',
        'Вельск',
        'Венёв',
        'Верещагино',
        'Верея',
        'Верхнеуральск',
        'Верхний Тагил',
        'Верхний Уфалей',
        'Верхняя Пышма',
        'Верхняя Салда',
        'Верхняя Тура',
        'Верхотурье',
        'Верхоянск',
        'Весьегонск',
        'Ветлуга',
        'Видное',
        'Вилюйск',
        'Вилючинск',
        'Вихоревка',
        'Вичуга',
        'Владивосток',
        'Владикавказ',
        'Владимир',
        'Волгоград',
        'Волгодонск',
        'Волгореченск',
        'Волжск',
        'Волжский',
        'Вологда',
        'Володарск',
        'Волоколамск',
        'Волосово',
        'Волхов',
        'Волчанск',
        'Вольск',
        'Воркута',
        'Воронеж',
        'Ворсма',
        'Воскресенск',
        'Воткинск',
        'Всеволожск',
        'Вуктыл',
        'Выборг',
        'Выкса',
        'Высоковск',
        'Высоцк',
        'Вытегра',
        'Вышний Волочёк',
        'Вяземский',
        'Вязники',
        'Вязьма',
        'Вятские Поляны',
        'Гаврилов Посад',
        'Гаврилов-Ям',
        'Гагарин',
        'Гаджиево',
        'Гай',
        'Галич',
        'Гатчина',
        'Гвардейск',
        'Гдов',
        'Геленджик',
        'Георгиевск',
        'Глазов',
        'Голицыно',
        'Горбатов',
        'Горно-Алтайск',
        'Горнозаводск',
        'Горняк',
        'Городец',
        'Городище',
        'Городовиковск',
        'Гороховец',
        'Горячий Ключ',
        'Грайворон',
        'Гремячинск',
        'Грозный',
        'Грязи',
        'Грязовец',
        'Губаха',
        'Губкин',
        'Губкинский',
        'Гудермес',
        'Гуково',
        'Гулькевичи',
        'Гурьевск',
        'Гурьевск',
        'Гусев',
        'Гусиноозёрск',
        'Гусь-Хрустальный',
        'Давлеканово',
        'Дагестанские Огни',
        'Далматово',
        'Дальнегорск',
        'Дальнереченск',
        'Данилов',
        'Данков',
        'Дегтярск',
        'Дедовск',
        'Демидов',
        'Дербент',
        'Десногорск',
        'Джанкой',
        'Дзержинск',
        'Дзержинский',
        'Дивногорск',
        'Дигора',
        'Димитровград',
        'Дмитриев',
        'Дмитров',
        'Дмитровск',
        'Дно',
        'Добрянка',
        'Долгопрудный',
        'Долинск',
        'Домодедово',
        'Донецк',
        'Донской',
        'Дорогобуж',
        'Дрезна',
        'Дубна',
        'Дубовка',
        'Дудинка',
        'Духовщина',
        'Дюртюли',
        'Дятьково',
        'Евпатория',
        'Егорьевск',
        'Ейск',
        'Екатеринбург',
        'Елабуга',
        'Елец',
        'Елизово',
        'Ельня',
        'Еманжелинск',
        'Емва',
        'Енисейск',
        'Ермолино',
        'Ершов',
        'Ессентуки',
        'Ефремов',
        'Железноводск',
        'Железногорск',
        'Железногорск',
        'Железногорск-Илимский',
        'Жердевка',
        'Жигулёвск',
        'Жиздра',
        'Жирновск',
        'Жуков',
        'Жуковка',
        'Жуковский',
        'Завитинск',
        'Заводоуковск',
        'Заволжск',
        'Заволжье',
        'Задонск',
        'Заинск',
        'Закаменск',
        'Заозёрный',
        'Заозёрск',
        'Западная Двина',
        'Заполярный',
        'Зарайск',
        'Заречный',
        'Заречный',
        'Заринск',
        'Звенигово',
        'Звенигород',
        'Зверево',
        'Зеленогорск',
        'Зеленоградск',
        'Зеленодольск',
        'Зеленокумск',
        'Зерноград',
        'Зея',
        'Зима',
        'Златоуст',
        'Злынка',
        'Змеиногорск',
        'Знаменск',
        'Зубцов',
        'Зуевка',
        'Ивангород',
        'Иваново',
        'Ивантеевка',
        'Ивдель',
        'Игарка',
        'Ижевск',
        'Избербаш',
        'Изобильный',
        'Иланский',
        'Инза',
        'Иннополис',
        'Инсар',
        'Инта',
        'Ипатово',
        'Ирбит',
        'Иркутск',
        'Исилькуль',
        'Искитим',
        'Истра',
        'Ишим',
        'Ишимбай',
        'Йошкар-Ола',
        'Кадников',
        'Казань',
        'Калач',
        'Калач-на-Дону',
        'Калачинск',
        'Калининград',
        'Калининск',
        'Калтан',
        'Калуга',
        'Калязин',
        'Камбарка',
        'Каменка',
        'Каменногорск',
        'Каменск-Уральский',
        'Каменск-Шахтинский',
        'Камень-на-Оби',
        'Камешково',
        'Камызяк',
        'Камышин',
        'Камышлов',
        'Канаш',
        'Кандалакша',
        'Канск',
        'Карабаново',
        'Карабаш',
        'Карабулак',
        'Карасук',
        'Карачаевск',
        'Карачев',
        'Каргат',
        'Каргополь',
        'Карпинск',
        'Карталы',
        'Касимов',
        'Касли',
        'Каспийск',
        'Катав-Ивановск',
        'Катайск',
        'Качканар',
        'Кашин',
        'Кашира',
        'Кедровый',
        'Кемерово',
        'Кемь',
        'Керчь',
        'Кизел',
        'Кизилюрт',
        'Кизляр',
        'Кимовск',
        'Кимры',
        'Кингисепп',
        'Кинель',
        'Кинешма',
        'Киреевск',
        'Киренск',
        'Киржач',
        'Кириллов',
        'Кириши',
        'Киров',
        'Киров',
        'Кировград',
        'Кирово-Чепецк',
        'Кировск',
        'Кировск',
        'Кирс',
        'Кирсанов',
        'Киселёвск',
        'Кисловодск',
        'Клин',
        'Клинцы',
        'Княгинино',
        'Ковдор',
        'Ковров',
        'Ковылкино',
        'Когалым',
        'Кодинск',
        'Козельск',
        'Козловка',
        'Козьмодемьянск',
        'Кола',
        'Кологрив',
        'Коломна',
        'Колпашево',
        'Кольчугино',
        'Коммунар',
        'Комсомольск',
        'Комсомольск-на-Амуре',
        'Конаково',
        'Кондопога',
        'Кондрово',
        'Константиновск',
        'Копейск',
        'Кораблино',
        'Кореновск',
        'Коркино',
        'Королёв',
        'Короча',
        'Корсаков',
        'Коряжма',
        'Костерёво',
        'Костомукша',
        'Кострома',
        'Котельники',
        'Котельниково',
        'Котельнич',
        'Котлас',
        'Котово',
        'Котовск',
        'Кохма',
        'Красавино',
        'Красноармейск',
        'Красноармейск',
        'Красновишерск',
        'Красногорск',
        'Краснодар',
        'Краснозаводск',
        'Краснознаменск',
        'Краснознаменск',
        'Краснокаменск',
        'Краснокамск',
        'Красноперекопск',
        'Краснослободск',
        'Краснослободск',
        'Краснотурьинск',
        'Красноуральск',
        'Красноуфимск',
        'Красноярск',
        'Красный Кут',
        'Красный Сулин',
        'Красный Холм',
        'Кремёнки',
        'Кропоткин',
        'Крымск',
        'Кстово',
        'Кубинка',
        'Кувандык',
        'Кувшиново',
        'Кудрово',
        'Кудымкар',
        'Кузнецк',
        'Куйбышев',
        'Кукмор',
        'Кулебаки',
        'Кумертау',
        'Кунгур',
        'Купино',
        'Курган',
        'Курганинск',
        'Курильск',
        'Курлово',
        'Куровское',
        'Курск',
        'Куртамыш',
        'Курчалой',
        'Курчатов',
        'Куса',
        'Кушва',
        'Кызыл',
        'Кыштым',
        'Кяхта',
        'Лабинск',
        'Лабытнанги',
        'Лагань',
        'Ладушкин',
        'Лаишево',
        'Лакинск',
        'Лангепас',
        'Лахденпохья',
        'Лебедянь',
        'Лениногорск',
        'Ленинск',
        'Ленинск-Кузнецкий',
        'Ленск',
        'Лермонтов',
        'Лесной',
        'Лесозаводск',
        'Лесосибирск',
        'Ливны',
        'Ликино-Дулёво',
        'Липецк',
        'Липки',
        'Лиски',
        'Лихославль',
        'Лобня',
        'Лодейное Поле',
        'Лосино-Петровский',
        'Луга',
        'Луза',
        'Лукоянов',
        'Луховицы',
        'Лысково',
        'Лысьва',
        'Лыткарино',
        'Льгов',
        'Любань',
        'Люберцы',
        'Любим',
        'Людиново',
        'Лянтор',
        'Магадан',
        'Магас',
        'Магнитогорск',
        'Майкоп',
        'Майский',
        'Макаров',
        'Макарьев',
        'Макушино',
        'Малая Вишера',
        'Малгобек',
        'Малмыж',
        'Малоархангельск',
        'Малоярославец',
        'Мамадыш',
        'Мамоново',
        'Мантурово',
        'Мариинск',
        'Мариинский Посад',
        'Маркс',
        'Махачкала',
        'Мглин',
        'Мегион',
        'Медвежьегорск',
        'Медногорск',
        'Медынь',
        'Межгорье',
        'Междуреченск',
        'Мезень',
        'Меленки',
        'Мелеуз',
        'Менделеевск',
        'Мензелинск',
        'Мещовск',
        'Миасс',
        'Микунь',
        'Миллерово',
        'Минеральные Воды',
        'Минусинск',
        'Миньяр',
        'Мирный',
        'Мирный',
        'Михайлов',
        'Михайловка',
        'Михайловск',
        'Михайловск',
        'Мичуринск',
        'Могоча',
        'Можайск',
        'Можга',
        'Моздок',
        'Мончегорск',
        'Морозовск',
        'Моршанск',
        'Мосальск',
        'Москва',
        'Муравленко',
        'Мураши',
        'Мурино',
        'Мурманск',
        'Муром',
        'Мценск',
        'Мыски',
        'Мытищи',
        'Мышкин',
        'Набережные Челны',
        'Навашино',
        'Наволоки',
        'Надым',
        'Назарово',
        'Назрань',
        'Называевск',
        'Нальчик',
        'Нариманов',
        'Наро-Фоминск',
        'Нарткала',
        'Нарьян-Мар',
        'Находка',
        'Невель',
        'Невельск',
        'Невинномысск',
        'Невьянск',
        'Нелидово',
        'Неман',
        'Нерехта',
        'Нерчинск',
        'Нерюнгри',
        'Нестеров',
        'Нефтегорск',
        'Нефтекамск',
        'Нефтекумск',
        'Нефтеюганск',
        'Нея',
        'Нижневартовск',
        'Нижнекамск',
        'Нижнеудинск',
        'Нижние Серги',
        'Нижний Ломов',
        'Нижний Новгород',
        'Нижний Тагил',
        'Нижняя Салда',
        'Нижняя Тура',
        'Николаевск',
        'Николаевск-на-Амуре',
        'Никольск',
        'Никольск',
        'Никольское',
        'Новая Ладога',
        'Новая Ляля',
        'Новоалександровск',
        'Новоалтайск',
        'Новоаннинский',
        'Нововоронеж',
        'Новодвинск',
        'Новозыбков',
        'Новокубанск',
        'Новокузнецк',
        'Новокуйбышевск',
        'Новомичуринск',
        'Новомосковск',
        'Новопавловск',
        'Новоржев',
        'Новороссийск',
        'Новосибирск',
        'Новосиль',
        'Новосокольники',
        'Новотроицк',
        'Новоузенск',
        'Новоульяновск',
        'Новоуральск',
        'Новохопёрск',
        'Новочебоксарск',
        'Новочеркасск',
        'Новошахтинск',
        'Новый Оскол',
        'Новый Уренгой',
        'Ногинск',
        'Нолинск',
        'Норильск',
        'Ноябрьск',
        'Нурлат',
        'Нытва',
        'Нюрба',
        'Нягань',
        'Нязепетровск',
        'Няндома',
        'Облучье',
        'Обнинск',
        'Обоянь',
        'Обь',
        'Одинцово',
        'Озёрск',
        'Озёрск',
        'Озёры',
        'Октябрьск',
        'Октябрьский',
        'Окуловка',
        'Олёкминск',
        'Оленегорск',
        'Олонец',
        'Омск',
        'Омутнинск',
        'Онега',
        'Опочка',
        'Орёл',
        'Оренбург',
        'Орехово-Зуево',
        'Орлов',
        'Орск',
        'Оса',
        'Осинники',
        'Осташков',
        'Остров',
        'Островной',
        'Острогожск',
        'Отрадное',
        'Отрадный',
        'Оха',
        'Оханск',
        'Очёр',
        'Павлово',
        'Павловск',
        'Павловский Посад',
        'Палласовка',
        'Партизанск',
        'Певек',
        'Пенза',
        'Первомайск',
        'Первоуральск',
        'Перевоз',
        'Пересвет',
        'Переславль-Залесский',
        'Пермь',
        'Пестово',
        'Петров Вал',
        'Петровск',
        'Петровск-Забайкальский',
        'Петрозаводск',
        'Петропавловск-Камчатский',
        'Петухово',
        'Петушки',
        'Печора',
        'Пикалёво',
        'Пионерский',
        'Питкяранта',
        'Плавск',
        'Пласт',
        'Плёс',
        'Поворино',
        'Подольск',
        'Подпорожье',
        'Покачи',
        'Покров',
        'Покровск',
        'Полевской',
        'Полесск',
        'Полысаево',
        'Полярные Зори',
        'Полярный',
        'Поронайск',
        'Порхов',
        'Похвистнево',
        'Почеп',
        'Починок',
        'Пошехонье',
        'Правдинск',
        'Приволжск',
        'Приморск',
        'Приморск',
        'Приморско-Ахтарск',
        'Приозерск',
        'Прокопьевск',
        'Пролетарск',
        'Протвино',
        'Прохладный',
        'Псков',
        'Пугачёв',
        'Пудож',
        'Пустошка',
        'Пучеж',
        'Пушкино',
        'Пущино',
        'Пыталово',
        'Пыть-Ях',
        'Пятигорск',
        'Радужный',
        'Радужный',
        'Райчихинск',
        'Раменское',
        'Рассказово',
        'Ревда',
        'Реж',
        'Реутов',
        'Ржев',
        'Родники',
        'Рославль',
        'Россошь',
        'Ростов',
        'Ростов-на-Дону',
        'Рошаль',
        'Ртищево',
        'Рубцовск',
        'Рудня',
        'Руза',
        'Рузаевка',
        'Рыбинск',
        'Рыбное',
        'Рыльск',
        'Ряжск',
        'Рязань',
        'Саки',
        'Салават',
        'Салаир',
        'Салехард',
        'Сальск',
        'Самара',
        'Санкт-Петербург',
        'Саранск',
        'Сарапул',
        'Саратов',
        'Саров',
        'Сасово',
        'Сатка',
        'Сафоново',
        'Саяногорск',
        'Саянск',
        'Светлогорск',
        'Светлоград',
        'Светлый',
        'Светогорск',
        'Свирск',
        'Свободный',
        'Себеж',
        'Севастополь',
        'Северо-Курильск',
        'Северобайкальск',
        'Северодвинск',
        'Североморск',
        'Североуральск',
        'Северск',
        'Севск',
        'Сегежа',
        'Сельцо',
        'Семёнов',
        'Семикаракорск',
        'Семилуки',
        'Сенгилей',
        'Серафимович',
        'Сергач',
        'Сергиев Посад',
        'Сердобск',
        'Серов',
        'Серпухов',
        'Сертолово',
        'Сибай',
        'Сим',
        'Симферополь',
        'Сковородино',
        'Скопин',
        'Славгород',
        'Славск',
        'Славянск-на-Кубани',
        'Сланцы',
        'Слободской',
        'Слюдянка',
        'Смоленск',
        'Снежинск',
        'Снежногорск',
        'Собинка',
        'Советск',
        'Советск',
        'Советск',
        'Советская Гавань',
        'Советский',
        'Сокол',
        'Солигалич',
        'Соликамск',
        'Солнечногорск',
        'Соль-Илецк',
        'Сольвычегодск',
        'Сольцы',
        'Сорочинск',
        'Сорск',
        'Сортавала',
        'Сосенский',
        'Сосновка',
        'Сосновоборск',
        'Сосновый Бор',
        'Сосногорск',
        'Сочи',
        'Спас-Деменск',
        'Спас-Клепики',
        'Спасск',
        'Спасск-Дальний',
        'Спасск-Рязанский',
        'Среднеколымск',
        'Среднеуральск',
        'Сретенск',
        'Ставрополь',
        'Старая Купавна',
        'Старая Русса',
        'Старица',
        'Стародуб',
        'Старый Крым',
        'Старый Оскол',
        'Стерлитамак',
        'Стрежевой',
        'Строитель',
        'Струнино',
        'Ступино',
        'Суворов',
        'Судак',
        'Суджа',
        'Судогда',
        'Суздаль',
        'Сунжа',
        'Суоярви',
        'Сураж',
        'Сургут',
        'Суровикино',
        'Сурск',
        'Сусуман',
        'Сухиничи',
        'Сухой Лог',
        'Сызрань',
        'Сыктывкар',
        'Сысерть',
        'Сычёвка',
        'Сясьстрой',
        'Тавда',
        'Таганрог',
        'Тайга',
        'Тайшет',
        'Талдом',
        'Талица',
        'Тамбов',
        'Тара',
        'Тарко-Сале',
        'Таруса',
        'Татарск',
        'Таштагол',
        'Тверь',
        'Теберда',
        'Тейково',
        'Темников',
        'Темрюк',
        'Терек',
        'Тетюши',
        'Тимашёвск',
        'Тихвин',
        'Тихорецк',
        'Тобольск',
        'Тогучин',
        'Тольятти',
        'Томари',
        'Томмот',
        'Топки',
        'Торжок',
        'Торопец',
        'Тосно',
        'Тотьма',
        'Трёхгорный',
        'Троицк',
        'Трубчевск',
        'Туапсе',
        'Туймазы',
        'Тула',
        'Тулун',
        'Туран',
        'Туринск',
        'Тутаев',
        'Тында',
        'Тырныауз',
        'Тюкалинск',
        'Тюмень',
        'Уварово',
        'Углегорск',
        'Углич',
        'Удачный',
        'Удомля',
        'Ужур',
        'Узловая',
        'Улан-Удэ',
        'Ульяновск',
        'Унеча',
        'Урай',
        'Урень',
        'Уржум',
        'Урус-Мартан',
        'Урюпинск',
        'Усинск',
        'Усмань',
        'Усолье',
        'Усолье-Сибирское',
        'Уссурийск',
        'Усть-Джегута',
        'Усть-Илимск',
        'Усть-Катав',
        'Усть-Кут',
        'Усть-Лабинск',
        'Устюжна',
        'Уфа',
        'Ухта',
        'Учалы',
        'Уяр',
        'Фатеж',
        'Феодосия',
        'Фокино',
        'Фокино',
        'Фролово',
        'Фрязино',
        'Фурманов',
        'Хабаровск',
        'Хадыженск',
        'Ханты-Мансийск',
        'Харабали',
        'Харовск',
        'Хасавюрт',
        'Хвалынск',
        'Хилок',
        'Химки',
        'Холм',
        'Холмск',
        'Хотьково',
        'Цивильск',
        'Цимлянск',
        'Циолковский',
        'Чадан',
        'Чайковский',
        'Чапаевск',
        'Чаплыгин',
        'Чебаркуль',
        'Чебоксары',
        'Чегем',
        'Чекалин',
        'Челябинск',
        'Чердынь',
        'Черемхово',
        'Черепаново',
        'Череповец',
        'Черкесск',
        'Чёрмоз',
        'Черноголовка',
        'Черногорск',
        'Чернушка',
        'Черняховск',
        'Чехов',
        'Чистополь',
        'Чита',
        'Чкаловск',
        'Чудово',
        'Чулым',
        'Чусовой',
        'Чухлома',
        'Шагонар',
        'Шадринск',
        'Шали',
        'Шарыпово',
        'Шарья',
        'Шатура',
        'Шахты',
        'Шахунья',
        'Шацк',
        'Шебекино',
        'Шелехов',
        'Шенкурск',
        'Шилка',
        'Шимановск',
        'Шиханы',
        'Шлиссельбург',
        'Шумерля',
        'Шумиха',
        'Шуя',
        'Щёкино',
        'Щёлкино',
        'Щёлково',
        'Щигры',
        'Щучье',
        'Электрогорск',
        'Электросталь',
        'Электроугли',
        'Элиста',
        'Энгельс',
        'Эртиль',
        'Югорск',
        'Южа',
        'Южно-Сахалинск',
        'Южно-Сухокумск',
        'Южноуральск',
        'Юрга',
        'Юрьев-Польский',
        'Юрьевец',
        'Юрюзань',
        'Юхнов',
        'Ядрин',
        'Якутск',
        'Ялта',
        'Ялуторовск',
        'Янаул',
        'Яранск',
        'Яровое',
        'Ярославль',
        'Ярцево',
        'Ясногорск',
        'Ясный',
        'Яхрома',
    ],
    type: ['1', '2', '3', '4️⃣', '5', '6'],
    forced: [
        '<h4 title=\'Стандартный\' >S</h4>',
        '<h4 title=\'Шина/Уголок25\' >🦾 <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Force/Шина-Уголок25.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'></a> Шина/Уголок25</h4>',
        '<h4 title=\'Уголок Тип1\' >🦾 <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Force/Уголок1.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'></a> Уголок</h4>',
        '<h4 title=\'Уголок Тип2\' >🦾 <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Force/Уголок2.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'></a> Уголок</h4>',
        '<h4 title=\'Уголок Тип3\' >🦾 <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Force/Уголок3.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'></a> Уголок</h4>',
        '<h4 title=\'Профиль оцинкованный\' >🦾 <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Force/Профиль оц.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'></a> Профиль оц.</h4>',
        '<h4 title=\'Внутренние угловые распорки\' >🦾 <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Force/Внутренние угловые распорки.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'></a> Внутренние угловые распорки</h4>',
        '<h4 title=\'Распорные шпильки\' >🦾 <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Force/Распорные шпильки.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'></a> Распорные шпильки</h4>',
        '<h4 title=\'Скошенный\' >∠ <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/3. прямой скошенный.png\' alt=\'1-1-1\' class=\'scale\' style=\'width: 40px; height: auto;\'></a></h4>',
        '<h4 title=\'Разборный\' >「」 <a href=\'#popmake-\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/3. прямой L-образный.png\' alt=\'1-1-1\' class=\'scale\' style=\'width: 40px; height: auto;\'></a></h4>',
    ],
    ductsplit: ['1250', '1390', '1410', '1500', '1000', '500'],
    for: ['1', '2'],
    TypeSystem: ['---', 'Резерв', 'Аварийная'],
    measurements: [
        '<h4>Решетка <img src=\'/wp-content/uploads/2022/03/reshvnutr/решетка однорядная.webp\' class=\'scale\' style=\'width: 30px; height: auto;\' /></h4>',
        '<h4>Диффузор <img src=\'/wp-content/uploads/2022/03/reshvnutr/квадратный диффузор.jpg\' class=\'scale\' style=\'width: 30px; height: auto;\' /></h4>',
        '<h4>Воздухораспределитель </h4>',
        '<h4>В канале <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/75. Лючок для очистки воздуховодов ПР.png\' alt=\'1-1-1\' class=\'scale\' style=\'width: 30px; height: auto;\'> (Магистральный на промышленном предприятии)(Норма 8-12м/с)</h4>',
        '<h4>В канале <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/75. Лючок для очистки воздуховодов ПР.png\' alt=\'1-1-1\' class=\'scale\' style=\'width: 30px; height: auto;\'> (Магистральный на гражданском объекте)(Норма 6м/с)</h4>',
        '<h4>Боковое ответвление <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/75. Лючок для очистки воздуховодов ПР.png\' alt=\'1-1-1\' class=\'scale\' style=\'width: 30px; height: auto;\'> от магистрального(Норма 4-5м/с)</h4>',
        '<h4>Распределительный, <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/75. Лючок для очистки воздуховодов ПР.png\' alt=\'1-1-1\' class=\'scale\' style=\'width: 30px; height: auto;\'> идущий к решетке или диффузору(Норма 1,5-2м/с)</h4>',
        '<h4>Выхлоп (Выброс)</h4>',
        '<h4>Вход (Забор)</h4>',
        '<h4>Зонт вытяжной(кухня) <img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/19-2-2.png\' class=\'scale\' alt=\'19-2-2\' style=\'width: 30px; height: auto;\'/></h4>',
    ],
    measurementsTools: ['Анемометр CPS', 'Анемометр Testo', 'Анемометр Testo - поверенный'],
    strong: [
        '<h4>---</h4>',
        '<h4><a href=\'#popmake-6462\'><img src=\'/wp-content/uploads/2022/03/spilka.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>Шпилька М8</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/spilka.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Шпилька М10</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/spilka.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Шпилька М12</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Угловая распорка1.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Угловая распорка 1️⃣</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Угловая распорка2.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Угловая распорка 2️⃣</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Рассекатель.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Рассекатель 1шт.</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Рассекатель.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Рассекатель 2шт.</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Рассекатель.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Рассекатель 3шт.</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Трубка алюминиевая.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Трубка алюминиевая М12</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Трубка алюминиевая.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Трубка алюминиевая М16</h4>'
    ],
    fire: [
        '<h4>---</h4>',
        '<h4>EI30</h4>',
        '<h4>EI60</h4>',
        '<h4>EI90</h4>',
        '<h4>EI120</h4>',
        '<h4>EI150</h4>',
        '<h4>EI180</h4>',
        '<h4>EI240</h4>',
        '<h4>PRO-МБОР-VENT 5мм(EI30)</h4>',
        '<h4>PRO-МБОР-VENT 5мм(EI60)</h4>',
        '<h4>PRO-МБОР-VENT 8мм(EI90)</h4>',
        '<h4>PRO-МБОР-VENT 10мм(EI120)</h4>',
        '<h4>PRO-МБОР-VENT 13мм(EI150)</h4>',
        '<h4>PRO-МБОР-VENT 13мм(EI180)</h4>',
        '<h4>PRO-МБОР-VENT 26мм(EI240)</h4>',
        '<h4>PRO-VENT 20 мм (EI60)</h4>',
        '<h4>PRO-VENT 40 мм (EI120)</h4>',
        '<h4>PRO-VENT 60 мм (EI150)</h4>',
        '<h4>PRO-VENT 70 мм (EI180)</h4>',
        '<h4>Firestill®</h4>',
        '<h4>ОгнеВент®-Базальт</h4>',
        '<h4>Firestill®</h4>',
        '<h4>Изовент®</h4>',
        '<h4>ОгнеВент®</h4>',
        '<h4>ПВК-2002</h4>',
        '<h4>Шнур базальтовый огнезащитный BOS-Cord</h4>'
    ],
    thermal: [
        '<h4>---</h4>',
        '<h4>🌡️ 5</h4>',
        '<h4>🌡️ 10</h4>',
        '<h4>🌡️ 15</h4>',
        '<h4>🌡️ 20</h4>',
        '<h4>🌡️ 30</h4>',
        '<h4><input class=\'\' type=\'radio\' name=\'Tape\' value=\'50\' checked > <img src=\'/wp-content/uploads/2022/03/скотч металл.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Скотч металлический 50x50\' />5️⃣0️⃣</input> <input class=\'\' type=\'radio\' name=\'Tape\' value=\'75\' > <img src=\'/wp-content/uploads/2022/03/скотч металл.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Скотч металлический 75x50\' />7️⃣5️⃣</input>  <input class=\'\' type=\'radio\' name=\'Tape\' value=\'100\' > <img src=\'/wp-content/uploads/2022/03/скотч металл.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Скотч металлический 100x50\' />1️⃣0️⃣0️⃣</input></h4>',
        '<input class=\'cb pristine\' type=\'checkbox\'         > <img src=\'/wp-content/uploads/2022/03/Клей.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Клей\' /></input>',
        '<input class=\'cb pristine\' type=\'checkbox\'         > <img src=\'/wp-content/uploads/2022/03/Шипы.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Шипы самоклящиеся с площадкой\' /></input>',
        '<input class=\'cb pristine\' type=\'checkbox\'         > <img src=\'/wp-content/uploads/2022/03/Шипы приварные.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Шипы приварные\' /></input>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Armaflex Duct AL.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Armaflex Duct AL</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR AD METAL 6 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR METAL 6 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR AD METAL 10 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR METAL 10 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR AD METAL 13 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR METAL 13 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR AD METAL 19 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR METAL 19 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR AD METAL 25 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR METAL 25 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR AD METAL 32 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/K-flex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />K-Flex AIR METAL 32 мм</h4>',
        '<h4>Thermasheet ECO VSA</h4>',
        '<h4><h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Energoflex Black Star Duct.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Energoflex Black Star Duct</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Пенофол.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Пенофол 2000 тип C-3 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Пенофол.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Пенофол 2000 тип C-5 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Пенофол.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Пенофол 2000 тип C-8 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Пенофол.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Пенофол 2000 тип C-10 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Пенофол.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Пенофол 2000 тип C-15 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Пенофол.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Пенофол 2000 тип C-20 мм</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Магнофлекс.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'МАГНОФЛЕКС® тип R-А – это фольгированная с одной стороны стеклосетка\'/>Магнофлекс тип R-А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Магнофлекс.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'МАГНОФЛЕКС® тип R-В – это стеклосетка, фольгированная с двух сторон\'/>Магнофлекс тип R-В</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Утеплитель/Магнофлекс.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'МАГНОФЛЕКС® тип R-С – это стеклосетка с одной стороны фольгированная, с другой стороны нанесен клейкий слой\'/>Магнофлекс тип R-С</h4>',
        '<h4>ALMALEN UniLine Sheet VSA</h4>',
        '<h4>🔥 EI30</h4>',
        '<h4>🔥 EI60</h4>',
        '<h4>🔥 EI90</h4>',
        '<h4>🔥 EI120</h4>',
        '<h4>🔥 EI150</h4>',
        '<h4>🔥 EI180</h4>',
        '<h4>🔥 EI240</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-МБОР-VENT 5мм(EI30)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-МБОР-VENT 5мм(EI60)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-МБОР-VENT 8мм(EI90)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-МБОР-VENT 10мм(EI120)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-МБОР-VENT 13мм(EI150)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-МБОР-VENT 13мм(EI180)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-МБОР-VENT 26мм(EI240)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-VENT 20 мм (EI60)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-VENT 40 мм (EI120)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-VENT 60 мм (EI150)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/PRO-МБОР-VENT.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />PRO-VENT 70 мм (EI180)</h4>',
        '<h4>Firestill®</h4>',
        '<h4>ОгнеВент®-Базальт</h4>',
        '<h4>Firestill®</h4>',
        '<h4>Изовент®</h4>',
        '<h4>ОгнеВент®</h4>',
        '<h4>ПВК-2002</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/Огнезащитный цилиндр для шпилек EXPERT ISOL PIN.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Огнезащитный цилиндр для шпилек EXPERT ISOL PIN\'/>Огнезащитный цилиндр для шпилек</input></h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/Сетка Манье.png\' class=\'scale\' style=\'width: 40px; height: auto;\' title=\'Сетка Манье\'/>Сетка Манье</input></h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\'> <img title=\'Шнур базальтовый огнезащитный BOS-Cord\' src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/Шнур базальтовый огнезащитный.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Базальтовый</input> <input class=\'cb pristine\' type=\'checkbox\'> <img title=\'Шнур асбестовый огнезащитный\' src=\'/wp-content/uploads/2022/03/vozduhovod/Огнезащита/Шнур асбестовый.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Асбестовый</input></h4>'
    ],
    category: [
        '---',
        '1 КАТЕГОРИЯ (Hv = 385 Дж / м3): 385',
        'операционные: 385',
        'предоперационные: 385',
        'родильные: 385',
        'стерильные зоны ЦСО: 385',
        'детские палаты роддомов: 385',
        '2 КАТЕГОРИЯ (Hv = 256 Дж / м3): 256',
        'перевязочные: 256',
        'палаты реанимационных отделений: 256',
        'помещения нестерильных зон ЦСО: 256',
        'бактериологические и вирусологические лаборатории: 256',
        'фармацевтические цеха: 256',
        '3 КАТЕГОРИЯ (Hv = 167 Дж / м3): 167',
        'палаты: 167',
        'кабинеты и другие помещения ЛПУ (не включенные в 1 и 2 категории): 167',
        '4 КАТЕГОРИЯ (Hv = 130 Дж / м3): 130',
        'детские игровые комнаты: 130',
        'школьные классы: 130',
        'бытовые помещения общественных и промышленных зданий с большим скоплением людей при длительном пребывании.130',
        '5 КАТЕГОРИЯ (Hv = 105 Дж / м3):105',
        'общественные туалеты и лестничные площадки помещений ЛПУ: 105'
    ],
    cond: ['---', 'К1', 'К2', 'К3', 'К4️⃣', 'К5', 'К6', 'К7', 'К8', 'К9', 'К10'],
    typebak: ['---', 'Канальный', 'Встраиваемый'],
    reserve: ['---', '1.2', '1.5', '2'],
    typechiller: ['Холод', 'Free-cooling', 'Тепловой насос'],
    typecondensator: ['Воздух', 'Вода', 'Гликоль'],
    typecopressor: ['Спиральный', 'Винтовой', 'Поршневой', 'Центробежный'],
    typeconfig: ['Моноблок', 'Выносной конденсатор', 'Сухая градирня'],
    tempoutdoor: ['Моноблок', 'Выносной конденсатор', 'Сухая градирня'],
    coolpower: ['Моноблок', 'Выносной конденсатор', 'Сухая градирня'],
    templiquidisp: ['in', 'out'],
    templiquidcond: ['in', 'out'],
    typeliquid: ['Вода', 'Этиленгликоль', 'Пропиленгликоль'],
    typemode: ['Круглогодичный', 'Теплый период года'],
    typemodedd: ['Круглогодичный', 'Теплый период года'],
    plancond: [
        '---',
        'Коммерческая закупка',
        'Гос/мнцп.закупки-44ФЗ',
        'Гос/мнцп.закупки-223ФЗ',
        'Гос/мнцп.закупки-ЗМО',
        'Прямо сейчас пока не начался сезон и все есть в наличии по низким ценам',
        'Как определюсь с выбором модели, сразу закажу',
        'Еще решаю, нужен мне кондиционер или нет',
        'Никогда - в жару использую мокрое полотенце',
        'Благотворительность'
    ],
    brandcond: [
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\' checked>Наша поставка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' >Наша поставка Б/У</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' >Поставка заказчика</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' >Поставка заказчика Б/У</input>',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/AC ELECTRIC.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />AC ELECTRIC',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/ACS.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />ACS',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Aeronik.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />AFE',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Aeronik.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Aeronik',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Aerotek.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Aerotek',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Aermec.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Aermec',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Airwell.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Airwell',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/AirSonic.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />AirSonic',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Akvilon.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Akvilon',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Aux.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Aux',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Axioma.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Axioma',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Bosch.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Bosch',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Ballu.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Ballu',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Carrier.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Carrier',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Cooper&Hunter.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Cooper&Hunter',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Centek.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Centek',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Chigo.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Chigo',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Chofu.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Chofu',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Daikin.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Daikin',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Dantex.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Dantex',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Dahaci.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Dahaci',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Daichi.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Daichi',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Daewoo.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Daewoo',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Dax.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Dax',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Electrolux.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Electrolux',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Energolux.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Energolux',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Faura.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Faura',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Fujitsu.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Fujitsu',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Funai.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Funai',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Galanz.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Galanz',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/General.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />General',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/General Climate.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />General Climate',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Gree.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Gree',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/GREEN.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />GREEN',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Hitachi.jpg\' class=\'scale\' style=\'width: 70px; height: auto;\' />Hitachi',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Haier.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Haier',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Hisense.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Hisense',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Hyundai.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Hyundai',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/IGC.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />IGC',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Jac.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Jac',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Jax.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Jax',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Kitano.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Kitano',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Kentatsu.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Kentatsu',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Komatsu.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Komatsu',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Lanzkraft.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Lanzkraft',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Leberg.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Leberg',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Lg.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Lg',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Lessar.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Lessar',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Mitsubishi heavy.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Mitsubishi heavy',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Mitsubishi electric.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Mitsubishi electric',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Midea.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Midea',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/MDV.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />MDV',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/NeoClima.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />NeoClima',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Nikai.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Nikai',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Oasis.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Oasis',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Panasonic.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Panasonic',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Pioneer.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Pioneer',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/QuattroClima.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />QuattroClima',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Rix.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Rix',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Roda.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Roda',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Rover.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Rover',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Royal Thermo.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Royal Thermo',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Royal Clima.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Royal Clima',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Roland.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Roland',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Rovex.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Rovex',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Sakata.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Sakata',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Sharp.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Sharp',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Sanyo.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Sanyo',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Samsung.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Samsung',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Systemair.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Systemair',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Shuft.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Shuft',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Shivaki.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Shivaki',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/TCL.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />TCL',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Toshiba.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Toshiba',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Tosot.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Tosot',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/ULTIMA COMFORT.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />ULTIMA COMFORT',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Vertex.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Vertex',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/VS-Comfort.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />VS-Comfort',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/XIGMA.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />XIGMA',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/York.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />York',
        '<img src=\'/wp-content/uploads/2022/03/cond/Brand/Zanussi.png\' class=\'scale\' style=\'width: 70px; height: auto;\' />Zanussi',
    ],
    across: ['5', '1', '2', '3', '4', '6', '7', '8', '9', '10', '15', '20', '25', '30', '35', '40', '45', '50', '60', '70', '80', '90', '100'],
    along: ['4', '1', '2', '3', '5', '6', '7', '8', '9', '10', '15', '20', '25', '30', '35', '40', '45', '50', '60', '70', '80', '90', '100'],
    ceiling: ['3', '1', '2', '2.5', '3.5', '4', '5', '6', '7', '8', '9', '10', '15', '20', '25', '30', '35', '40', '45', '50', '60', '70', '80', '90', '100'],
    acrossType: ['20', '25', '30', '35', '40', '45', '50', '60', '70', '80', '90', '100'],
    typecondsistem: [
        '<h4>On/Off</h4>',
        '<h4>Invertor</h4>',
        '<input class=\'cb pristine\' type=\'checkbox\' checked>Тихий ВБ</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Тихий НБ</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>𖣘 Приточная вентиляция</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>🛜Wi-Fi</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' checked>Таймер</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Самодиагностика</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Самоочистка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Авторестарт</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Механический фильтр</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Тихий ВБ</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Защита от обдува холодным воздухом</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Турбо режим/быстрый старт</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Теплый/горячий старт</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Автоматические горизонтальные жалюзи</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Автоматические горизонтальные и вертикальные жалюзи</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Класс энергоэффективности</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Низкотемпературный обогрев и охлаждение</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Глубокий сон/ночной режим</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>I feel обеспечивает необходимую температуру в зоне нахождения пульта ДУ</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' checked> Пульт беспроводной</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>ДУ с часами и функцией блокировки</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Пульт проводной</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Насыщение воздуха ионами кислорода и стерилизация воздуха благодаря фильтру холодная плазма</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Плавный пуск</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Поддержание минимальной температуры +8 в помещении при отсутствии людей</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Датчик присутствия людей</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Скрытый дисплей ВБ</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' checked>Автоматический режим работы</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Экономичный режим</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Режим разморозки</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img title=\'R12 Дифтордихлорметан, -29,8°C, химическая формула CCl₂F₂\' src=\'/wp-content/uploads/2022/03/cond/Freon/R12.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />R12</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img title=\'R22 Дифторхлорметан, -40,8°C, химическая формула CHClF2\' src=\'/wp-content/uploads/2022/03/cond/Freon/R22.png\' class=\'scale\' style=\'width: 20px; height: auto;\' />R22</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img title=\'R32 Дифторметан, -51,63°C, химическая формула CH2F2\' src=\'/wp-content/uploads/2022/03/cond/Freon/R32.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />R32</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img title=\'R134A Тетрафторэтан, -26,3°C, химическая формула CH2FCF3\' src=\'/wp-content/uploads/2022/03/cond/Freon/R134A.png\' class=\'scale\' style=\'width: 20px; height: auto;\' />R134A</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img title=\'R290 Пропан, -42,1°C, химическая формула C3H8\' src=\'/wp-content/uploads/2022/03/cond/Freon/R290.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />R290</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img title=\'R404A Околоазеотропная смесь из R125, R143a и R134a (44/52/4 масса-%), -46,6°C, химическая формула CHF2CF3 / CF3CH2F / CH3CF3\'  src=\'/wp-content/uploads/2022/03/cond/Freon/R404A.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />R404A</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/Freon/R407C.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />R407C</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/Freon/R407F.png\' class=\'scale\' style=\'width: 40px; height: 50px;\' />R407F</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' checked><img title=\'R410A Неазеотропная смесь из 50% дифторметана R-32 и 50% пентафторэтана R-125, -48,5°C, химическая формула 50%CH2F2/50%CHF2CF3\' src=\'/wp-content/uploads/2022/03/cond/Freon/R410A.png\' class=\'scale\' style=\'width: 20px; height: 50px;\' />R410A</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/Freon/R427A.png\' class=\'scale\' style=\'width: 40px; height: 50px;\' />R427A</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>🅰️</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>🅰️➕</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>🅰️➕➕</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>🅰️➕➕➕</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>🅱️</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>C</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>D</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>E</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>F</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>G</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Стабилизатор напряжения до 185В (Запуск кондиционера при низком напряжении или перебоях в питании)</input>',
    ],
    typecondmode: [
        '<h4>❄️➖☀️➖💧➖𖣘➖🔄</h4>',
        '<h4>❄️➖☀️➖💧</h4>',
        '<h4>❄️➖☀️</h4>',
        '<h4>❄️</h4>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Тепловой насос</input>',
    ],
    typeroom: [
        '---',
        'Жилая комната',
        'Офис',
        'Серверная',
        'Спортзал',
        '🏠Жилой дом/Квартира',
        'Детский сад/ясли',
        '🏫Школа',
        '🏩Больница',
        '🎓Вуз/Колледж/Лицей',
        '📚Библиотека/🏛️Музей',
        'Гостиница/Общежитие',
        'Офис/Администрация',
        'Баня',
        'Сауна',
        'Бассейн',
        'Склад, цех, ангар',
        'Прозрачный козырёк над входом',
        'Магазин/Торговый центр',
        'Нет в списке',
    ],
    stdschem: [
        '---',
        'Не стандарт',
        '<input class=\'cb pristine\' type=\'checkbox\'>Закладка трассы</input>',
        '1️⃣ <img src=\'/wp-content/uploads/2024/05/1.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/1.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/1.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />',
        '2️⃣ <img src=\'/wp-content/uploads/2024/05/2.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/2.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/2.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />',
        '3️⃣ <img src=\'/wp-content/uploads/2024/05/3.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/3.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/3.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />',
        '<h4> 4️⃣ <img src=\'/wp-content/uploads/2024/05/4.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/4.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/4.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 5️⃣ <img src=\'/wp-content/uploads/2024/05/5.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/5.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/5.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 6️⃣ <img src=\'/wp-content/uploads/2024/05/6.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/6.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/6.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 7️⃣ <img src=\'/wp-content/uploads/2024/05/7.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/7.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/7.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 8️⃣ <img src=\'/wp-content/uploads/2024/05/8.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/8.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/8.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 9️⃣ <img src=\'/wp-content/uploads/2024/05/9.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/9.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/9.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣0️⃣ <img src=\'/wp-content/uploads/2024/05/10.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/10.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/10.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣1️⃣ <img src=\'/wp-content/uploads/2024/05/11.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/11.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/11.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣2️⃣ <img src=\'/wp-content/uploads/2024/05/12.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/12.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/12.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣3️⃣ <img src=\'/wp-content/uploads/2024/05/13.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/13.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/13.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣4️⃣ <img src=\'/wp-content/uploads/2024/05/14.1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/14.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/14.3.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣ <img src=\'/wp-content/uploads/2024/05/схема-1.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 2️⃣ <img src=\'/wp-content/uploads/2024/05/схема-2.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 3️⃣ <img src=\'/wp-content/uploads/2024/05/схема-3.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 4️⃣ <img src=\'/wp-content/uploads/2024/05/схема-4.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 5️⃣ <img src=\'/wp-content/uploads/2024/05/схема-5.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 6️⃣ <img src=\'/wp-content/uploads/2024/05/схема-6.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 7️⃣ <img src=\'/wp-content/uploads/2024/05/схема-7.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 8️⃣ <img src=\'/wp-content/uploads/2024/05/схема-8.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 9️⃣ <img src=\'/wp-content/uploads/2024/05/схема-9.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣0️⃣<img src=\'/wp-content/uploads/2024/05/схема-10.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣1️⃣ <img src=\'/wp-content/uploads/2024/05/схема-11.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣2️⃣ <img src=\'/wp-content/uploads/2024/05/схема-12.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣3️⃣ <img src=\'/wp-content/uploads/2024/05/схема-13.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣4️⃣ <img src=\'/wp-content/uploads/2024/05/схема-14.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
    ],
    light: ['---', '🔆Низкая', '🔆Средняя', '🔆Высокая'],
    airvent: ['---', 'Да'],
    people: ['---', '3', '4', '5', '6', '7', '8', '9', '10', '15', '20'],
    device: ['---', '3', '4', '5', '6', '7', '8', '9', '10', '15', '20'],
    powerreserve: ['---', '5%', '10%'],
    typecond: [
        '<h4><img src=\'/wp-content/uploads/2022/03/sftg_1_830kh620.webp\' class=\'scale\' style=\'width: 50px; height: auto;\' />Настенный</h4>',
        'Не определено',
        '<input class=\'cb pristine\' type=\'checkbox\'> Существующий Б/У</input>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кассетный.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Кассетный</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Потолочный.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Потолочный</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Напольный.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Напольный</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Колонный.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Колонный</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Ккб.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />ККБ</h4>'
    ],
    tubecond: [
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕9️⃣,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4➕<img src=\'/wp-content/uploads/2022/03/cond/tube/Гайка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />)➕9️⃣,52❌0,81(3/8➕<img src=\'/wp-content/uploads/2022/03/cond/tube/Гайка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕9️⃣,52❌0,81(3/8)➕K-flex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕9️⃣,52❌0,81(3/8)➕Thermaflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕9️⃣,52❌0,81(3/8)➕Condiflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕9️⃣,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4➕<img src=\'/wp-content/uploads/2022/03/cond/tube/Гайка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />)➕12,7❌0,70(1/2➕<img src=\'/wp-content/uploads/2022/03/cond/tube/Гайка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕12,7❌0,70(1/2)➕K-flex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕12,7❌0,70(1/2)➕Thermaflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕12,7❌0,70(1/2)➕Condiflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 9️⃣,52❌0,81(3/8)➕15,88❌0,75(5/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 9️⃣,52❌0,81(3/8➕<img src=\'/wp-content/uploads/2022/03/cond/tube/Гайка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />)➕15,88❌0,75(5/8➕<img src=\'/wp-content/uploads/2022/03/cond/tube/Гайка.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 9️⃣,52❌0,81(3/8)➕15,88❌0,75(5/8)➕K-flex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 9️⃣,52❌0,81(3/8)➕15,88❌0,75(5/8)➕Thermaflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 9️⃣,52❌0,81(3/8)➕15,88❌0,75(5/8)➕Condiflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 9️⃣,52❌0,81(3/8)➕15,88❌0,75(5/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 19,05❌0,80(3/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 19,05❌0,80(3/4)➕ K-flex Ø20</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 19,05❌0,80(3/4)➕Thermaflex Ø20</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 19,05❌0,80(3/4)➕Condiflex Ø20</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 19,05❌0,80(3/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 25,4❌1,0(1)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 25,4❌1,0(1)➕K-flex Ø25</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 25,4❌1,0(1)➕Thermaflex Ø25</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 25,4❌1,0(1)➕Condiflex Ø25</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 25,4❌1,0(1)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 28,57❌1,00(1-1/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 28,57❌1,00(1-1/8)➕K-flex Ø28</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 28,57❌1,00(1-1/8)➕Thermaflex Ø28</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 28,57❌1,00(1-1/8)➕Condiflex Ø28</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 28,57❌1,00(1-1/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 34,92❌1,25(1-3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 34,92❌1,25(1-3/8)➕K-flex Ø30</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 34,92❌1,25(1-3/8)➕Thermaflex Ø30</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 34,92❌1,25(1-3/8)➕Condiflex Ø30</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 34,92❌1,25(1-3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' /> 9,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' /> 12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />15,88❌0,75(5/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' /> 15,88❌0,75(5/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />19,05❌0,80(3/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' /> 19,05❌0,80(3/4)➕',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />25,4❌1,0(1)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' /> 25,4❌1,0(1)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />28,57❌1,00(1-1/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' /> 28,57❌1,00(1-1/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />34,92❌1,25(1-3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' /> 34,92❌1,25(1-3/8)</h4>',
        '---',
        'Не требуется',
        'Монтаж заказчика',
        'Материал заказчика',
    ],
    tubecondgas: [
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)➕K-flex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)➕Thermaflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)➕Condiflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)➕K-flex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)➕Thermaflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)➕Condiflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />15,88❌0,75(5/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />15,88❌0,75(5/8)➕K-flex Ø16</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />15,88❌0,75(5/8)➕Thermaflex Ø16</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />15,88❌0,75(5/8)➕Condiflex Ø16</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />15,88❌0,75(5/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />19,05❌0,80(3/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />19,05❌0,80(3/4)➕ K-flex Ø20</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />19,05❌0,80(3/4)➕Thermaflex Ø20</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />19,05❌0,80(3/4)➕Condiflex Ø20</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />19,05❌0,80(3/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />25,4❌1,0(1)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />25,4❌1,0(1)➕K-flex Ø25</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />25,4❌1,0(1)➕Thermaflex Ø25</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />25,4❌1,0(1)➕Condiflex Ø25</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />25,4❌1,0(1)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />28,57❌1,00(1-1/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />28,57❌1,00(1-1/8)➕K-flex Ø28</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />28,57❌1,00(1-1/8)➕Thermaflex Ø28</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />28,57❌1,00(1-1/8)➕Condiflex Ø28</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />28,57❌1,00(1-1/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />34,92❌1,25(1-3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />34,92❌1,25(1-3/8)➕K-flex Ø30</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />34,92❌1,25(1-3/8)➕Thermaflex Ø30</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />34,92❌1,25(1-3/8)➕Condiflex Ø30</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />34,92❌1,25(1-3/8)</h4>',
        '<h4><input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/tube/Гайка.png" class="scale" style="width: 60px; height: auto;" />Гайки</input></h4>',
        '<h4><input class="cb pristine" type="checkbox">Заглушки</input></h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' />9,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />15,88❌0,75(5/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' />15,88❌0,75(5/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />19,05❌0,80(3/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' />19,05❌0,80(3/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />25,4❌1,0(1)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' />25,4❌1,0(1)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />28,57❌1,00(1-1/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' />28,57❌1,00(1-1/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />34,92❌1,25(1-3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий.png\'          class=\'scale\' style=\'width: 40px; height: auto;\' />34,92❌1,25(1-3/8)</h4>',
        '---',
        'Не требуется',
        'Монтаж заказчика',
        'Материал заказчика',
    ],
    tubecondliquid: [
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕K-flex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕Thermaflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)➕Condiflex</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6️⃣,35❌0,76(1/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)➕K-flex Ø1️⃣0️⃣</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)➕Thermaflex Ø1️⃣0️⃣</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)➕Condiflex Ø1️⃣0️⃣</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9️⃣,52❌0,81(3/8)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)➕K-flex Ø12</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)➕Thermaflex Ø12</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)➕Condiflex Ø12</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба медная.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)</h4>',
        '<h4><input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/tube/Гайка.png" class="scale" style="width: 60px; height: auto;" />Гайки</input></h4>',
        '<input class="cb pristine" type="checkbox">Заглушки</input>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />6,35❌0,76(1/4)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />9,52❌0,81(3/8)➕K-flex Ø1️⃣0️⃣</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)➕Thermaflex Ø12</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/cond/tube/Труба Алюминий+изоляция.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />12,7❌0,70(1/2)➕Condiflex Ø12</h4>',
        '---',
        'Не требуется',
        'Монтаж заказчика',
        'Материал заказчика',
    ],
    track: ['---', '3', '4', '5', '6', '10', '15', '20', '25', '30', '35', '40', '45', '50', '60', '70', '80', '90', '100', 'Прокладка(монтаж) заказчика'],
    power: [
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ПВС.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВС 3❌1,5',
        '---',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ПВС.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВС 3❌1',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ВВГ.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ВВГ 3❌1,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ВВГ.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ВВГ 3❌2,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ВВГ4х1.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ВВГ 4❌2,5',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Вилка угловая.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Угловая 16А</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Вилка прямая.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Прямая 16А</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Автомат 1Р.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />10А/15А 1Р <12000 БТЕ/ч</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Автомат 1Р.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />16А 1Р ≥12000 БТЕ/ч </input>',
        '<input class=\'cb pristine\' type=\'checkbox\' ><img src=\'/wp-content/uploads/2022/03/cond/Кабель/УЗО.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />УЗО влажной/сырой зоны</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Автомат 3Р.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 3Р</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Бокс для автомата накладной.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Накладной 12</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Бокс для автомата накладной24.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Накладной 24</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Бокс для автомата внутренний.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Внутренний 12</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Бокс для автомата внутренний24.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Внутренний 24</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/ГофраПВХ.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВХ</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Кабель/Металлорукав.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Металлорукав</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 25❌16</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/Штроба.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /> 40❌40</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' >Материал заказчика</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' >Монтаж заказчика</input>',
    ],
    trackpower: ['---', '3', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '60', '70', '80', '90', '100', 'Прокладка(монтаж) заказчика'],
    link: [
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ВВГ5х1.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ВВГ 5❌1',
        '---',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ВВГ4х1.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ВВГ 4❌1',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ПВС5х1.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВС 5❌1',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ВВГ4х1.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />ВВГпнг 4❌1,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/РПШ5х0,5.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />РПШ 5❌0,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/КСВВ5х0,5.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />КСВВ 5❌0,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/КСПВ4х0,5.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />КСПВ 4❌0,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/МКЭШ5х0,5.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />МКЭШ 5❌0,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/ПВС.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВС 3❌1',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 2❌1,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 2❌2,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 3❌1,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 3❌2,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 3❌4',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 4❌1,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 4❌2,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 5❌1,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 5❌2,5',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 5❌16 (тройная изоляция)',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 5❌2,5 ГОСТ',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 3❌2,5 ГОСТ',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 2❌2,5 ГОСТ',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 5❌1,5 ГОСТ',
        '<img src=\'/wp-content/uploads/2022/03/cond/Кабель/NYM.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> NYM 5❌1,5 ГОСТ',
        '<input class=\'cb pristine\' type=\'checkbox\' >Материал заказчика</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' >Монтаж заказчика</input>',
    ],
    screwcond: [
        '6️⃣,35(1/4)➖2️⃣шт.❌9️⃣,52(3/8)➖2️⃣шт.',
        '6️⃣,35(1/4)➖2️⃣шт.❌12,7(1/2)➖2️⃣шт.',
        '9️⃣,52(3/8)➖2️⃣шт.❌15,88(5/8)➖2️⃣шт.',
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\' checked>Заглушка</input>',
        '19,05(3/4)➖2️⃣шт.',
        '25,4(1)➖2️⃣шт.',
        '28,57(1-1/8)➖2️⃣шт.',
        '34,92(1-3/8)➖2️⃣шт.',
        'Не требуется',
        'Монтаж заказчика',
        'Материал заказчика',
    ],
    screwcondgas: [
        '9️⃣,52(3/8)➖2️⃣шт.',
        '---',
        'Заглушка',
        '9️⃣,52(3/8)➖1️⃣шт.',
        '12,7(1/2)➖2️⃣шт.',
        '12,7(1/2)➖1️⃣шт.',
        '15,88(5/8)➖2️⃣шт.',
        '15,88(5/8)➖1️⃣шт.',
        '19,05(3/4)➖2️⃣шт.',
        '19,05(3/4)➖1️⃣шт.',
        '25,4(1)➖2️⃣шт.',
        '25,4(1)➖1️⃣шт.',
        '28,57(1-1/8)➖2️⃣шт.',
        '28,57(1-1/8)➖1️⃣шт.',
        '34,92(1-3/8)➖2️⃣шт.',
        '34,92(1-3/8)➖1️⃣шт.',
        'Не требуется',
        'Монтаж заказчика',
        'Материал заказчика',
    ],
    screwcondliquid: [
        '6️⃣,35(1/4)➖2️⃣шт.',
        '---',
        'Заглушка',
        '6️⃣,35(1/4)➖1️⃣шт.',
        '9️⃣,52(3/8)➖2️⃣шт.',
        '9️⃣,52(3/8)➖1️⃣шт.',
        '12,7(1/2)➖2️⃣шт.',
        '12,7(1/2)➖1️⃣шт.',
        '15,88(5/8)➖2️⃣шт.',
        '15,88(5/8)➖1️⃣шт.',
        '19,05(3/4)➖2️⃣шт.',
        '19,05(3/4)➖1️⃣шт.',
        '25,4(1)➖2️⃣шт.',
        '25,4(1)➖1️⃣шт.',
        '28,57(1-1/8)➖2️⃣шт.',
        '28,57(1-1/8)➖1️⃣шт.',
        '34,92(1-3/8)➖2️⃣шт.',
        '34,92(1-3/8)➖1️⃣шт.',
        'Не требуется',
        'Монтаж заказчика',
        'Материал заказчика',
    ],
    cransteins: [
        'Оц.<img src=\'/wp-content/uploads/2022/03/кранштейн кондиционера.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H415❌L450➖50кг. Ral➖9003',
        'Оц.<img src=\'/wp-content/uploads/2022/03/кранштейн кондиционера.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H400❌L420➖30кг. Ral➖9003',
        '---',
        'Оц.<img src=\'/wp-content/uploads/2022/03/кранштейн кондиционера.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H500❌L600➖100кг. Ral➖9003',
        'Оц.<img src=\'/wp-content/uploads/2022/03/Кранштейн кондиционера 1000х700.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H830❌L677➖150кг. Ral➖9003',
        'Оц.<img src=\'/wp-content/uploads/2022/03/Кранштейн кондиционера 1000х700.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>H1000❌L700➖150кг. Ral➖9003',
        'Траверса 30<img src=\'/wp-content/uploads/2022/03/cond/На потолке.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\'/> L➖700❌H-1000(М8➖150кг)',
        'Траверса 30<img src=\'/wp-content/uploads/2022/03/cond/На потолке.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\'/> L➖700❌H-2000(М10➖200кг)',
        'Kernick AVS 40 4шт/комплект (до 40 кг)',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ДО-38-19кг комплект 4 шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ДО-39-33кг</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ДО-40-42кг</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ДО-41-76кг</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ДО-42-116кг</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ДО-43-206кг</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ДО-44-297.9кг</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/cond/vibro.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ДО-45-466кг</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> RexFaber <img src=\'/wp-content/uploads/2022/03/cond/RF-V40P.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> RF-V40P комплект 4 шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> RexFaber <img src=\'/wp-content/uploads/2022/03/cond/RF-V60P.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> RF-V60P комплект 4 шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> RexFaber <img src=\'/wp-content/uploads/2022/03/cond/RF-V120P.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> RF-V120P комплект 4 шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> RexFaber <img src=\'/wp-content/uploads/2022/03/cond/RFPMM40.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> RF-PMM40 ▶️40кг комплект 4 шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> RexFaber <img src=\'/wp-content/uploads/2022/03/cond/RFPMM65.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> RF-PMM65 ▶️65кг комплект 4 шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> RexFaber <img src=\'/wp-content/uploads/2022/03/cond/RFPMM120.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> RF-PMM120 ▶️120кг комплект 4 шт.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/WTG-AG35.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> WTG-AG35</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/WTG-AG45.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> WTG-AG45</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> RexFaber <img src=\'/wp-content/uploads/2022/03/cond/RexFaber RF-Vibro T 40.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> RF-Vibro T 40</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> RexFaber <img src=\'/wp-content/uploads/2022/03/cond/WT 112.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> WT 112</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/ВР201.png\' class=\'scale\' style=\'width: 35px; height: auto;\' /> ДО-38(MNDDZb2)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/ВР201.png\' class=\'scale\' style=\'width: 35px; height: auto;\' /> ДО-39(MNDDZb3)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/ВР201.png\' class=\'scale\' style=\'width: 35px; height: auto;\' /> ДО-41(MNDDZb5)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/ВР201.png\' class=\'scale\' style=\'width: 35px; height: auto;\' /> ДО-42(MNDDZb8)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/ВР201.png\' class=\'scale\' style=\'width: 35px; height: auto;\' /> ДО-43(MNDDZ20)</input>',
        'Оц.Ус.H400❌L420➖30кг.',
        'Оц.Ус.H415❌L450➖50кг.',
        'Оц.Ус.H500❌L600-100кг.',
        'Оц.Ус.H830❌L677➖150кг.',
        'Оц.Ус.H1000❌L700➖150кг.',
        'Нерж.AISI201.H400❌L420➖30кг.',
        'Нерж.AISI201.H415❌L450➖50кг.',
        'Нерж.AISI201.H500❌L600➖100кг.',
        'Нерж.AISI201.H830❌L677➖150кг.',
        'Нерж.AISI201.H1000❌L700➖150кг.',
        'Нерж.AISI430.H400❌L420➖30кг.',
        'Нерж.AISI430.H415❌L450➖50кг.',
        'Нерж.AISI430.H500❌L600➖100кг.',
        'Нерж.AISI430.H830❌L677➖150кг.',
        'Нерж.AISI430.H1000❌L700➖150кг.',
        'Нерж.Усилен.AISI201.H400❌L420➖30кг.',
        'Нерж.Усилен.AISI201.H415❌L450➖50кг.',
        'Нерж.Усилен.AISI201.H500❌L600➖100кг.',
        'Нерж.Усилен.AISI201.H830❌L677➖150кг.',
        'Нерж.Усилен.AISI201.H1000❌L700➖150кг.',
        'Нерж.Усилен.AISI304.H400❌L420➖30кг.',
        'Нерж.Усилен.AISI304.H415❌L450➖50кг.',
        'Нерж.Усилен.AISI304.H500❌L600➖100кг.',
        'Нерж.Усилен.AISI304.H830❌L677➖150кг.',
        'Нерж.Усилен.AISI304.H1000❌L700➖150кг.',
        'Углер.ст.H400❌L420➖30кг.',
        'Углер.ст.H415❌L450➖50кг.',
        'Углер.ст.H500❌L600➖100кг.',
        'Углер.ст.H830❌L677➖150кг.',
        'Углер.ст.H1000❌L700➖150кг.',
        '<h4>Подставка <img src=\'/wp-content/uploads/2022/03/Подставка разборная.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /> разборная</h4>',
        'Материал заказчика',
    ],
    drainage: [
        '---',
        '<img src=\'/wp-content/uploads/2022/03/cond/ПВХ гиб.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВХ,гиб.арм.Ø1️⃣6️⃣',
        '<img src=\'/wp-content/uploads/2022/03/cond/ПВХ гиб.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВХ,гиб.арм.2️⃣0️⃣',
        '<img src=\'/wp-content/uploads/2022/03/cond/ПВХ гиб.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВХ,гиб.арм.25',
        '<img src=\'/wp-content/uploads/2022/03/cond/Металлопласт.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Металлопласт.Ø1️⃣6️⃣',
        '<img src=\'/wp-content/uploads/2022/03/cond/Металлопласт.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Металлопласт.2️⃣0️⃣',
        '<img src=\'/wp-content/uploads/2022/03/cond/Металлопласт.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Металлопласт.25',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/Сифон/СтопМух.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Фильтр дренажа СтопМух</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> <img src=\'/wp-content/uploads/2022/03/cond/Сифон/Распылитель.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Распылитель</input>',
        '<img src=\'/wp-content/uploads/2022/03/cond/Полипропилен.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВХ,жест.Ø1️⃣6️⃣',
        '<img src=\'/wp-content/uploads/2022/03/cond/Полипропилен.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВХ,жест.20',
        '<img src=\'/wp-content/uploads/2022/03/cond/Полипропилен.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> ПВХ,жест.25',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/PROFcool MSP 16-32 мембранный сифон с сухим затвор.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> PROFcool MSP 16-32 мембранный сифон с сухим затвором',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/PROFcool SCU-032 сифон с обратным клапаном.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> PROFcool SCU-032 сифон с обратным клапаном',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/PROFcool VSP-32 капельная воронка с двумя клапанам.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> PROFcool VSP-32 капельная воронка с двумя клапанам',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/Сифон Rex Faber G-35 MINI.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Сифон Rex Faber G-35 MINI',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/Сифон G-34-1 Y Rex Faber.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Сифон G-34-1 Y Rex Faber',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/Сифон Rex Faber G-33.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Сифон Rex Faber G-33',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/Сифон Rex Faber G-34-1.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Сифон Rex Faber G-34-1',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/Сифон RexFaber G-33-П(прозрачный).png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Сифон RexFaber G-33-П(прозрачный)',
        '<img src=\'/wp-content/uploads/2022/03/cond/Сифон/Сифон RexFaber RF-ReGO.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Сифон RexFaber RF-ReGO',
        'Материал заказчика',
    ],
    trackdrainage: ['---', '3', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '60', '70', '80', '90', '100', 'Прокладка(монтаж) заказчика'],
    pump: [
        '---',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кондиционер/Помпа/DС Pump Pro (проточный, 12).png\' class=\'scale\' style=\'width: 50px; height: auto;\' />DС Pump Pro (проточный, 12 л/ч)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кондиционер/Помпа/DС Pump Pro (проточный, 18 лч).png\' class=\'scale\' style=\'width: 50px; height: auto;\' />DС Pump Pro (проточный, 18 л/ч)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кондиционер/Помпа/Aspen Mini Aqua (проточный, 12 лч).webp\' class=\'scale\' style=\'width: 50px; height: auto;\' />Aspen Mini Aqua (проточный, 12 л/ч) / AA Mini Lift Pump</h4>',
        'Aspen Mini Orange(проточный, 12 л/ч)/AO Mini Lift Pump',
        'CondiPump Hi Lift (накопительный, 380 л/ч)',
        'CondiPump DC Tank Pro (моноблочный, 18 л/ч)',
        'DС Tank (моноблочный, 28 л/ч)',
        'Проточный, 15 л/ч',
        'Проточный, 18 л/ч',
        'CondiPump Nebulizer (система распыления конденсата, 15 л/ч)',
        'TOP Power (накопительный, 125 л/ч)',
        'MUTE BOX 40 л/ч', 'MUTE WEDGE накопительный 40 л/ч)',
        'Tranquil',
        'Материал заказчика',
    ],
    winter: [
        '---',
        'Снегирь',
        '<input class=\'cb pristine\' type=\'checkbox\' >Регулятор давления конденсации SD-1/3U-5A (полупром)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' >Нагреватель дренажа BALLU ND-500мм</input>',
        'Материал заказчика',
    ],
    rotation: [
        '---',
        '<img src=\'/wp-content/uploads/2022/03/cond/rotation/БУРР-1М.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> БУРР➖1М',
        '<img src=\'/wp-content/uploads/2022/03/cond/rotation/БИС-1М.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> БИС➖1М',
        '<img src=\'/wp-content/uploads/2022/03/cond/rotation/УРК-2М.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> УРК➖2М',
        '<img src=\'/wp-content/uploads/2022/03/cond/rotation/УРК-2Т.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> УРК➖2Т',
        'Материал заказчика',
    ],
    visor: [
        '---',
        '<img src=\'/wp-content/uploads/2022/03/козырек.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 800❌500',
        '<img src=\'/wp-content/uploads/2022/03/козырек.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 900❌550',
        '<img src=\'/wp-content/uploads/2022/03/козырек.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 1000❌550',
        '<img src=\'/wp-content/uploads/2022/03/козырек.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/> 1100❌625',
        'Материал заказчика',
    ],
    roomvisor: [
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\' > <img src=\'/wp-content/uploads/2022/03/cond/Монтажная пластина.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Монтажная пластина ВБ</input>',
        'Экран универсальный для настенных кондиционеров 700-1100',
        'Экран для настенных кондиционеров 800', 'Экран для настенных кондиционеров 900',
        'Экран для кассетного кондиционера Смарт 650',
        'Экран для кассетного кондиционера Смарт 950',
        'Материал заказчика',
    ],
    vandal: [
        '---',
        '<img src=\'/wp-content/uploads/2022/03/cond/1.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>Корзина 1️⃣ ',
        '<img src=\'/wp-content/uploads/2022/03/cond/2.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>Корзина 2️⃣ ',
        '<img src=\'/wp-content/uploads/2022/03/cond/3.png\' alt=\'\' class=\'scale\' style=\'width: 50px; height: auto;\'/>Корзина 3️⃣ ',
        'Цвет корзины',
        'Цвет козырька',
        'Решетка',
        'Ограждение разборное 500х800х600',
        'Ограждение 500х1000х600',
        'Ограждение 700х1200х1000',
        'Ограждение 700х1200х1400',
        'Материал заказчика'
    ],
    typegasket: [
        '---',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 60❌60</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 60❌40</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 80❌60</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 100❌60</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Метал лоток.webp\' class=\'scale\' style=\'width: 50px; height: auto;\' /> Метал.лоток 100х60</h4>',
        '<input class=\'cb pristine\' type=\'radio\' name=\'Трасса\' value=\'Трасса снаружи\'><a href=\'#popmake-6528\'><img src=\'/wp-content/uploads/2022/03/cond/Трасса снаружи.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /></a> Трасса снаружи</input>',
        '<input class=\'cb pristine\' type=\'radio\' name=\'Трасса\' value=\'Трасса внутри\'><a href=\'#popmake-6531\'><img src=\'/wp-content/uploads/2022/03/cond/Трасса внутри.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' /></a> Трасса внутри</input>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Штроба.webp\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 60❌40</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Штроба.webp\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 80❌60</h4>',
        'Прокладка заказчика', '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> К/к 40х40</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 40❌25</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 40❌16</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 25❌25</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 25❌16</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 20❌10</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 16❌16</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 15❌10</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Кабель канал.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> 12❌12</h4>',
    ],
    place: [
        '---',
        '<img src=\'/wp-content/uploads/2022/03/cond/place/Под окно.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Под окном',
        'Цвет короба трассы',
        '<img src=\'/wp-content/uploads/2022/03/cond/place/Сбоку от окна.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сбоку от окна',
        '<img src=\'/wp-content/uploads/2022/03/cond/.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />На стене здания на балконе/лоджии',
        '<img src=\'/wp-content/uploads/2022/03/cond/.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />На бортике бетонного балкона/лоджии',
        '<img src=\'/wp-content/uploads/2022/03/cond/.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />На бортике рамного балкона',
        '<h4> 1️⃣ <img src=\'/wp-content/uploads/2024/05/1.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/7.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/11.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> <img src=\'/wp-content/uploads/2024/05/12.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /></h4>',
        '<h4> 2️⃣ <img src=\'/wp-content/uploads/2024/05/2.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 3️⃣ <img src=\'/wp-content/uploads/2024/05/3.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 4️⃣ <img src=\'/wp-content/uploads/2024/05/4.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 5️⃣ <img src=\'/wp-content/uploads/2024/05/5.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 6️⃣ <img src=\'/wp-content/uploads/2024/05/6.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 7️⃣ </h4>',
        '<h4> 8️⃣ <img src=\'/wp-content/uploads/2024/05/8.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 9️⃣ <img src=\'/wp-content/uploads/2024/05/9.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣0️⃣ <img src=\'/wp-content/uploads/2024/05/10.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣1️⃣ </h4>',
        '<h4> 1️⃣2️⃣  </h4>',
        '<h4> 1️⃣3️⃣ <img src=\'/wp-content/uploads/2024/05/13.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>',
        '<h4> 1️⃣4️⃣ <img src=\'/wp-content/uploads/2024/05/14.2.png\' class=\'scale\' style=\'width: 50px; height: auto;\' /> </h4>'
    ],
    front: [
        '---',
        'Обычная стена',
        'Утепленный фасад',
        'Вентилируемый фасад',
        'Сайдинг',
        'Керамогранит',
        'Разборка(сборка) заказчика',
    ],
    wall: [
        '---',
        'Панельный дом до 50см',
        'Кирпичный дом до 100см',
        'Кирпичный дом свыше 100см',
        '<input class="cb pristine" type="checkbox">Внутренняя стена</input>',
        '<input class="cb pristine" type="checkbox">Внутренняя стена гипс/фанера</input>',
        '<input class="cb pristine" type="checkbox">Внутренняя стена кирпич</input>',
        '<input class="cb pristine" type="checkbox">Внутренняя стена бетон</input>',
        '<input class="cb pristine" type="checkbox">Внутренняя стена толщина и кол-во шт</input>',
        'Монолит до 100см',
        'Монолит свыше 100см',
        'Сталинский дом свыше 100см',
        'Деревянные стены',
        'Не могу определить',
        'П-3', 'П-30', 'П-44', 'П-44Т',
        'П-46', 'КОПЭ', 'II-68', 'II-18/12', 'П-3М', 'П-43', 'П-44М', 'П-55', 'П-55М', 'ПД-4', 'И-209А',
        'И-491А', 'И-522А', 'И-700А', '1-510', '1-511', '1-515/5', '1-515/9', '1605/9', '1605/12', 'II-01',
        'II-02', 'II-03', 'II-04', 'II-18/9', 'II-29', 'II-49', 'II-57', 'II-68/02', 'II-68/03', 'II-67 МОСКВ.',
        'II-67 СМИРН.', 'II-67 ТИШ.', 'Б. ВУЛЫХА'
    ],
    special: [
        '---',
        '<img src=\'/wp-content/uploads/2022/03/cond/special/Работа на лестнице.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Работа на лестнице',
        '<img src=\'/wp-content/uploads/2022/03/cond/special/Автовышка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Автовышка 2ч.',
        '<img src=\'/wp-content/uploads/2022/03/cond/special/Автовышка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Автовышка 4ч.',
        '<img src=\'/wp-content/uploads/2022/03/cond/special/Автовышка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Автовышка 6ч.',
        '<img src=\'/wp-content/uploads/2022/03/cond/special/Автовышка-площадка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Автовышка-площадка 2ч.',
        '<img src=\'/wp-content/uploads/2022/03/cond/special/Вышка-тура.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Вышка-тура',
        '<img src=\'/wp-content/uploads/2022/03/cond/special/Пром_альпинист.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Пром.альпинист 2ч.',
        '<input class=\'cb pristine\' type=\'checkbox\' ><img src=\'/wp-content/uploads/2022/03/cond/special/Манипулятор.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Манипулятор 2ч.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' ><img src=\'/wp-content/uploads/2022/03/cond/special/Автокран.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Автокран 2ч.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' >Организует(оплата) заказчик</input>'
    ],
    additional: [
        '---',
        'Дополнительная трасса свыше 5м.',
        'Штробление стены для трассы',
        'Штробление стены для дренажа',
        'Дополнительный электрический кабель',
        'Дополнительный короб для трассы',
        'Подъем при отсутствии лифта',
        'Доставка по области'
    ],
    cecktoolscond: [
        '---',
        '1️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/перфоратор 5_3Дж.png" class="scale" style="width: 40px; height: auto;" />Большой перфоратор 5.3Дж</input>',
        '2️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Пылесос.png" class="scale" style="width: 40px; height: auto;" />Пылесос</input>',
        '3️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/перфоратор 1_2Дж.png" class="scale" style="width: 40px; height: auto;" />Маленький перфоратор 1.2Дж</input>',
        '4️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Шуруповерт.png" class="scale" style="width: 40px; height: auto;" />Шуруповерт</input>',
        '5️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Тестер.png" class="scale" style="width: 20px; height: auto;" />Тестер/Мультиметр/Клещи</input>',
        '6️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Большой бур.png" class="scale" style="width: 40px; height: auto;" />Большой бур (32 - 45 L1000)</input>',
        '7️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Бур6.png" class="scale" style="width: 40px; height: auto;" />Бур Ø6 L-200</input>',
        '8️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Бур8.png" class="scale" style="width: 40px; height: auto;" />Бур Ø8 L-200</input>',
        '9️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Бур10.png" class="scale" style="width: 40px; height: auto;" />Бур Ø10 L-200</input>',
        '1️⃣0️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Бур12.png" class="scale" style="width: 40px; height: auto;" />Бур Ø12 L-200</input>',
        '1️⃣1️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Бур14.png" class="scale" style="width: 40px; height: auto;" />Бур Ø14 L-200</input>',
        '1️⃣2️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Бур16.png" class="scale" style="width: 40px; height: auto;" />Бур Ø16 L-200</input>',
        '1️⃣3️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Вакуматор.png" class="scale" style="width: 40px; height: auto;" />Вакуумный насос 40л 1ступ.</input>',
        '1️⃣3️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Вакуматор.png" class="scale" style="width: 40px; height: auto;" />Вакуумный насос 60л 2ступ</input>',
        '1️⃣4️⃣<input class="cb pristine" type="checkbox" checked><img src="/wp-content/uploads/2022/03/cond/Tools/Переноска.png" class="scale" style="width: 40px; height: auto;" />Переноска (удлинитель)-20м.</input>',
        '1️⃣5️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Бита для шуруповерта.png" class="scale" style="width: 40px; height: auto;" />Бита для шуруповерта</input>',
        '1️⃣6️⃣<input class="cb pristine" type="checkbox" checked ><img src="/wp-content/uploads/2022/03/cond/Tools/Пружины.png" class="scale" style="width: 40px; height: auto;" />Пружины (трубогиб)</input>',
        '1️⃣7️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Шестигранники.png" class="scale" style="width: 40px; height: auto;" />Шестигранники (набор)6-12</input>',
        '1️⃣8️⃣<input class="cb pristine" type="checkbox">18. Ключ рожковый 14</input>',
        '1️⃣9️⃣<input class="cb pristine" type="checkbox">19. Ключ рожковый 17</input>',
        '2️⃣0️⃣<input class="cb pristine" type="checkbox">20. Ключ разводной 22</input>',
        '2️⃣1️⃣<input class="cb pristine" type="checkbox">21. Ключ разводной 24</input>',
        '2️⃣2️⃣<input class="cb pristine" type="checkbox">22. <img src="/wp-content/uploads/2022/03/cond/Tools/Горелка.png" class="scale" style="width: 40px; height: auto;" />Горелка</input>',
        '2️⃣3️⃣<input class="cb pristine" type="checkbox">23. <img src="/wp-content/uploads/2022/03/cond/Tools/Мешок для мусора.png" class="scale" style="width: 40px; height: auto;" />Мешок для мусора</input>',
        '2️⃣4️⃣<input class="cb pristine" type="checkbox">24. <img src="/wp-content/uploads/2022/03/cond/Tools/Нож разделки кабеля.png" class="scale" style="width: 40px; height: auto;" />Нож разделки кабеля</input>',
        '2️⃣5️⃣<input class="cb pristine" type="checkbox">25. Отвертка +</input>',
        '2️⃣6️⃣<input class="cb pristine" type="checkbox">26. Отвертка -</input>',
        '2️⃣7️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Головка-бита 13.png" class="scale" style="width: 40px; height: auto;" />Головка-бита 13</input>',
        '2️⃣8️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Ключ рожковый 13.png" class="scale" style="width: 40px; height: auto;" />Ключ рожковый 13</input>',
        '2️⃣9️⃣<input class="cb pristine" type="checkbox" checked ><img src="/wp-content/uploads/2022/03/cond/Рулетка.png" class="scale" style="width: 40px; height: auto;" />Рулетка</input>',
        '3️⃣0️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Уровень.png" class="scale" style="width: 40px; height: auto;" />Уровень</input>',
        '3️⃣0️⃣ 1️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Лазерный уровень.png" class="scale" style="width: 40px; height: auto;" />Лазерный уровень</input>',
        '3️⃣1️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Пистолет для силикона.png" class="scale" style="width: 40px; height: auto;" />Пистолет для силикона (герметика)</input>',
        '3️⃣2️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Пистолет для пены.png" class="scale" style="width: 40px; height: auto;" />Пистолет для пены</input>',
        '3️⃣3️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Штроборез.png" class="scale" style="width: 40px; height: auto;" />Штроборез</input>',
        '3️⃣4️⃣<input class="cb pristine" type="checkbox">34. Пика L-500</input>',
        '3️⃣5️⃣<input class="cb pristine" type="checkbox">35. Молоток</input>',
        '3️⃣6️⃣<input class="cb pristine" type="checkbox">36. Кусачки</input>',
        '3️⃣7️⃣<input class="cb pristine" type="checkbox">37. Пассатижи</input>',
        '3️⃣8️⃣<input class="cb pristine" type="checkbox">38. Ключ трещетка</input>',
        '3️⃣9️⃣<input class="cb pristine" type="checkbox">39. Набор головок 6, 8, 10, 12, 13, 14, 17, 19, 22</input>',
        '4️⃣0️⃣<input class="cb pristine" type="checkbox">40. Гибкий удлинитель для бит</input>',
        '4️⃣1️⃣<input class="cb pristine" type="checkbox">41. Малый баллон(азот)-по необходимости</input>',
        '4️⃣2️⃣<input class="cb pristine" type="checkbox">42. Алмазная дрель</input>',
        '4️⃣3️⃣<input class="cb pristine" type="checkbox">43. Ф20-Коронка алмазная</input>',
        '4️⃣4️⃣<input class="cb pristine" type="checkbox">44. Ф30-Коронка алмазная</input>',
        '4️⃣5️⃣<input class="cb pristine" type="checkbox">45. Ф40-Коронка алмазная</input>',
        '4️⃣6️⃣<input class="cb pristine" type="checkbox">46. Ф50-Коронка алмазная</input>',
        '4️⃣7️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Вальцовка.png" class="scale" style="width: 40px; height: auto;" />Вальцовка</input>',
        '4️⃣8️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Манометры.png" class="scale" style="width: 40px; height: auto;" />Манометры</input>',
        '4️⃣9️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Болгарка 125малая(УШМ).png" class="scale" style="width: 40px; height: auto;" />Болгарка 125малая(УШМ)</input>',
        '5️⃣0️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Болгарка 150большая(УШМ).png" class="scale" style="width: 40px; height: auto;" />Болгарка 150большая(УШМ)</input>',
        '5️⃣1️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Набор со сверлами.png" class="scale" style="width: 40px; height: auto;" />Набор со сверлами</input>',
        '5️⃣2️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Ступенчатое сверло.png" class="scale" style="width: 40px; height: auto;" />Ступенчатое сверло</input>',
        '5️⃣3️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Стремянка.png" class="scale" style="width: 40px; height: auto;" />Стремянка трансформер</input>',
        '5️⃣4️⃣<input class="cb pristine" type="checkbox">54. Лестница</input>',
        '5️⃣5️⃣<input class="cb pristine" type="checkbox">55. Карандаш</input>',
        '5️⃣6️⃣<input class="cb pristine" type="checkbox">56. Маркер</input>',
        '5️⃣7️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Труборез.png" class="scale" style="width: 40px; height: auto;" />Труборез</input>',
        '5️⃣8️⃣<input class="cb pristine" type="checkbox" checked ><img src="/wp-content/uploads/2022/03/cond/Tools/Гратосниматель.png" class="scale" style="width: 40px; height: auto;" />Гратосниматель</input>',
        '5️⃣9️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Ример.png" class="scale" style="width: 40px; height: auto;" />Ример</input>',
        '6️⃣0️⃣<input class="cb pristine" type="checkbox">60. Припой</input>',
        '6️⃣1️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/ПВХ стяжки.png" class="scale" style="width: 40px; height: auto;" />ПВХ стяжки</input>',
        '6️⃣2️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Очки.png" class="scale" style="width: 40px; height: auto;" />Очки</input>',
        '6️⃣3️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Зеркало инспеционное.png" class="scale" style="width: 40px; height: auto;" />Зеркало инспеционное</input>',
        '6️⃣4️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Круг отрезной 125.png" class="scale" style="width: 40px; height: auto;" />Круг отрезной 125</input>',
        '6️⃣5️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Круг отрезной 150.png" class="scale" style="width: 40px; height: auto;" />Круг отрезной 150</input>',
        '6️⃣6️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Выкручивание золотников под давлением.png" class="scale" style="width: 40px; height: auto;" />Выкручивание золотников под давлением</input>',
        '6️⃣7️⃣<input class="cb pristine" type="checkbox">67. Быстросъемы</input>',
        '6️⃣8️⃣<input class="cb pristine" type="checkbox">68. Ножницы разные</input>',
        '6️⃣9️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Кримпер.png" class="scale" style="width: 40px; height: auto;" />Кримпер</input>',
        '7️⃣0️⃣<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Фен.png" class="scale" style="width: 40px; height: auto;" />Фен</input>',
        '<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Аренда.png" class="scale" style="width: 40px; height: auto;" />Аренда</input>',
        '<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/special/Вышка-тура.png" class="scale" style="width: 50px; height: auto;" />Вышка-тура</input>',
        '<input class="cb pristine" type="checkbox"><img src="/wp-content/uploads/2022/03/cond/Tools/Ходули.png" class="scale" style="width: 40px; height: auto;" />Ходули</input>'
    ],
    drainagecap: ['---', 'ПВХ 6', 'ПВХ 8', 'Материал заказчика'],
    ТипВентилятора: ['---', 'VRB', 'кухонный'],
    ТипОхладителя: [
        'Вода(H2O) ➕7-12°С', 'Вода(H2O) ➕5-10°С', 'Пропиленгликоль', 'Этиленгликоль',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img title=\'R12 Дифтордихлорметан, -29,8°C, химическая формула CCl₂F₂\' src=\'/wp-content/uploads/2022/03/cond/Freon/R12.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> R12</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img title=\'R22 Дифторхлорметан, -40,8°C, химическая формула CHClF2\' src=\'/wp-content/uploads/2022/03/cond/Freon/R22.png\' class=\'scale\' style=\'width: 20px; height: auto;\' /> R22</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img title=\'R32 Дифторметан, -51,63°C, химическая формула CH2F2\' src=\'/wp-content/uploads/2022/03/cond/Freon/R32.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> R32</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img title=\'R134A Тетрафторэтан, -26,3°C, химическая формула CH2FCF3\' src=\'/wp-content/uploads/2022/03/cond/Freon/R134A.png\' class=\'scale\' style=\'width: 20px; height: auto;\' /> R134A</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img title=\'R290 Пропан, -42,1°C, химическая формула C3H8\'  src=\'/wp-content/uploads/2022/03/cond/Freon/R290.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> R290</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img title=\'R404A Околоазеотропная смесь из R125, R143a и R134a (44/52/4 масса-%), -46,6°C, химическая формула CHF2CF3 / CF3CH2F / CH3CF3\'  src=\'/wp-content/uploads/2022/03/cond/Freon/R404A.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> R404A</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img src=\'/wp-content/uploads/2022/03/cond/Freon/R407C.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> R407C</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img src=\'/wp-content/uploads/2022/03/cond/Freon/R407F.png\' class=\'scale\' style=\'width: 40px; height: 50px;\' /> R407F</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img title=\'R410A Неазеотропная смесь из 50% дифторметана R-32 и 50% пентафторэтана R-125, -48,5°C, химическая формула 50%CH2F2/50%CHF2CF3\' src=\'/wp-content/uploads/2022/03/cond/Freon/R410A.png\' class=\'scale\' style=\'width: 20px; height: 50px;\' /> R410A</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'          > <img src=\'/wp-content/uploads/2022/03/cond/Freon/R427A.png\' class=\'scale\' style=\'width: 40px; height: 50px;\' /> R427A</input>',
    ],
    siphon: ['---', 'RexFaber G-35 Mini', 'RexFaber G-33 (прозрачный)', 'PROFCOOL с обратным клапаном', 'Материал заказчика'],
    weightroom: ['---', '2', '2.3', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10'],
    heightroom: ['---', '2', '2.3', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10'],
    Hroom: ['---', '2', '2.3', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10'],
    concretegrade: [
        'БСТ В7.5 П3 М100',
        'БСТ В10 П3 М150',
        'БСТ В12,5 П3 М150',
        'БСТ В15 П3 М200',
        'БСТ В20 П3 М250',
        'БСТ В22,5 П3 М300',
        'БСТ В25 П3 М350',
        'БСТ В30 П3 М400',
        'БСТ В7,5 П4 М100',
        'БСТ В10 П4 М150',
        'БСТ В12,5 П4 М150',
        'БСТ В15 П4 М200',
        'БСТ В20 П4 М250',
        'БСТ В22,5 П4 М300',
        'БСТ В25 П4 М350',
        'БСТ В30 П4 М400',
        'БСМ В7,5 П3 М 100 Пк3',
        'БСМ В10 П3 М 150 Пк3',
        'БСМ В15 П3 М 200 Пк3',
        'БСМ В20 П3 М 250 Пк3',
        'БСМ В22,5 П3 М 300 Пк3',
        'БСМ В25 П3 М 350 Пк3',
        'БСЛ В3,5 П4 D1600 М50',
        'БСЛ В5 П4 D1600 М50',
        'БСЛ В7,5 П4 D1600 М100',
        'БСЛ В12,5 П4 D1600 М150',
        'БСЛ В15 П4 D1600 М200',
        'М50 Пк3', 'М75 Пк3',
        'М100 Пк3', 'М150 Пк3',
        'М200 Пк3',
        'М4',
        'М10',
        'М25'
    ],
    boxfiltersquarepocket: [
        '--',
        'G3-300-250ПА-1️⃣шт.',
        'G3-600-250ПА-1️⃣шт.',
        'G3-900-250ПА-1️⃣шт.',
        'G4-300-250ПА-1️⃣шт.',
        'G4-600-250ПА-1️⃣шт.',
        'G4-900-250ПА-1️⃣шт.',
        'M5-300-250ПА-1️⃣шт.',
        'M5-600-250ПА-1️⃣шт.',
        'M5-900-250ПА-1️⃣шт.',
        'F7-300-450ПА-1️⃣шт.',
        'F7-600-450ПА-1️⃣шт.',
        'F7-900-450ПА-1️⃣шт.',
        'F9-300-450ПА-1️⃣шт.',
        'F9-600-450ПА-1️⃣шт.',
        'F9-900-450ПА-1️⃣шт.'
    ],
    boxfiltersquarepanel: [
        '--',
        'G2-[65 £ Am < 80]-1️⃣шт.',
        'G3-[80 £ Am < 90]-1️⃣шт.',
        'G4-[90 £ Am]-1️⃣шт.',
        'G5-1️⃣шт.'
    ],
    boxfiltersquarecassette: [
        '--',
        'G2-[65 £ Am < 80]',
        'G3-[80 £ Am < 90]',
        'G4-[90 £ Am]',
        'M5',
        'F7',
        'F9'
    ],
    boxfilterroundpocket: ['--', 'G3-300', 'G3-600', 'G3-900', 'G4-300', 'G4-600', 'G4-900', 'M5-300', 'M5-600', 'M5-900', 'F7-300', 'F7-600', 'F7-900', 'F9-300', 'F9-600', 'F9-900'],
    boxfilterroundpanel: [
        '--',
        'G2-[65 £ Am < 80]',
        'G3-[80 £ Am < 90]',
        'G4-[90 £ Am]',
        'G5'
    ],
    boxfilterroundcassette: [
        '---',
        'G2-[65 £ Am < 80]',
        'G3-[80 £ Am < 90]',
        'G4-[90 £ Am]',
        'M5',
        'F7',
        'F9'
    ],
    filtersquarepocket: [
        'G3-[80 £ Am < 90]',
        'G4-[90 £ Am]',
        'M5',
        'F7',
        'F9'
    ],
    filtersquarepanel: [
        'G2-[65 £ Am < 80]',
        'G3-[80 £ Am < 90]',
        'G4-[90 £ Am]',
        'G5'
    ],
    filtersquarecassette: [
        'G2-[65 £ Am < 80]',
        'G3-[80 £ Am < 90]',
        'G4-[90 £ Am]',
        'M5',
        'F7',
        'F9'
    ],
    filterroundpocket: [
        'G3-[80 £ Am < 90]',
        'G4-[90 £ Am]',
        'M5',
        'F7',
        'F9'
    ],
    filterroundpanel: [
        'G2-[65 £ Am < 80]',
        'G3-[80 £ Am < 90]',
        'G4',
        'G5'
    ],
    filterroundcassette: [
        'G2-[65 £ Am < 80]',
        'G3-[80 £ Am < 90]',
        'G4-[90 £ Am]',
        'M5',
        'F7',
        'F9'
    ],
    quantity: ['---', '+1️⃣шт.', '+2️⃣шт.', '+3️⃣шт.', '4️⃣шт.', '5️⃣шт.', '6шт.', '7шт.', '8шт.', '9шт.', '10шт.', '11шт.', '12шт.', '13шт.', '1-шт.', '15шт.', '16шт.', '17шт.', '18шт.', '19шт.', '20шт.'],
    filterpocket: ['3️⃣', '6️⃣', '9️⃣'],
    lengthpocket: ['300', '600', '900'],
    framepocket: ['20', '25'],
    framepanel: ['48', '96', '100'],
    framecassette: ['48', '96', '100'],
    framehepa: ['30', '78', '100'],
    plaster: ['Гипсовая', 'Декоративная', 'Короед', 'Ротбанд', 'Цементная смесь', 'Ветонит'],
    cirdim: ['100', '125', '140', '160', '180', '200', '225', '250', '280', '315', '355', '400', '450', '500', '560', '630', '710', '800', '900', '1000', '1120', '1250', '1400', '1600', '1800', '2000', '2250', '2500'],
    length: ['1250', '1500'],
    Radius: ['125', '150'],
    vibro: [
        '---',
        'ДО-38-19кг',
        'ДО-39-33кг',
        'ДО-40-42кг',
        'ДО-41-76кг',
        '<input class=\'cb pristine\' type=\'checkbox\'>2шт</input>',
        'ДО-42-116кг',
        'ДО-43-206кг',
        'ДО-44-297.9кг',
        'ДО-45-466кг',
        'ДО-38(MNDDZb2)',
        'ДО-39(MNDDZb3)',
        'ДО-41(MNDDZb5)',
        'ДО-42(MNDDZb8)',
        'ДО-43(MNDDZ20)',
        'ВР-201',
        'ВР-202',
        'ВР-203',
        'Крепление для ВР 200'
    ],
    vibrocount: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    sq: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    hq: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    ssq: [
        '---',
        '<option value=\'5\'>Автомойка</option>',
        '<option value=\'2\'>Автостоянка</option>',
        '<option value=\'20\'>Автосервис</option>',
        '<option value=\'4\'>Бассейн</option>',
        '<option value=\'5\'>Гараж</option>',
        '<option value=\'1\'>Жилье</option>',
        '<option value=\'3\'>Котельная</option>',
        '<option value=\'4\'>Кухня</option>',
        '<option value=\'6\'>Лаборатория</option>',
        '<option value=\'1\'>Магазин</option>',
        '<option value=\'3\'>Офис</option>',
        '<option value=\'50\'>Покрасочный цех</option>',
        '<option value=\'10\'>Прачечная</option>',
        '<option value=\'3.5\'>Ресторан-цех</option>',
        '<option value=\'1.5\'>Ресторан-зал</option>',
        '<option value=\'1\'>Склад</option>',
        '<option value=\'5\'>Спортзал</option>',
        '<option value=\'4\'>Школьный класс</option>'
    ],
    servicevent: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    serviceventel: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    serviceventrw: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    serviceventrel: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    serviceventout: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    servicehumi: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    servicecondindoorwall: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    servicecondindoorcassete: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    servicecondindoorcanal: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    servicecondoutdoor: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    servicecondoutdoorkkb: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    servicecondoutdoorchiller: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    serviceadd: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    veilel: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    veilw: ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    purpose: ['---', 'Клубника', 'Цветы', 'Редиска'],
    sensoroutdoor: ['---', 'Уличный темп.датчик 5м.', 'Уличный темп.датчик 10м.', 'Уличный темп.датчик 15м.', 'Уличный темп.датчик 20м.', '25м.', '30м.'],
    sensorindoor: ['---', 'Датчик темп.помещения 5м.', 'Датчик темп.помещения 10м.', 'Датчик темп.помещения 15м.', 'Датчик темп.помещения 20м.', '25м.', '30м.'],
    sensorcanal: ['---', 'Датчик темп. в канале 5м.', 'Датчик темп. в канале 10м.', 'Датчик темп. в канале 15м.', 'Датчик темп. в канале 20м.', '25м.', '30м.'],
    sensorhumicanal: ['---', 'Датчик влажности в канале 5м.', 'Датчик влажности в канале 10м.', 'Датчик влажности в канале 15м.', 'Датчик влажности в канале 20м.', '25м.', '30м.'],
    sensorhumiindoor: ['---', 'Датчик влажности помещения 5м.', 'Датчик влажности помещения 10м.', 'Датчик влажности помещения 15м.', 'Датчик влажности помещения 20м.', '25м.', '30м.'],
    sensorfiltercanal: ['---', 'Датчик фильтра в канале 5м.', 'Датчик фильтра в канале 10м.', 'Датчик фильтра в канале 15м.', 'Датчик фильтра в канале 20м.', '25м.', '30м.'],
    sensorrecuperator: ['---', 'Датчик рекуператора 5м.', 'Датчик рекуператора 10м.', 'Датчик рекуператора 15м.', 'Датчик рекуператора 20м.', '25м.', '30м.'],
    driverecuperator: ['---', 'Мотор рекуператора 5м.', 'Мотор рекуператора 10м.', 'Мотор рекуператора 15м.', 'Мотор рекуператора 20м.', '25м.', '30м.'],
    sensorfilterindoor: ['---', 'Датчик фильтра помещения (H11-13)5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    drivein: ['---', 'Привод возд. заслонки приток', 'Привод возд. заслонки приток + контроль положения 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    driveinheat: ['---', 'Подогрев Привод возд. заслонки 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    driveout: ['---', 'Привод возд. заслонки вытяжки', 'Привод возд. заслонки вытяжки + контроль положения 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    powerinvent: ['---', 'Приточный вентилятор 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    tkinvent: ['---', 'термо контакт Приточный вентилятор 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    poweroutvent: ['---', 'Вытяжной вентилятор 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    tkoutvent: ['---', 'термо контакт Вытяжной вентилятор 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    powerpump: ['---', 'Водяной насос 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    sensortkelheat: ['---', 'ТК 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    smesvalvecontrol: ['---', '3х ходовой 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    smesoutsensor: ['---', 'Датчик обратки 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    aztcontrol: ['---', '2м', '3м', '4м', '6м', '12м', 'Защита от замерзания (каппиляр) 5м', '10м', '15м', '20м', '25м', '30м'],
    firealarmcontrol: ['---', 'Подключение 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    freqpower: ['---', 'ЧП', 'Транс', 'Диммер 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    wirepowerelheat: ['---', 'ВВГ 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    coolcontrol: ['---', 'ВВГ 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    wirepower: ['---', 'ВВГ 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    controlpower: ['---', 'КВВГ', 'ВВГ', 'ПВС', 'ШВВП', 'МКЭШ 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    wirepowerflap: ['---', 'ВВГ 5м.', '10м.', '15м.', '20м.', '25м.', '30м.'],
    wire: ['---', 'В гофре', 'В металлорукав', 'В лотке'],
    box: ['---', 'На стене', 'На стойке'],
    customization: ['---', 'Настройка параметров'],
    commissioning: ['---', 'Пусконаладка'],
    invalve: ['<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В С пружинным возвратом</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В Реверсивный</h4>',
        '<h4>---</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Доп.привод на подмес</input></h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Доп.привод на рециркуляцию</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋24В Пропорциональный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋24В Реверсивный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋24В С пружинным возвратом</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋12В Пропорциональный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋12В Реверсивный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋12В С пружинным возвратом</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> С предпусковым оттаиванием</h4>'],
    outvalve: [
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В С пружинным возвратом</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В Реверсивный</h4>',
        '<h4>---</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Доп.привод на подмес</input></h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Доп.привод на рециркуляцию</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋24В Пропорциональный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋24В Реверсивный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋24В С пружинным возвратом</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋12В Пропорциональный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋12В Реверсивный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋12В С пружинным возвратом</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Привод.webp\' title=\'Привод приточного клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> С предпусковым оттаиванием</h4>'
    ],
    outvalveq: [
        '<h4><input class=\'\' type=\'radio\' id1=\'1\' name=\'Pump\' value=\'400\' title=\'Выбирайте напряжение насоса\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 60px; height: auto;\'/> ~400/3</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'Pump\' value=\'230\' title=\'Выбирайте напряжение насоса\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 60px; height: auto;\'/> ~230/1</input><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Esbe.png\' title=\'Привод клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋24В (0-10В, 6Нм)</h4>',
        '<h4>---</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Esbe.png\' title=\'Привод клапана\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 🔋24В (0-10В, 6Нм)<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 60px; height: auto;\'/> ~230/1</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Esbe.png\' title=\'\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>🔋24В<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 60px; height: auto;\'/> ~230/1</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Esbe.png\' title=\'\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>~230В<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 60px; height: auto;\'/> ~230/1</h4>',
        '<h4><input class=\'\' type=\'radio\' id1=\'1\' name=\'Pump\' value=\'400\' title=\'Выбирайте напряжение насоса\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный насос ~400/3\' alt=\'Циркуляционный насос ~400/3\' class=\'scale\' style=\'width: 60px; height: auto;\'/> ~400/3</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'Pump\' value=\'230\' title=\'Выбирайте напряжение насоса\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 60px; height: auto;\'  /> ~230/1</input> <input class=\'\' type=\'radio\' id1=\'1\' name=\'Valve\' value=\'3х 24В 0-10\' title=\'Выбирайте привод регулировочного клапана\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Esbe.png\' title=\'Привод клапана 3х 24В 0-10\' alt=\'Привод клапана 3х 24В 0-10\' class=\'scale\' style=\'width: 40px; height: auto;\'/>3х 24В 0-10</input><input class=\'\' type=\'radio\' id1=\'2\' name=\'Valve\' value=\'3х 24В 2-12\' title=\'Выбирайте привод регулировочного клапана\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Esbe.png\' title=\'Привод клапана 3х 24В 2-12\' alt=\'Привод клапана 3х 24В 2-12\' class=\'scale\' style=\'width: 40px; height: auto;\'/>3х 24В 2-12</input><input class=\'\' type=\'radio\' id1=\'3\' name=\'Valve\' value=\'3х 12В 0-10\' title=\'Выбирайте привод регулировочного клапана\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Esbe.png\' title=\'Привод клапана 3х 12В 0-10\' alt=\'Привод клапана 3х 12В 0-10\' class=\'scale\' style=\'width: 40px; height: auto;\'/>3х 12В 0-10</input><input class=\'\' type=\'radio\' id1=\'4\' name=\'Valve\' value=\'3х 12В 2-12\' title=\'Выбирайте привод регулировочного клапана\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Esbe.png\' title=\'Привод клапана 3х 12В 2-12\' alt=\'Привод клапана 3х 12В 2-12\' class=\'scale\' style=\'width: 40px; height: auto;\'/>3х 12В 2-12</input></h4>',
    ],
    elheat: [
        '---',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400x200 440мм³/ч 400/2 6кВт 6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400x200 440мм³/ч 400/3 9кВт 9</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400x200 440м3/ч 400/3 12кВт 12</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400x200 440м3/ч 400/3 15кВт 9+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x250 680м3/ч 400/3 7.5кВт 7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x250 680м3/ч 400/3 12кВт 12</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x250 680м3/ч 400/3 15кВт 7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x250 680м3/ч 400/3 18кВт 12+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x250 680м3/ч 400/3 22.5кВт 15+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x250 680м3/ч 400/3 24кВт 12+6+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x300 810м3/ч 400/3 7.5кВт 7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x300 680м3/ч 400/3 12кВт 12</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x300 680м3/ч 400/3 15кВт 7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x300 680м3/ч 400/3 18кВт 12+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x300 680м3/ч 400/3 22.5кВт 15+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500x300 680м3/ч 400/3 24кВт 12+6+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x300 980м3/ч 400/3 15кВт 7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x300 980м3/ч 400/3 18кВт 12+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x300 980м3/ч 400/3 22.5кВт 15+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x300 980м3/ч 400/3 24кВт 12+6+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x300 980м3/ч 400/3 30кВт 15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x300 980м3/ч 400/3 36кВт 12+12+6+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x350 1200м3/ч 400/3 15кВт 7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x350 1200м3/ч 400/3 18кВт 12+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x350 1200м3/ч 400/3 22.5кВт 15+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x350 1200м3/ч 400/3 24кВт 12+6+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x350 1200м3/ч 400/3 30кВт 15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x350 1200м3/ч 400/3 36кВт 12+12+6+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x350 1200м3/ч 400/3 45кВт 15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600x350 1200м3/ч 400/3 48кВт 12+12+12+6+6</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700x400 1550м3/ч 400/3 22.5кВт 15+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700x400 1550м3/ч 400/3 30кВт 15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700x400 1550м3/ч 400/3 45кВт 15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700x400 1550м3/ч 400/3 60кВт 15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700x400 1550м3/ч 400/3 75кВт 15+15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700x400 1550м3/ч 400/3 90кВт 15+15+15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800x500 2200м3/ч 400/3 30кВт 15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800x500 2200м3/ч 400/3 45кВт 15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800x500 2200м3/ч 400/3 60кВт 15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800x500 2200м3/ч 400/3 75кВт 15+15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800x500 2200м3/ч 400/3 90кВт 15+15+15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900x500 2500м3/ч 400/3 30кВт 15+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900x500 2500м3/ч 400/3 45кВт 15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900x500 2500м3/ч 400/3 60кВт 15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900x500 2500м3/ч 400/3 75кВт 15+15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900x500 2500м3/ч 400/3 90кВт 15+15+15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>1000x500 2700м3/ч 400/3 45кВт 15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>1000x500 2700м3/ч 400/3 60кВт 15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>1000x500 2700м3/ч 400/3 75кВт 15+15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>1000x500 2700м3/ч 400/3 90кВт 15+15+15+15+15+7.5+7.5</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>100 40мм³/ч 230/1 0.3/0.6кВт 1.4/2.8А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>125 70мм³/ч 230/1 1.2/1.8кВт 5.5/8.2А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>160 110мм³/ч 230/1 1.2/2.4/3кВт 5.5/10.9/13.7А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>160 110м3/ч 400/2 3/5кВт 7.9/13.2А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>160 110м3/ч 400/3 6кВт 8.7А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>200 170м3/ч 230/1 2.4/3кВт 10.9/13.7А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>200 170м3/ч 400/2 5/6кВт 13.2/15.8А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>200 170м3/ч 400/3 6кВт 8.7А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>250 270м3/ч 230/1 3кВт 13.7А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>250 270м3/ч 400/2 6кВт 15.8А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>250 270м3/ч 400/3 6/9/12кВт 8.7/13/17.3А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>315 415м3/ч 230/1 3кВт 13.7А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>315 415м³/ч 400/2 6кВт 15.8А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>315 415м³/ч 400/3 6/9/12кВт 8.7/13/17.3А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый электронагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400 690м³/ч 400/3 9/12кВт 13/17.3А</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>160/2 290м3/ч вода-T1-90/T2-70°С воздух-30/+23,61 5,13кВт Расход воды,м3/час 0,23 воздух, Па40 вода, кПа1,94</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>160/3 290м3/ч вода-T1-90/T2-70°С воздух-30/+37,09 6,42кВт Расход воды,м3/час 0,28 воздух, Па82 вода, кПа1,9</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>200/2 450м3/ч вода-T1-90/T2-70°С воздух-30/+15,44 6,75кВт Расход воды,м3/час 0,3 воздух, Па40 вода, кПа3,26</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>200/3 450м3/ч вода-T1-90/T2-70°С воздух-30/+28,01 8,61кВт Расход воды,м3/час 0,38 воздух, Па82 вода, кПа3,38</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>250/2 700м3/ч вода-T1-90/T2-70°С воздух-30/+24,89 12,68кВт Расход воды,м3/час 0,56 воздух, Па40 вода, кПа14,73</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>250/3 700м3/ч вода-T1-90/T2-70°С воздух-30/+37,74 15,64кВт Расход воды,м3/час 0,69 воздух, Па82 вода, кПа10,34</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>315/2 1120м3/ч вода-T1-90/T2-70°С воздух-30/+14,94 16,61кВт Расход воды,м3/час 0,73 воздух, Па40 вода, кПа15,21</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>315/3 1120м3/ч вода-T1-90/T2-70°С воздух-30/+27,94 21,41кВт Расход воды,м3/час 0,95 воздух, Па82 вода, кПа19,25</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>300-150/2 500м³/ч вода-T1-90/T2-70°С воздух-30/+14,14°С 7,28кВт Расход воды,м3/час 0,32 воздух, Па-33 вода, кПа-0,73</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>300-150/3 500м³/ч вода-T1-90/T2-70°С воздух-35/+28,04°С 10,40кВт Расход воды,м3/час 0,46 воздух, Па-47 вода, кПа-1,87</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400-200/1 850м³/ч вода-T1-90/T2-70°С воздух-10/+17,50°С 7,71кВт Расход воды,м3/час 0,34 воздух, Па26 вода, кПа-1,74</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400-200/2 850м³/ч вода-T1-90/T2-70°С воздух-30/+16,21°С 12,96кВт Расход воды,м3/час 0,57 воздух, Па31 вода, кПа-1,65</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400-200/3 850м³/ч вода-T1-90/T2-70°С воздух-35/+30,20°С 18,28кВт Расход воды,м3/час 0,81 воздух, Па43 вода, кПа-4,04</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>400-200/4 850м³/ч вода-T1-90/T2-70°С воздух-40/+41,44°С 22,84кВт Расход воды,м3/час 1,01 воздух, Па56 вода, кПа-7,45</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500-250/1 1350м³/ч вода-T1-90/T2-70°С воздух-10/+18,57°С 12,72кВт Расход воды,м3/час 0,56 воздух, Па27 вода, кПа-5,9</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500-250/2 1350м³/ч вода-T1-90/T2-70°С воздух-30/+16,75°С 20,82кВт Расход воды,м3/час 0,92 воздух, Па32 вода, кПа-3,38</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500-250/3 1350м³/ч вода-T1-90/T2-70°С воздух-35/+30,62°С 29,23кВт Расход воды,м3/час 1,29 воздух, Па45 вода, кПа-8,07</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500-250/4 1350м³/ч вода-T1-90/T2-70°С воздух-40/+42,40°С 36,70кВт Расход воды,м3/час 1,62 воздух, Па58 вода, кПа-23,84</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500-300/1 1600м³/ч вода-T1-90/T2-70°С воздух-10/+19,15°С 15,39кВт Расход воды,м3/час 0,68 воздух, Па26 вода, кПа-9,69</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500-300/2 1600м³/ч вода-T1-90/T2-70°С воздух-30/+16,98°С 24,80кВт Расход воды,м3/час 1,09 воздух, Па31 вода, кПа-3,9</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500-300/3 1600м³/ч вода-T1-90/T2-70°С воздух-35/+30,89°С 34,78кВт Расход воды,м3/час 1,54 воздух, Па44 вода, кПа-9,06</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>500-300/4 1600м³/ч вода-T1-90/T2-70°С воздух-40/+42,05°С 43,31кВт Расход воды,м3/час 1,92 воздух, Па57 вода, кПа-16,11</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600-300/1 1950м³/ч вода-T1-90/T2-70°С воздух-10/+19,31°С 18,85кВт Расход воды,м3/час 0,84 воздух, Па27 вода, кПа-15,83</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600-300/2 1950м³/ч вода-T1-90/T2-70°С воздух-30/+17,29°С 30,42кВт Расход воды,м3/час 1,35 воздух, Па32 вода, кПа-6,15</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600-300/3 1950м³/ч вода-T1-90/T2-70°С воздух-35/+31,10°С 42,53кВт Расход воды,м3/час 1,88 воздух, Па45 вода, кПа-14,31</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600-300/4 1950м³/ч вода-T1-90/T2-70°С воздух-40/+41,29°С 52,30кВт Расход воды,м3/час 2,31 воздух, Па58 вода, кПа-15,91</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600-350/1 2250м³/ч вода-T1-90/T2-70°С воздух-10/+18,92°С 21,46кВт Расход воды,м3/час 0,95 воздух, Па26 вода, кПа-9,01</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600-350/2 2250м³/ч вода-T1-90/T2-70°С воздух-30/+17,49°С 35,26кВт Расход воды,м3/час 1,56 воздух, Па31 вода, кПа-7,07</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600-350/3 2250м³/ч вода-T1-90/T2-70°С воздух-35/+31,35°С 49,25кВт Расход воды,м3/час 2,18 воздух, Па44 вода, кПа-16,06</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>600-350/4 2250м³/ч вода-T1-90/T2-70°С воздух-40/+42,06°С 60,91кВт Расход воды,м3/час 2,69 воздух, Па57 вода, кПа-22,81</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700-400/1 3000м³/ч вода-T1-90/T2-70°С воздух-10/+18,88°С 28,59кВт Расход воды,м3/час 1,26 воздух, Па26 вода, кПа-9,43</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700-400/2 3000м³/ч вода-T1-90/T2-70°С воздух-30/+17,95°С 47,46кВт Расход воды,м3/час 2,10 воздух, Па32 вода, кПа-11,78</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700-400/3 3000м³/ч вода-T1-90/T2-70°С воздух-35/+31,77°С 66,08кВт Расход воды,м3/час 2,92 воздух, Па44 вода, кПа-26,27</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>700-400/4 3000м³/ч вода-T1-90/T2-70°С воздух-40/+42,81°С 81,96кВт Расход воды,м3/час 3,62 воздух, Па57 вода, кПа-45,47</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800-500/1 4350м³/ч вода-T1-90/T2-70°С воздух-10/+18,98°С 41,60кВт Расход воды,м3/час 1,84 воздух, Па27 вода, кПа-15,35</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800-500/2 4350м³/ч вода-T1-90/T2-70°С воздух-30/+18,03°С 68,92кВт Расход воды,м3/час 3,05 воздух, Па32 вода, кПа-21,55</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800-500/3 4350м³/ч вода-T1-90/T2-70°С воздух-35/+31,77°С 95,82кВт Расход воды,м3/час 4,24 воздух, Па45 вода, кПа-46,65</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>800-500/4 4350м³/ч вода-T1-90/T2-70°С воздух-40/+40,67°С 115,77кВт Расход воды,м3/час 5,12 воздух, Па58 вода, кПа-45,68</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900-500/1 4850м³/ч вода-T1-90/T2-70°С воздух-10/+19,32°С 46,92кВт Расход воды,м3/час 2,07 воздух, Па27 вода, кПа-20,43</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900-500/2 4850м³/ч вода-T1-90/T2-70°С воздух-30/+18,49°С 77,59кВт Расход воды,м3/час 3,43 воздух, Па32 вода, кПа-27,95</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900-500/3 4850м³/ч вода-T1-90/T2-70°С воздух-35/+32,23°С 107,57кВт Расход воды,м3/час 4,76 воздух, Па45 вода, кПа-60,53</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>900-500/4 4850м³/ч вода-T1-90/T2-70°С воздух-40/+41,28°С 130,05кВт Расход воды,м3/час 5,75 воздух, Па57 вода, кПа-58,12</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>1000-500/1 5400м³/ч вода-T1-90/T2-70°С воздух-10/+18,79°С 51,28кВт Расход воды,м3/час 2,27 воздух, Па27 вода, кПа-15,33</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>1000-500/2 5400м³/ч вода-T1-90/T2-70°С воздух-30/+18,69°С 86,74кВт Расход воды,м3/час 3,83 воздух, Па32 вода, кПа-35,7</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>1000-500/3 5400м³/ч вода-T1-90/T2-70°С воздух-35/+25,4°С 107,62кВт Расход воды,м3/час 4,76 воздух, Па44 вода, кПа-62,9</h4>',
        '<h4><a href=\'#popmake-\'><img src=\'/wp-content/uploads/2022/03/prom vent/pr/водяной нагреватель.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>1000-500/4 5400м³/ч вода-T1-90/T2-70°С воздух-40/+41,56°С 145,30кВт Расход воды,м3/час 6,42 воздух, Па58 вода, кПа-73,1</h4>',
    ],
    controlFilter: [
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный фильтр элемент.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> G4️⃣</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный фильтр элемент.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> G4️⃣ ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F5.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F5️⃣</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный фильтр элемент.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> G4️⃣ ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F5.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F5️⃣ ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F7.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F7️⃣</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F5.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F5️⃣</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F7.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F7️⃣</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> E1️⃣0️⃣ 85 %(MPPS)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> E1️⃣1️⃣ 95 %(MPPS)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> E1️⃣2️⃣ 99.5 %(MPPS)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> H1️⃣3️⃣ 99.95 %(MPPS)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> H1️⃣4️⃣ 99.995 %(MPPS)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> U1️⃣5️⃣ 99.9995 %(MPPS)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> U1️⃣6️⃣ 99.99995 %(MPPS)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> U1️⃣7️⃣ 99.999995 %(MPPS)</h4>',
        '<h4><h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный фильтр элемент.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> G4️⃣ ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F7.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F7️⃣</h4>',
        '<h4><h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный фильтр элемент.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> G4️⃣ ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> H13</h4>',
        '<h4><h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный фильтр элемент.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> G4️⃣ ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F5.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F5️⃣ ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F7.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F7️⃣ ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> H13</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный фильтр элемент.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F5 ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F7.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F7</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/F7.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> F7 ➕ <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Filter/H13.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> H13</h4>',
    ],
    inletVentControl: ['+', '---'],
    outVentControl: ['---', '+'],
    ventType: [
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 100m 50-230м³/ч 0-270Па 1x220 0.07кВт 0.3А 3.2кг in -25➖60°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-p.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/>100p 45-205м³/ч 85-325Па 1x220 0.07кВт 0.3А 2.3кг in -25➖70°С/out -30➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/>125m 50-340м³/ч 0-280Па 1x220 0.07кВт 0.3А 3.6кг in -25➖70°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-p.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/>125p 50-280м³/ч 120-299Па 1x220 0.07кВт 0.3А 2.3кг in -25➖70°С/out -30➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/>150m 50-690м³/ч 5-380Па 1x220 0.115кВт 0.5А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/>160m 50-690м³/ч 5-380Па 1x220 0.115кВт 0.5А 5.5кг in -25➖50°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-p.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/>160p 100-890м³/ч 5-387Па 1x220 0.1кВт 0.47А 3.4кг in -25➖60°С/out -30➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/>200m 60-900м³/ч 20-490Па 1x220 0.15кВт 0.7А 5.1кг in -25➖50°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-p.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/>200p 300-920м³/ч 50-374Па 1x220 0.15кВт 0.7А 4.1кг in -25➖50°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/>250m 50-1080м³/ч 5-550Па 1x220 0.2кВт 0.9А 6.7кг in -25➖60°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-p.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/>250p 150-1400м³/ч 0-531Па 1x220 0.2кВт 0.9А 4.5кг in -25➖60°С/out -30➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/>315m 90-1550м³/ч 0-650Па 1x220 0.28кВт 1.1А 8.2кг in -25➖50°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-p.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/>315p 300-1540м³/ч 30-556Па 1x220 0.25кВт 1.1А 5.8кг in -25➖50°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/>355-4Dm 1050-2200м³/ч 5-270Па 3x400 0.22кВт 0.47А 14кг in -25➖50°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/c/круглый вентилятор-m.png\' class=\'scale\' style=\'width: 40px; height: auto;\'/>355-4Em 1150-2150м³/ч 0-255Па 1x220 0.22кВт 1А 22.3кг in -25➖50°С/out -45➖40°С</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 400-200/20-4D 0-1200м³/ч 50-255Па 3x400 0.33кВт 0.63А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 400-200/20-4Dsh 0-1200м³/ч 50-255Па 3x400 0.33кВт 0.63А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 400-200/20-4E 0-1200м³/ч 25-240Па 1x220 0.33кВт 1.52А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 400-200/20-4Esh 0-1200м³/ч 25-240Па 1x220 0.33кВт 1.52А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 500-250/22-4D 0-1800м³/ч 50-310Па 3x400 0.49кВт 0.82А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 500-250/22-4Dsh 0-1800 м³/ч 50-310Па 3x400 0.49кВт 0.82А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 500-250/22-4E 0-1600 м³/ч 25-300Па 1x220 0.51кВт 2.3А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 500-250/22-4Esh 0-1600 м³/ч 25-300Па 1x220 0.51кВт 2.3А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 500-300/25-4D 0-2950 м³/ч 90-410Па 3x400 0.87кВт 1.8А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 500-300/25-4Dsh 0-2950 м³/ч 90-410Па 3x400 0.87кВт 1.8А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 500-300/25-4E 0-2700 м³/ч 55-380Па 1x220 0.9кВт 4.1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 500-300/25-4Esh 0-2700 м³/ч 55-380Па 1x220 0.9кВт 4.1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 600-300/28-4D 0-3500м³/ч 45-450Па 3x400 1.7кВт 3.2А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 600-300/28-4Dsh 0-3500м³/ч 45-450Па 3x400 1.7кВт 3.2А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 600-300/28-4E 0-2700 м³/ч 120-410Па 1x220 1.6кВт 7.3А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 600-300/28-4Esh 0-2700 м³/ч 120-410Па 1x220 1.6кВт 7.3А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 600-350/31-4D 0-4200м³/ч 250-631Па 3x400 2.2кВт 4А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 600-350/31-4Dsh 0-4200м³/ч 250-631Па 3x400 2.2кВт 4А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 700-400/35-4D 0-5600м³/ч 385-760Па 3x400 3.5кВт 5.9А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 700-400/35-4Dsh 0-5600м³/ч 385-760Па 3x400 3.5кВт 5.9А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 800-500/40-4D 0-6500м³/ч 688-1000Па 3x400 4.8кВт 8А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 800-500/40-4Dsh 0-6500м³/ч 688-1000Па 3x400 4.8кВт 8А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 900-500/45-6D 0-7500м³/ч 480-695Па 3x400 3.5кВт 6А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 900-500/45-6Dsh 0-8500м³/ч 480-900Па 3x400 3.5кВт 6А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 1000-500/50-6D 0-8500м³/ч 640-900Па 3x400 4.4кВт 7.5А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKP 1000-500/50-6Dsh 0-8500м³/ч 640-900Па 3x400 4.4кВт 7.5А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 400-200/22-2E 0-1100м³/ч 0-480Па 1x230 0.15кВт 0.7А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 400-200/22-2Esh 0-1100м³/ч 0-480Па 1x230 0.15кВт 0.7А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 500-250/25-2E 0-1400м³/ч 0-650Па 1x230 0.2кВт 0.9А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 500-250/25-2Esh 0-1400м³/ч 0-650Па 1x230 0.2кВт 0.9А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 500-300/28-2E 0-1800м³/ч 0-600Па 1x230 0.25кВт 1.1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 500-300/28-2Esh 0-1800м³/ч 0-600Па 1x230 0.25кВт 1.1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 600-300/35-4D 0-2500м³/ч 0-300Па 3x400 0.22кВт 0.47А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 600-300/35-4Dsh 0-2500м³/ч 0-300Па 3x400 0.22кВт 0.47А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 600-300/35-4E 0-2200м³/ч 0-260Па 1x230 0.22кВт 1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 600-300/35-4Esh 0-2200м³/ч 0-260Па 1x230 0.22кВт 1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 600-350/40-4D 700-4000м³/ч 0-400Па 3x400 0.54кВт 1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 600-350/40-4Dsh 700-4000м³/ч 0-400Па 3x400 0.54кВт 1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 600-350/40-4E 1050-4000м³/ч 0-400Па 1x230 0.56кВт 2.46А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 600-350/40-4Esh 1050-4000м³/ч 15-400Па 1x230 0.56кВт 2.46А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 700-400/45-4D 2000-5700м³/ч 0-450Па 3x400 0.69кВт 1.26А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 700-400/45-4Dsh 2000-5700м³/ч 0-450Па 3x400 0.69кВт 1.26А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 700-400/45-4E 2550-5600м³/ч 0-450Па 1x230 0.83кВт 4.1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 700-400/45-4Esh 2550-5600м³/ч 0-450Па 1x230 0.83кВт 4.1А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 800-500/50-4D 0-7400м³/ч 0-510Па 3x400 1.3кВт 2.65А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 800-500/50-4Dsh 0-7400м³/ч 0-510Па 3x400 1.3кВт 2.65А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 900-500/56-4D 0-10000м³/ч 0-680Па 3x400 1.8кВт 3.4А',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN 900-500/56-4Dsh 0-10000м³/ч 0-680Па 3x400 1.8кВт 3.4А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 400-200/22-6E 80-1130м³/ч 25-640Па 1x230 0.18кВт 1.3А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 500-250/25-6E 180-1380м³/ч 0-525Па 1x230 0.27кВт 1.8А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 500-300/25-6E 850-3080м³/ч 0-850Па 1x230 0.54кВт 2.38А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 600-300/25-6E 1000-29000м³/ч 0-830Па 1x230 0.54кВт 2.38А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 600-300/28-6D 500-4000м³/ч 0-1180Па 3x400 1.14кВт 1.86А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 600-350/28-6D 500-4350м³/ч 0-1205Па 3x400 1.14кВт 1.86А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 700-400/28-6D 500-4500м³/ч 50-1150Па 3x400 1.14кВт 1.86А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 700-400/35-8D 1500-6500м³/ч 0-1050Па 3x400 1.7кВт 2.7А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 800-500/56-8D 3100-12900м³/ч 0-1110Па 3x400 3.53кВт 5.5А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 900-500/56-8D 3100-12900м³/ч 0-1110Па 3x400 3.53кВт 5.5А</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/prom vent/pr/прямоугольный вентилятор.webp\' class=\'scale\' style=\'width: 40px; height: auto;\'/> VKPN-EC 1000-500/56-8D 3100-12900м³/ч 0-1110Па 3x400 3.53кВт 5.5А</h4>',
    ],
    bm: ['---',
        'Эконом➖CHNT, ESQ, Andeli, KEAZ',
        'Норма➖Schneider, АВВ',
    ],
    waterheat: [
        '<h4>---</h4>',
        '<h4><input class=\'\' type=\'radio\' id1=\'1\' name=\'Pump\' value=\'400\' title=\'Выбирайте напряжение насоса\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~400/3</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'Pump\' value=\'230\' title=\'Выбирайте напряжение насоса\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230/1</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230/1</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~400/3</h4>',
        '<h4>С пружинным возвратом</h4>',
        '<h4>100*50/3-R</h4>',
        '<h4>40*20/3-R</h4>',
        '<h4>50*25/3-R</h4>',
        '<h4>50*30/3-R</h4>',
        '<h4>60*30/3-R</h4>',
        '<h4>60*35/3-R</h4>',
        '<h4>70*40/3-R</h4>',
        '<h4>80*50/3-R</h4>',
        '<h4>90*50/3-R</h4>'
    ],
    coolerwaterheat: [
        '<h4>---</h4>', 'Cухой» контакт на пуск ККБ',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230/1</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230/1<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~400/3</h4>',
        '<h4><input class=\'\' type=\'radio\' id1=\'1\' name=\'Pump\' value=\'400\' title=\'Выбирайте напряжение насоса\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~400/3</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'Pump\' value=\'230\' title=\'Выбирайте напряжение насоса\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Циркуляционный  насос.png\' title=\'Циркуляционный  насос\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230/1</input></h4>',
        '<h4>С пружинным возвратом</h4>',
        '<h4>100*50/3-R</h4>',
        '<h4>40*20/3-R</h4>',
        '<h4>50*25/3-R</h4>',
        '<h4>50*30/3-R</h4>',
        '<h4>60*30/3-R</h4>',
        '<h4>60*35/3-R</h4>',
        '<h4>70*40/3-R</h4>',
        '<h4>80*50/3-R</h4>',
        '<h4>90*50/3-R</h4>',
    ],
    cooler: ['---', 'Cухой» контакт на пуск', 'Циркуляционный насос ~230 B/1ф', 'Циркуляционный насос ~400 В/3ф', 'Управление приводом вентиля 0-10В (24VAC)'],
    recycl: ['---', 'Рециркуляция-Дискретное управление', 'Рециркуляция-Плавное управление 0-10 В (питание 24VAC)', 'Пластинчатый рекуператор-Дискретное управление', 'Пластинчатый рекуператор-Плавное управление 0-10 В (питание 24VAC)', 'Роторный рекуператор-(упр.Прямой пуск)-230 В/1Ф', 'Роторный рекуператор-(упр.Прямой пуск)-400 В/3ф', 'Роторный рекуператор-(упр.0-10 В)-230 В/1Ф', 'Роторный рекуператор-(упр.0-10 В)-400 В/3ф', 'Гликолевый рекуператор-(насос 230 В/1ф)-привод вентиля (24VAC) 0-10 В', 'Гликолевый рекуператор-(насос 230 В/1ф)-привод вентиля (24VAC) Откр / закр', 'Гликолевый рекуператор-(насос 400 В/3ф)-привод вентиля (24VAC) 0-10 В', 'Гликолевый рекуператор-(насос 400 В/3ф)-привод вентиля (24VAC) Откр / закр'],
    humid: [
        '<h4>---</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Сотовый увлажнитель.png\' title=\'Сотовый увлажнитель\' alt=\'Сотовый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 230 В/1ф -Датчик влажности Дискретный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Сотовый увлажнитель.png\' title=\'Сотовый увлажнитель\' alt=\'Сотовый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/>Сотовый увлажнитель 230 В/1ф -Датчик влажности 0-10 В (24VAC)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Сотовый увлажнитель.png\' title=\'Сотовый увлажнитель\' alt=\'Сотовый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/>Сотовый увлажнитель 400 В/3ф -Датчик влажности Дискретный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Сотовый увлажнитель.png\' title=\'Сотовый увлажнитель\' alt=\'Сотовый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/>Сотовый увлажнитель 400 В/3ф -Датчик влажности 0-10 В (24VAC)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/увлажнитель.webp\' title=\'Паровой увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Паровой увлажнитель (0-10 В + «сухой» контакт на пуск) -Датчик влажности Дискретный</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/увлажнитель.webp\' title=\'Паровой увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Паровой увлажнитель (0-10 В + «сухой» контакт на пуск) -Датчик влажности 0-10 В (24VAC)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/увлажнитель.webp\' title=\'Паровой увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Паровой увлажнитель (Вкл / выкл) -Датчик влажности Дискретный</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/увлажнитель.webp\' title=\'Паровой увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Паровой увлажнитель (Вкл / выкл) -Датчик влажности 0-10 В (24VAC)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Форсунчатый увлажнитель.png\' title=\'Форсунчатый увлажнитель\' alt=\'Форсунчатый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Форсунчатый увлажнитель 230 В/1ф-(Упр.0-10 В)-Датчик влажности Дискретный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Форсунчатый увлажнитель.png\' title=\'Форсунчатый увлажнитель\' alt=\'Форсунчатый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Форсунчатый увлажнитель 230 В/1ф-(Упр.0-10 В)-Датчик влажности 0-10 В (24VAC)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Форсунчатый увлажнитель.png\' title=\'Форсунчатый увлажнитель\' alt=\'Форсунчатый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Форсунчатый увлажнитель 230 В/1ф-(Вкл/выкл)-Датчик влажности Дискретный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Форсунчатый увлажнитель.png\' title=\'Форсунчатый увлажнитель\' alt=\'Форсунчатый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Форсунчатый увлажнитель 230 В/1ф-(Вкл/выкл)-Датчик влажности 0-10 В (24VAC)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Форсунчатый увлажнитель.png\' title=\'Форсунчатый увлажнитель\' alt=\'Форсунчатый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Форсунчатый увлажнитель 400 В/3ф-(Упр.0-10 В)-Датчик влажности Дискретный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Форсунчатый увлажнитель.png\' title=\'Форсунчатый увлажнитель\' alt=\'Форсунчатый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Форсунчатый увлажнитель 400 В/3ф-(Упр.0-10 В)-Датчик влажности 0-10 В (24VAC)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Форсунчатый увлажнитель.png\' title=\'Форсунчатый увлажнитель\' alt=\'Форсунчатый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Форсунчатый увлажнитель 400 В/3ф-(Вкл/выкл)-Датчик влажности Дискретный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/humid/Форсунчатый увлажнитель.png\' title=\'Форсунчатый увлажнитель\' alt=\'Форсунчатый увлажнитель\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Форсунчатый увлажнитель 400 В/3ф-(Вкл/выкл)-Датчик влажности 0-10 В (24VAC)</h4>'
    ],
    dry: ['---', 'Дискретное управление', 'Cухой» контакт на пуск', 'Да'],
    modbus: ['---', 'RS-485 (ModBus RTU)', 'Ethernet (ModBus TCP/IP)', '🛜Wi-Fi'],
    control: ['---',
        'Zentec',
        'Segnetics',
        'Овен',
        'Болид',
        'Siemens',
        'Danfoss',
        'Esbe',
        'Carel',
        'Jonson controls',
        'Raspberry',
        'Arduino',
        'Управл. с контроллера внутри щита',
        'Управл. с панели оператора',
        'Управл. со смартфона(Android) через приложение ',
        'Управл. со смартфона(ios) через приложение ',
        'Управл. через браузер',
        'Монохромная панель на стену с 🛜Wi-Fi',
        'Монохромная панель в щит',
        'Сенсорная панель 7’’',
        'Режим арботы потаймеру, день-ночь',
        'Сенсорная панель 10’’',
    ],
    alarm: [
        '---',
        '🔥Пожар',
        '🔴Авария',
        '📢Звуковая сирена',
        '🔴Фильтр(ы)',
        '🟢Работа П(В)',
        '🟢Питание',
    ],
    addsensor: [
        '---',
        'Наружного воздуха',
        'Вытяжного воздуха',
        'Датчик с выходом 0-10 В (питание 24VAC)',
        'Дискретный датчик (беспотенциальный контакт)',
    ],
    addsignal: ['---', '1', '2', '3', 'Доп.контакт 1', 'Доп.контакт 2', '🛜Wi-Fi', 'GSM', 'СО2', 'Резерв', 'Доп.контакт'],
    infun: [
        '<h4>~230В-Вкл/выкл <input class=\'\' type=\'radio\' id1=\'1\' name=\'230В-Вкл/выкл\' value=\'КП\' title=\'Выбирайте тип КП\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'КП\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ПДУ</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'230В-Вкл/выкл\' value=\'Шкаф\' title=\'Выбирайте тип в шкаф\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Вкл-выкл шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Местный <input class=\'\' type=\'radio\' id1=\'3\' name=\'220В-Вкл/выкл\' value=\'Пост и шкаф\' title=\'Выбирайте тип пост и в шкаф\' > <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>➕<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Вкл-выкл шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/></h4>',
        '<h4>~230В-Вкл/выкл <input class=\'\' type=\'radio\' id1=\'1\' name=\'Клавиша\' value=\'Накладная\' title=\'Выбирайте тип клавиши\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Накладной</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'Клавиша\' value=\'Внутренняя\' title=\'Выбирайте тип клавиши\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель внутренний.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Внутренний</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Диммер.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В-Диммер <input class=\'\' type=\'radio\' id1=\'1\' name=\'Диммер\' value=\'Накладной\' title=\'Выбирайте тип диммера\' checked >Накладной</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'Диммер\' value=\'Внутренний\' title=\'Выбирайте тип диммера\'>Внутренний</input> <input class=\'\' type=\'radio\' id1=\'3\' name=\'Диммер\' value=\'Димер+Накладной\' title=\'Выбирайте димер + выключатель\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Диммер.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>➕<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/></input></h4>',
        '<h4>Вкл/выкл с контроллера</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/220В-Регулятор скорости на Din рейку.png\' alt=\'230/1\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230/1-Регулятор скорости на Din рейку</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/220В-Регулятор скорости на Din рейку.png\' alt=\'400/3\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~400/3-Регулятор скорости на Din рейку</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Транс.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В-Трансф.5ступ.регул.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> in220В/out220В-ЧП➕<input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'КП\' title=\'Выбирайте тип КП\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'КП\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ПДУ</input><input class=\'cb pristine\' type=\'checkbox\' id1=\'2\' name=\'230В-Вкл/выклЧП\' value=\'Накладная\' title=\'Выбирайте тип клавиши\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Накладной</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> in220В/out380В-ЧП➕<input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'КП\' title=\'Выбирайте тип КП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'КП\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ПДУ</input><input class=\'cb pristine\' type=\'checkbox\' id1=\'2\' name=\'230В-Вкл/выклЧП\' value=\'Накладная\' title=\'Выбирайте тип клавиши\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Накладной</input></h4>',
        '<h4>380В-Вкл/выкл <input class=\'\' type=\'radio\' id1=\'1\' name=\'380В-Вкл/выкл\' value=\'Пост\' title=\'Выбирайте тип пост\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ПДУ <input class=\'\' type=\'radio\' id1=\'2\' name=\'380В-Вкл/выкл\' value=\'Шкаф\' title=\'Выбирайте тип в шкаф\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Вкл-выкл шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Местный <input class=\'\' type=\'radio\' id1=\'3\' name=\'380В-Вкл/выкл\' value=\'Шкаф+Пост\' title=\'Выбирайте тип в шкаф+ пост\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>➕<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Вкл-выкл шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/></input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/УПП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>~400/3-УПП➕<input class=\'\' type=\'radio\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'КП\' title=\'Выбирайте тип КП\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'КП\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ПДУ</input><input class=\'\' type=\'radio\' id1=\'2\' name=\'230В-Вкл/выклЧП\' value=\'Накладная\' title=\'Выбирайте тип клавиши\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Накладной</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/УПП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>~230/1-УПП➕<input class=\'\' type=\'radio\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'КП\' title=\'Выбирайте тип КП\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'КП\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ПДУ</input><input class=\'\' type=\'radio\' id1=\'2\' name=\'230В-Вкл/выклЧП\' value=\'Накладная\' title=\'Выбирайте тип клавиши\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Накладной</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Транс.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 380В-Трансф.5ступ.регул.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> in380В/out220В-ЧП➕<input class=\'\' type=\'radio\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'КП\' title=\'Выбирайте тип КП\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'КП\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ПДУ</input><input class=\'\' type=\'radio\' id1=\'2\' name=\'230В-Вкл/выклЧП\' value=\'Накладная\' title=\'Выбирайте тип клавиши\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Накладной</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> in380В/out380В-ЧП➕<input class=\'\' type=\'radio\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'КП\' title=\'Выбирайте тип КП\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'КП\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ПДУ</input><input class=\'\' type=\'radio\' id1=\'2\' name=\'230В-Вкл/выклЧП\' value=\'Накладная\' title=\'Выбирайте тип клавиши\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Накладной</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Потенциометр на шкаф для Частотный привод.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Потенциометр на шкаф для Частотный привод</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Потенциометр в шкаф для Частотный привод на Din.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Потенциометр в шкаф для Частотный привод на Din рейку</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Потенциометр в пост для Частотный привод.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Потенциометр в бокс для Частотный привод</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП Danfoss\' title=\'Выбирайте ЧП\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Danfoss</input></h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП Zentec\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Zentec.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Zentec</input></</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП M-DRIVER\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/M-DRIVER.png\' alt=\'\' class=\'scale\' style=\'width: 30px; height: auto;\'/> M-DRIVER</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП DA\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/DA.png\' alt=\'\' class=\'scale\' style=\'width: 30px; height: auto;\'/> DA</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП INNOVERT\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/INNOVERT.png\' alt=\'\' class=\'scale\' style=\'width: 30px; height: auto;\'/> INNOVERT</input></h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП INSTART\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/INSTART.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> INSTART</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП INOVANCE\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/INOVANCE.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> INOVANCE</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП KINCO\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/KINCO.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> KINCO</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП ONI\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ONI.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ONI</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП IDS-DRIVE\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/IDS-DRIVE.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> IDS-DRIVE</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП ESQ\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ESQ.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ESQ</h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП ATV\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ATV.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ATV(Schneider Electric)</input></h4>',
        '<h4><input class=\'cb pristine\' type=\'checkbox\' id1=\'1\' name=\'230В-Вкл/выклЧП\' value=\'ЧП Овен\' title=\'Выбирайте ЧП\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Овен.png\' alt=\'\' class=\'scale\' style=\'width: 30px; height: auto;\'/> Овен</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Реле контроля фаз.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Реле контроля фаз</h4>'
    ],
    outfun: ['<h4>~230В-Вкл/выкл <input class=\'\' type=\'radio\' id1=\'1\' name=\'230В-Вкл/выкл\' value=\'Пост\' title=\'Выбирайте тип пост\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Пост <input class=\'\' type=\'radio\' id1=\'2\' name=\'230В-Вкл/выкл\' value=\'Шкаф\' title=\'Выбирайте тип в шкаф\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Вкл-выкл шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> В шкаф <input class=\'\' type=\'radio\' id1=\'3\' name=\'220В-Вкл/выкл\' value=\'Пост и шкаф\' title=\'Выбирайте тип пост и в шкаф\' > <img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>➕<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Вкл-выкл шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/></h4>',
        '<h4>~230В-Вкл/выкл <input class=\'\' type=\'radio\' id1=\'1\' name=\'Клавиша\' value=\'Накладная\' title=\'Выбирайте тип клавиши\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Накладной</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'Клавиша\' value=\'Внутренняя\' title=\'Выбирайте тип клавиши\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель внутренний.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Внутренний</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Диммер.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В-Диммер <input class=\'\' type=\'radio\' id1=\'1\' name=\'Диммер\' value=\'Накладной\' title=\'Выбирайте тип диммера\' checked >Накладной</input> <input class=\'\' type=\'radio\' id1=\'2\' name=\'Диммер\' value=\'Внутренний\' title=\'Выбирайте тип диммера\'>Внутренний</input> <input class=\'\' type=\'radio\' id1=\'3\' name=\'Диммер\' value=\'Димер+Накладной\' title=\'Выбирайте димер + выключатель\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Диммер.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>➕<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Выключатель накладной.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/></input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/220В-Регулятор скорости на Din рейку.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В-Регулятор скорости на Din рейку</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Транс.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> ~230В-Трансф.5ступ.регул.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> in220В/out220В-Частотный привод</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> in220В/out380В-Частотный привод</h4>',
        '<h4>380В-Вкл/выкл <input class=\'\' type=\'radio\' id1=\'1\' name=\'380В-Вкл/выкл\' value=\'Пост\' title=\'Выбирайте тип пост\' checked ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Пост <input class=\'\' type=\'radio\' id1=\'2\' name=\'380В-Вкл/выкл\' value=\'Шкаф\' title=\'Выбирайте тип в шкаф\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Вкл-выкл шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> В шкаф <input class=\'\' type=\'radio\' id1=\'3\' name=\'380В-Вкл/выкл\' value=\'Шкаф+Пост\' title=\'Выбирайте тип в шкаф+ пост\' ><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Пост2.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/>➕<img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Вкл-выкл шкаф.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/></input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/УПП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 380В-УПП</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/Транс.webp\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> 380В-Трансф.5ступ.регул.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> in380В/out220В-Частотный привод</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/ЧП.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> in380В/out380В-Частотный привод</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Потенциометр на шкаф для Частотный привод.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Потенциометр на шкаф для Частотный привод</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Потенциометр в шкаф для Частотный привод на Din.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Потенциометр в шкаф для Частотный привод на Din рейку</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Потенциометр в пост для Частотный привод.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Потенциометр в бокс для Частотный привод</h4>',
        '<h4>Danfoss</h4>',
        '<h4>Zentec</h4>',
        '<h4>M-DRIVER</h4>',
        '<h4>DA</h4>',
        '<h4>INNOVERT</h4>',
        '<h4>INSTART</h4>',
        '<h4>INOVANCE</h4>',
        '<h4>KINCO</h4>',
        '<h4>ONI</h4>',
        '<h4>IDS-DRIVE</h4>',
        '<h4>ESQ</h4>',
        '<h4>Schneider Electric</h4>',
        '<h4>Овен</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/ШСАУ/infun/Реле контроля фаз.png\' alt=\'\' class=\'scale\' style=\'width: 40px; height: auto;\'/> Реле контроля фаз</h4>'],
    scada: ['---', 'Scada', 'MasterScada'],
    boxmaterial: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    typevalve: ['---',
        '🔋24В - Электромагнитный Нормально-закрытый',
        '🔋24В - Электромагнитный Нормально-открытый',
        '🔋24В - Реверсивный',
        '🔋12В - Электромагнитный Нормально-закрытый',
        '🔋12В - Электромагнитный Нормально-открытый',
        '🔋12В - Реверсивный',
        '~230В - Нормально-закрытый',
        '~230В - Нормально-открытый',
        '~230В - Реверсивный',
        '<input class="cb pristine" type="checkbox">С пружинным возвратом</input>',
        '<input class="cb pristine" type="checkbox">Контроль состояния</input>'],
    openclosevalve: ['---', 'Нормально-открытый', 'Нормально-закрытый', '~230В', '<input type="text" value="">', '<input class="cb pristine" type="checkbox">С пружинным возвратом</input>'],
    watersource: ['---', 'Скважина*(указать глубину, м)', 'Река, озеро', 'Водопровод', 'Колодец', 'Водонапорная башня'],
    waterconsumptionmode: ['---', 'Периодический **', 'только на выходные дни', 'непрерывный', 'сезонный (только лето или зима) ', 'односменный, кол-во часов', 'многосменный, кол-во смен/часов'],
    purposewater: ['---', 'хоз-питьевые нужды', 'подпитка системы отопления'],
    copperpipe: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    steelpipe: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    metalplasticpipe: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    polypropylenepipe: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    Polyethylenepipes: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    Pipescrosslinkedpolyethylene: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    Flexibleeyeliner: ['---', 'Подводка для воды 0,3-3м Г/Ш VALTEC', 'Подводка д/смесителя Монофлекс 120-150 см SS 12мм М-10', 'Подводка к смесителю комплект 0.5 -1,5 м VALTEC', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    batteryAL: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    Bimetallicradiators: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    Castironradiators: ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    'Панельныерадиаторы': ['---', 'Пластик', 'Металл', 'Установка в существующий Пластик', 'Установка в существующий Металл', 'Материал Пластик заказчика', 'Материал Металл заказчика'],
    Convectors: ['---',
        'Пластик',
        'Металл',
        'Установка в существующий Пластик',
        'Установка в существующий Металл',
        'Материал Пластик заказчика',
        'Материал Металл заказчика'],
    planwindows: ['---',
        'Коммерческая закупка',
        'Гос/мнцп.закупки-44ФЗ',
        'Гос/мнцп.закупки-223ФЗ',
        'Гос/мнцп.закупки-ЗМО',
        'Прямо сейчас пока не начался сезон и все есть в наличии по низким ценам',
        'Как определюсь с выбором, сразу закажу',
        'Еще решаю',
        'Никогда',
        'Благотворительность'],
    'material': ['ПВХ', 'Allum.', 'Дерево', 'Стеклокомпозит'],
    'Четверть': ['---', 'Есть', 'Нет', 'Не могу определить'],
    'ТипЗдания': ['---',
        '🏠Жилой дом/Квартира',
        'Детский сад/ясли',
        '🏫Школа',
        '🏩Больница',
        '🎓Вуз/Колледж/Лицей',
        '📚Библиотека/🏛️Музей',
        'Гостиница/Общежитие',
        'Офис/Администрация',
        'Баня',
        'Сауна',
        'Бассейн',
        'Склад, цех, ангар',
        'Прозрачный козырёк над входом',
        'Магазин/Торговый центр',
        'Нет в списке'],
    'Профиль': ['---',
        'Аллюминий раздвижные системы',
        'ALT100VC65', 'AYPC SL160',
        'AYPC SL160 2х полозковая',
        'Балконы распашные',
        'КП 40',
        'КП 45 Light',
        'КП 45',
        'СТ 71',
        'ALT W62',
        'ALT W72',
        'КП 45 на клеммах',
        'КП 45 маятниковые двери',
        'ПЛАСТИК',
        'Exprof XS460 Prona',
        'Exprof XS570 Siberica',
        'Exprof Experta 70',
        'Rehau Grazia',
        'Rehau Delight Design',
        'Rehau Intelio 80',
        'Rehau Intelio Slide',
        'Rehau Blitz',
        'Rehau Thermo-Design',
        'Gealan 8000 IQ',
        'Gealan 9000',
        'Externa 46мм. 2кам.',
        'Provin 58мм. 3кам',
        'Practica А-класс 101мм.',
        'Prona',
        'Ratio', 'Siberica 70мм.',
        'Profecta',
        'Experta', 'Arctica 70мм. 6кам.',
        'Robusta',
        'KBE Etalon',
        'KBE Engine',
        'KBE Gut',
        'KBE Expert',
        'KBE Master',
        'KBE 76 Premium',
        'KBE Select',
        'Melke Lite 60',
        'Melke Smart',
        'Melke Evolution',
        'Melke Art'],
    'Фурнитура': ['---',
        'Maco➖ЭКО(Австрия)',
        'Maco➖замок(Австрия)',
        'Maco➖многозапорник(Австрия)',
        '<input class=\'cb pristine\' title=\'\' type=\'checkbox\' value=\'1\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Гребенка.webp\' class=\'scale\' alt=\'\' style=\'width: 50px; height: auto;\'/>Гребенка</input>',
        '<input class=\'cb pristine\' title=\'\' type=\'checkbox\' value=\'2\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Замок.png\' class=\'scale\' alt=\'\' style=\'width: 50px; height: auto;\'/>Замок</input>',
        '<input class=\'cb pristine\' title=\'\' type=\'checkbox\' value=\'3\' checked><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Детский замок.png\' class=\'scale\' alt=\'\' style=\'width: 50px; height: auto;\'/>Детский замок</input>',
        '<input class=\'cb pristine\' title=\'\' type=\'checkbox\' value=\'4\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Термометр.png\' class=\'scale\' alt=\'\' style=\'width: 50px; height: auto;\'/>Оконный градусник</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' value=\'5\'>Высота ручки</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' value=\'6\' checked>В цвет конструкции</input>',
        '<input class=\'cb pristine\' type=\'checkbox\' value=\'6\' checked>Tilt First</input>',
        'Maco-Rehau➖MM(Австрия)',
        'Vorne(Турция)',
        'Vorne➖многозапорник(Турция)',
        'Roto(Германия)',
        'ELEMENTIS',
        'FORNAX',
        'Kale',
        'GU',
        'T&T',
        'Multi matic',
        'Axor',
        'ACCADO',
        'WinkHaus',
        'Futuruss',
        'GreenteQ(Турция)',
        'WINTECH ACCADO',
        'Variotec',
        'Verta',
        'ELEMENTIS',
        'ACCADO',
        'SCHURING',
        'ARtec',
        'GEVISS',
        'FORNAX',
        'KALE',
        'VORNE',
        'FUHR',
        'WINKHAUS',
        'UPT',
        'MACO',
        '<input class=\'cb pristine\' type=\'checkbox\' value=\'6\' checked>ROTO TiltFirst</input>',
        'GU',
        'SIEGENIA-AUBI'],
    'Стеклопакет': ['СПД➖32(4М1-10-4М1-10-4М1)',
        'СПД➖34(4М1-10-4М1-16-4М1-шумоизолированный)',
        'СПД➖34(4М1-10-4М1-10-3.3-триплекс)',
        'СПД➖34(4М1-10-4М1-10-4.4-триплекс)',
        '<input class=\'cb pristine\' type=\'checkbox\'>Теплые рамки</input>',
        'СПД➖36(4М1-14-4М1-14-4М1)',
        'СПД➖44(4М1-16-4М1-16-4М1)',
        'СПТ➖44(4М1-10-4М1-10-4М1-10-4М1)',
        'СПД➖32(4М1-10ТР-4М1-10Ar-4К)',
        'СПД➖52(4MF-20Ar-4М1-20Ar-4i)',
        'СПО➖32(6М1-20-6М1)',
        'СПО➖32(4М1-24-4М1)',
        'СПО➖14(4М1-6-4М1)',
        'СПО➖16(4М1-8-4М1)',
        'СПО➖18(4М1-10-4М1)',
        'СПО➖20(4М1-12-4М1)',
        'СПО➖22(4М1-14-4М1)',
        'СПО➖24(4М1-16-4М1)',
        'СПТ➖52(4MF-12Kr-4М1-12Kr-4М1-12Kr-4И)',
        'СПД➖38(8СИз-12Ar-6М1з-12Ar-И4.4.2)',
        'СПД➖24(4М1-6-4М1-6-4М1)',
        'СПД➖28(4М1-8-4М1-8-4М1)',
        'СПД➖32(4М1-10-4М1-10-4М1)',
        'СПД➖36(4М1-12-4М1-12-4М1)',
        'СПД➖40(4М1-14-4М1-14-4М1)',
        'СПД➖52(4MF-20Ar-4М1-20Ar-4i)',
        'СПО➖16(4М1-Ar8-4М1)',
        'СПО➖18(4М1-Ar10-4М1)',
        'СПО➖20(4М1-Ar12-4М1)',
        'СПО➖24(4М1-Ar16-4М1)',
        'СПО➖16(4М1-8-K4)',
        'СПО➖18(4М1-10-K4)',
        'СПО➖20(4М1-12-K4)',
        'СПО➖18(4М1-Ar10-K4)',
        'СПО➖20(4М1-Ar12-K4)',
        'СПО➖20(4М1-Ar16-K4)',
        'СПО➖16(4М1-8-И4)',
        'СПО➖18(4М1-10-И4)',
        'СПО➖20(4М1-12-И4)',
        'СПО➖24(4М1-16-И4)',
        'СПО➖16(4М1-Ar8-И4)',
        'СПО➖18(4М1-Ar10-И4)',
        'СПО➖20(4М1-Ar12-И4)',
        'СПО➖24(4М1-Ar16-И4)',
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\'>Шпросы</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Пленка для защиты от солнца</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Тонирующая оконная плёнка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Зеркальная пленка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Защитная пленка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Матовая пленка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Обогрев</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Электрохромное стекло(смарт-стекло)</input>',
        'Сэндвич➖S10', 'Сэндвич➖S24', 'Сэндвич➖S32', 'Сэндвич➖S40', 'Стекло Mi➖4',
        'Стекло Mi➖6', 'Стекло➖4М1', 'Стекло➖4А-Армированное', 'Стекло➖4AC-Active Clear-самоочищающиеся стекла',
        'Стекло➖4 ТОП', 'Стекло➖3.3.1 (два 3-мм стекла и 1-мм пленка)', 'Стекло➖4.4.1 (два стекла по 4 мм и пленка 1 мм)',
        'Стекло➖МС 33.2 (два стекла 3 мм и пленка 2 мм)', 'Стекло➖Stratobel Clear 3.3.1', 'Стекло➖Stratobel Clear 4.4.1',
        'Стекло➖Optilam Clear 3.3.1', 'Стекло➖Optilam Clear 4.4.1', 'Стекло➖SunStop 4мм.', 'Стекло➖StopSol 4мм.',
        'Стекло➖ANTELIO 4мм.', 'Стекло➖4SGSolar 4мм.', 'Стекло➖Pilkington Optitherm S1',
        'Стекло➖Pilkington Optitherm S3', 'Стекло➖ClimaGard N',
        'Стекло➖CLGuN', 'Стекло➖ENplus', 'Стекло➖ZERO (ZERO-E)',
        'Стекло➖Futur-N', 'Стекло➖MF', 'Стекло➖SunCool',
        'Стекло➖ClimaGard Solar', 'Стекло➖GuSolar', 'Стекло➖StopReyNeo', 'Стекло➖SELEKT',
        'Стекло➖LifeGlassGear', 'Стекло➖4T1 Bronze', 'Стекло➖4MF Neutral', 'Стекло➖6M1',
        'Стекло➖Тop N стекло 6мм.', 'Стекло➖Закаленное 6мм.', 'Стекло➖6 Comfort Elit',
        'Стекло➖Закаленное 4мм', 'Стекло➖ESG 4мм Закаленное', 'Стекло➖6MF Neutral'],
    'Дом': ['---',
        'Панельный',
        '🧱Кирпичный',
        'Монолит',
        'Газобетон',
        'Сталинский',
        '🌳Деревянный',
        'Старый фонд',
        'Обсадная коробка',
        'Не могу определить',
        'П-3', 'П-30', 'П-44',
        'П-44Т', 'П-46', 'КОПЭ', 'II-68',
        'II-18/12', 'П-3М', 'П-43', 'П-44М', 'П-55',
        'П-55М', 'ПД-4', 'И-209А', 'И-491А', 'И-522А',
        'И-700А', '1-510', '1-511', '1-515/5', '1-515/9',
        '1605/9', '1605/12', 'II-01', 'II-02', 'II-03',
        'II-04', 'II-18/9', 'II-29', 'II-49', 'II-57',
        'II-68/02', 'II-68/03', 'II-67 МОСКВ.',
        'II-67 СМИРН.', 'II-67 ТИШ.', 'Б. ВУЛЫХА'],
    'Подъезд': ['---', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    'ПланДатаРемонта': ['Затрудняюсь ответить', 'В этом месяце', 'Как можно скорее'],
    'Стекло1': ['4М1', '6M1', '8СИз', 'И4.4.2', '4К',
        'Закаленное 4мм.',
        'Триплекс 3.3', 'Триплекс 4.4', '6М1з', 'И4', 'K4', 'Тонировка', 'Шумоизоляционное',
        'Энергосберегающее', 'Мультифункциональное', '+ Жалюзи'],
    'Рамка1': ['6', '8',
        '<input class=\'cb pristine\' type=\'checkbox\'>Теплая рамка</input>',
        '10', '12', '14', '16', '18', '20', '10ТР', '12Kr', '10Ar', '12Ar', '20Ar'],
    'Стекло2': ['---', '4М1', '6M1', '8СИз', 'И4.4.2', '4К', 'Закаленное 4мм.',
        'Триплекс 3.3', 'Триплекс 4.4', '6М1з', 'И4', 'K4', 'Тонировка', 'Шумоизоляционное',
        'Энергосберегающее', 'Мультифункциональное', '+ Жалюзи'],
    'Рамка2': ['---', '6', '8', '<input class=\'cb pristine\' type=\'checkbox\'>Теплая рамка</input>', '10', '12', '14', '16', '18', '20', '10ТР', '12Kr', '10Ar', '12Ar', '20Ar'],
    'Стекло3': ['---', '4М1', '6M1', '8СИз', 'И4.4.2', '4К', 'Закаленное 4мм.', 'Триплекс 3.3', 'Триплекс 4.4', '6М1з', 'И4', 'K4', 'Тонировка', 'Шумоизоляционное', 'Энергосберегающее', 'Мультифункциональное', '+ Жалюзи'],
    'Рамка3': ['---', '6', '8', '<input class=\'cb pristine\' type=\'checkbox\'>Теплая рамка</input>', '10', '12', '14', '16', '18', '20', '10ТР', '12Kr', '10Ar', '12Ar', '20Ar'],
    'СтворкаОкна': ['<h4>Глухое➕(F)</h4>',
        '<h4>Поворотное Лево▶️</h4>',
        '<h4>Поворотное◀️Право</h4>',
        '<h4>Поворотно-откидное Лево⬆️⬅️</h4>',
        '<h4>Поворотно-откидное Право➡️⬆️</h4>',
        '<h4>Фрамужное⬆️</h4>',
        '<h4>Фрамужное⬇️</h4>',
        '<h4><input class=\'cb pristine\' title=\'\' type=\'checkbox\'>Блокировщик ошибочного открывания</input></h4>',
        '<h4><input class=\'cb pristine\' title=\'\' type=\'checkbox\'>Противовзломная</input></h4>',
        '<h4>Раздвижные◀️ ▶️</h4>',
        '<h4>Раздвижные⬆️⬇️</h4>',
        '<h4>Складная створка➡️⬅️</h4>',
        '<h4>Поворотная по вертикальной оси⤸</h4>',
        '<h4>Поворотная по горизонтальной оси↷</h4>',
        '<h4>Ставни</h4>',
        '<h4>Штульповая</h4>'],
    'СтворкаДверь': ['<h4>Поворотное Лево▶️</h4>',
        '<h4>Поворотное◀️Право</h4>',
        '<h4>Кламбустер</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/ББ/Балконная ручка пластик.png\' class=\'scale\' alt=\'\' style=\'width: 50px; height: auto;\'/><input class=\'cb pristine\' title=\'\' type=\'checkbox\'>Балконная ручка пластик</input></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/ББ/Балконная ручка металл.webp\' class=\'scale\' alt=\'\' style=\'width: 50px; height: auto;\'/><input class=\'cb pristine\' title=\'\' type=\'checkbox\'>Балконная ручка металл</input></h4>',
        '<h4>Поворотно-откидное Лево⬆️⬅️</h4>',
        '<h4>Поворотно-откидное Право➡️⬆️</h4>',
        '<h4>Раздвижные◀️ ▶️️</h4>'],
    'СтворкаДверьВХГ': ['<h4>Поворотное Лево▶️</h4>',
        '<input class=\'cb pristine\' title=\'\' type=\'checkbox\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/.webp\' class=\'scale\' alt=\'\' style=\'width: 50px; height: auto;\'/>Доводчик</input>',
        '<input class=\'cb pristine\' title=\'\' type=\'checkbox\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/.webp\' class=\'scale\' alt=\'\' style=\'width: 50px; height: auto;\'/>Металл пластина</input>',
        '<h4>Поворотное◀️Право</h4>', '<h4>Поворотно-откидное Лево⬆️⬅️</h4>', '<h4>Поворотно-откидное Право➡️⬆️</h4>',
        '<h4>Раздвижные◀️ ▶️️</h4>'],
    'Ламинация': ['---', 'Ламинация', 'Каширование'],
    'Угол': ['---', '90', '45', '125', 'Эркер'],
    BalconyCool: ['❄️Холод', '☀️Тепло'],
    Roof: ['---', '90', '45', 'Эркер'],
    'ВыносБалкона': ['---', 'По подоконнику', 'По парапету'],
    'Мсетка': ['---',
        'Стандарт',
        '<input class="cb pristine" type="number">М/С шт.</input>',
        '<input class="cb pristine" type="checkbox">М/С на все створки</input>',
        '🎁Обычная Подарок',
        '😼Антикошка',
        '🤧Антипыль',
        'Allum',
        'Раздвижная',
        'Плиссе SKF',
        'Плиссе(вставная)',
        'Плиссе(сдвижная)',
        'Coplanar',
        'Kepper',
        'На двери',
    ],
    'МсеткаТип': [
        '---',
        'Рамочная',
        '↔️Раздвижная',
        '↕️Роллетная',
        'Дверная',
        'Плиссе SKF',
        'Плиссе DFM',
    ],
    Balcony: ['---', 'Крыша', 'Освещение', 'Шкаф', 'Подоконники', 'Теплый пол', 'Отделка стен'],
    'ВентКлапан': [
        '---',
        'VENTEC VT 101 32 м3/ч',
        'VENTEC VT 601  21 м3/ч',
        '<h4><img src=\'/wp-content/uploads/2022/03/Окна/Vent/Comfort.png\' style=\'width: 100px; height: auto;\' />Air-Box Comfort до 31 м3/ч (при ∆Р=10Па)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Окна/Vent/Comfort MINI.png\' style=\'width: 100px; height: auto;\' />Air-Box Comfort MINI до 31 м3/ч (при ∆Р=10Па)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Окна/Vent/Standart.png\' style=\'width: 100px; height: auto;\' />Air-Box Standart до 18 м3/ч (при ∆Р=10Па)</h4>',
        '<h4>Комплект Air-Box Eco с фильтром G3 до 32 м3/ч (при ∆Р=10Па)</h4>',
        '<h4>Air-Box Eco Standart до 34 м3/ч (при ∆Р=10Па)</h4>', '<h4>Фильтр элемент для Air-Box Eco G3: 80-90%</h4>',
        '<h4>Фильтр элемент для Air-Box Eco G4: более 90%</h4>', '<h4>Air-Box Comfort с козырьком до 42 м3/ч (при ∆Р=10Па)</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/Окна/Vent/Comfort_S.png\' style=\'width: 100px; height: auto;\' />Air-Box Comfort S до 41 м3/ч (при ∆Р=10Па)</h4>',
        '<h4>Наружный защитный козырек Air-Box</h4>',
        '<h4>Aereco Комплект: приточное гигрорегулируемое устройство EMM2, козырек ASAM, 5-35 м3/ч, EHM1280 RU, RAL 8017 (тик)</h4>',
        '<h4>Aereco Комплект: клапан приточный EMM, 5-35 м3/ч, козырек ASAM, белый, EMM707</h4>',
        '<h4>Aereco Комплект: приточное гигрорегулируемое устройство EMM2, козырек ASAM, 5-35 м3/ч, EHM1282 RU, белый RAL9003</h4>',
        '<h4>Aereco Клапан приточный EHA2, 5-35 м3/ч, белый, EAR201</h4>',
        'Brookvent',
        'Norvind',
        'Siegenia',
    ],
    'ОткосыВнутр': [
        '---',
        '500х1500х1',
        '250мм. панель 3000',
        '250мм. панель 6000',
        '500мм.',
        'F-образный',
        'U-образный',
        'Сэндвич 10мм.',
        'Стартовый профиль П-обр.20х28',
        '500х2200х2',
        '250мм. панель 3000',
        'Пенопласт листовой 1000х2000 50мм.',
        'Пенопласт листовой 1000х2000 30мм.',
        '500х1000х1',
        'Профиль закрывающий',
        'Брусок деревянный 20х55х1150',
        'Брусок пенополистирольный 40х602020',
        '600х1500 Danke',
        'Панели ПВХ ламинированная белая',
        'Панели ПВХ ламинированная дуб золотой',
        'Панели ПВХ ламинированная махагон',
        'Профили стартовый ламинированный махагон',
        'Профили стартовый ламинированный дуб золотой',
        'Сэндвич-панели белая 10*1500*3000',
        'Сэндвич-панели белая 10*2000*3000',
        'Сэндвич-панели белая 24*1500*3000',
        'Сэндвич-панели белая 32*1500*3000',
        'Сэндвич-панели ламинированная венге',
        'Сэндвич-панели ламинированная венге черный',
        'Сэндвич-панели ламинированная дуб золотой',
        'Сэндвич-панели ламинированная дуб натуральный',
        'Сэндвич-панели ламинированная махагон',
        'Универсальный-Откос универсальный пластиковый',
        'Crystallit Антрацит мат.F- профиль(финишный)',
        'Crystallit Антрацит мат.П- профиль(стартовый)',
        'Crystallit Бел. Дуб гл.', 'Crystallit Бел. Дуб мат.',
        'Crystallit Белый гл.',
        'Crystallit Кремовый',
        'Crystallit Мрамор гл.',
        'Crystallit Мрамор мат.',
        'Crystallit ',
        'Crystallit Дуб нат.гл.',
        'Crystallit Дуб нат.мат.',
        'Crystallit Орех гл.',
        'Crystallit Орех мат.',
        'Crystallit Венге гл.',
        'Crystallit Венге мат.',
        'Crystallit Дуб зол.гл.',
        'Crystallit Дуб зол.мат.',
        'Möller Qunell Белый',
        'Möller Qunell Дуб Шеффилд матовый',
        'Möller Qunell Натуральный дуб матовый',
        'Möller Qunell Золотой дуб матовый',
        'Möller Qunell Орех матовый',
        'Möller Qunell Махагон матовый',
        'Möller Qunell Темный дуб матовый',
        'Морковка',
    ],
    'Подоконник': [
        '---',
        'Россия ЭЛЕКС белый матовый',
        'Россия ЭЛЕКС дуб темный матовый',
        'Россия ЭЛЕКС дуб золотой матовый',
        'Россия ЭЛЕКС орех матовый',
        'Россия ЭЛЕКС белый дуб матовый', 'Россия MONTBLANC - Махагон',
        'Комфорт THERMO PRO 550', 'Комфорт THERMO PRO 600',
        'Заглушка для подоконника 240 Комфорт THERMO PRO',
        'Заглушка для подоконника 40x600 Комфорт THERMO PRO',
        'DankeStandart➖150',
        'DankeStandart➖200',
        'DankeStandart➖250',
        'DankeStandart➖300',
        'DankeStandart➖350',
        'DankeStandart➖400',
        'DankeStandart➖450',
        'DankeStandart➖500',
        'DankeStandart➖550',
        'DankeStandart➖600',
        'DankeStandart➖700',
        '<input class="calcZV__input" type="checkbox">Danke Заглушка торцевая (пара)</input>',
        '<input class="calcZV__input" type="checkbox">Danke Угловое соединение</input>',
        '<input class="calcZV__input" type="checkbox">Danke Торцевая заглушка универсальная</input>',
        'DankeKomfort➖150', 'DankeKomfort➖200',
        'DankeKomfort➖250', 'DankeKomfort➖300',
        'DankeKomfort➖350',
        'DankeKomfort➖400',
        'DankePremium➖150',
        'DankePremium➖200',
        'DankePremium➖250',
        'DankePremium➖300',
        'DankePremium➖350',
        'DankePremium➖400',
        'Деревянные',
        'Из искусственного камня',
        'Из натурального камня',
        'Алюминиевые AlumSill ALS150',
        'Алюминиевые AlumSill ALS200',
        'Crystallit Антрацит гл.',
        'Crystallit Антрацит мат.',
        'Crystallit Бел. Дуб гл.',
        'Crystallit ', 'Crystallit ',
        'Crystallit ', 'Crystallit ',
        'Crystallit Кремовый',
        'Crystallit Мрамор гл.',
        'Crystallit Мрамор мат.',
        'Crystallit Дуб нат.гл.',
        'Crystallit Дуб нат.мат.',
        'Crystallit Оранж',
        'Crystallit Орех гл.',
        'Crystallit Орех мат.',
        'Crystallit Палермо гл.',
        'Crystallit Палермо мат.',
        'Crystallit Метелик',
        'Crystallit Вилья',
        'Crystallit Венге гл.',
        'Crystallit Венге мат.',
        'Crystallit Дуб зол.гл.',
        'Crystallit Дуб зол.мат.',
        'ESTERA (ПРОИЗВОДИТЕЛЬ CRYSTALLIT)белый глянец',
        'BauDeck - белое дерево', 'Möller LD-36',
        'Möller LD-S30',
        'Möller LD-40',
        'Vitrage DISCOVERY',
        'Vitrage VPL PREMIUM',
        'Vitrage PVC (Стандарт)',
        'Vitrage DESIGN',
        'Vitrage Плюс',
        'Deceuninck',
        'Fibersill',
        'Daniel Interior',
        'Melke', 'LUX-40',
        'Montblanc Белый',
        'Montblanc Золотой дуб',
        'Montblanc Махагон',
        'Montblanc Мрамор',
    ],
    impost: ['Импост', 'Штульп'],
    'Порог': ['---', '100', '200', '300', '400', '500'],
    'УголкиПластик': [
        '---',
        'Уголок 50x18x3x100˚ Комфорт THERMO PRO',
        'Уголок 50x35x2x90˚ Комфорт THERMO PRO',
        'Пластик 50х3000х10', 'Пластик 100х20',
        'Пластик 120х35', 'Пластик 35х50',
        'Пластик 40х15', 'Пластик 40х40',
        'Пластик 50х18', 'Пластик 75х35',
        'Пластик 70х3000х20',
        'Металл 100x3000x20',
        'Металл 50х3000х10',
        'Металл 100х20',
        'Металл 120х35',
        'Металл 35х50',
        'Металл 40х15',
        'Металл 40х40',
        'Металл 50х18',
        'Металл 75х35',
        'Металл 70х3000х20',
        'Металл 100x3000x20',
    ],
    'Отлив': [
        '---',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Козырьки/1. Отлив стандарт.png\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип1</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Козырьки/8. Отлив.png\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип8</h4>', '100', '200', '300', '400', '500'
    ],
    'Козырек': ['---',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Козырьки/2. Козырек.png\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип2</h4>', '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Козырьки/3. Козырек.png\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип3</h4>', '100', '200', '300', '400', '500'],
    'НащельникМетал': ['---', 'Самоклей', '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Козырьки/10. Нащельник-уголок.png\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип10</h4>', '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Козырьки/11. Нащельник.png\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип11</h4>', 'Металл-100', 'Металл-200', 'Металл-300', 'Пластик-100', 'Пластик-200', 'Пластик-300', 'Дерево-100', 'Дерево-200', 'Дерево-300'],
    'МестоХранения': ['---', 'Есть'],
    'Наличие220V': ['---', '220V', '380V'],
    'ДопПена': [
        '---',
        '1-баллон',
        '<input class="calcZV__input" type="number">',
        '2-баллона',
        '3-баллона',
        '4-баллона',
        '5-баллонов',
        '6-баллонов',
        '7-баллонов',
        '8-баллонов',
        '9-баллонов',
        '10-баллонов',
    ],
    Lift: [
        '---',
        'Ручной подъем',
        'Ручной подъем на веревках',
        'Подъем техникой',
        '<input class=\'cb pristine\' type=\'checkbox\'>Пассажирский лифт</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Грузовой лифт</input>',
    ],
    'ЮвелирныйДеМонтаж': ['---', '<input class=\'cb pristine\' type=\'checkbox\'>Стандарт</input>', '<input class=\'cb pristine\' type=\'checkbox\'>Премиум</input>', '<input class=\'cb pristine\' type=\'checkbox\'>Элит</input>', '<input class=\'cb pristine\' type=\'checkbox\'>Стремянка</input>', '<input class=\'cb pristine\' type=\'checkbox\'></input>', 'Демонтаж', 'С сохранением', 'Без ненорматив.лексикона', 'Срубка откосов', 'Срубка четвертей', 'Расширение проема', 'Подъем уровня под окном'],
    'ВывозМусора': [
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\' checked>Доставка</input>',
        'Вынос из помещения', 'Вынос на улицу',
        'Вынос мусора в контенер до 50м. от подъезда', 'Вывоз до 50км.',
    ],
    'Сварка': [
        '---',
        '<input class=\'cb pristine\' title=\'Состав работ\' type=\'checkbox\'> С1️⃣➖Лоджия L до 3200мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С2️⃣➖Лоджия L до 6500мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С3️⃣➖Балкон L до 3200мм.(2 стороны)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С4️⃣➖Балкон L до 3200мм.(3 стороны)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С5️⃣➖Балкон L до 6500мм.(2 стороны)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С6️⃣➖Балкон L до 6500мм.(3 стороны)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С7️⃣➖Лоджия L до 3200мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С8️⃣➖Лоджия L до 6500мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С9️⃣➖Балкон L до 3200мм.(2 стороны)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣0️⃣➖Балкон L до 3200мм.(3 стороны)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣1️⃣➖Балкон L до 6500мм.(2 стороны)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣2️⃣➖Балкон L до 6500мм.(3 стороны)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣3️⃣➖Балкон L до 3200мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣4️⃣➖Балкон L до 6500мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣5️⃣➖Балкон L до 3200мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣6️⃣➖Балкон L до 6500мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣7️⃣➖Лоджия L до 3200мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣8️⃣➖Лоджия L до 6500мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С1️⃣9️⃣➖Балкон L до 3200мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С2️⃣0️⃣➖Балкон L до 6500мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С2️⃣1️⃣➖Балкон L до 3200мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С2️⃣2️⃣➖Балкон L до 6500мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С2️⃣3️⃣➖Балкон L до 3200мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С2️⃣4️⃣➖Балкон L до 6500мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С2️⃣5️⃣➖Дополнительная стойка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> С2️⃣6️⃣➖Зашивка профлистом боковины над парапетом</input>',
    ],
    'Отделка': [
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\'> О1️⃣➖Обшивка ПВХ панелями</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О2️⃣➖Обшивка ламинированными панелями</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О3️⃣➖Обшивка МДФ панелями (только теплые помещения)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О4️⃣➖Обшивка Евро вагонкой</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О5️⃣➖Устройство пола</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О6️⃣➖Настил линолеума (с плинтусами)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О7️⃣➖Настил ламината (с плинтусами)</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О8️⃣➖Утепление с экструзией (пенополистиролом) 30мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О9️⃣➖Утепление с экструзией (пенополистиролом) 50мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О1️⃣0️⃣➖Утепление с экструзией (пенополистиролом) 100мм.</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О1️⃣1️⃣➖Электрика</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'> О1️⃣2️⃣➖Монтаж подоконника</input>',
    ],
    'Фальшпереплеты': ['---', 'Венские', 'Венецианские'],
    sprats: [
        '---',
        'Конструктивные', 'Межстекольные',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип1.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип1</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип2.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип2</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип3.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип3</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип4.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип4</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип5.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип5</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип6.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип6</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип7.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип7</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип8.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип8</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип9.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип9</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип10.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип10</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип11.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип11</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип12.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип12</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип13.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип13</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип14.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип14</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип15.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип15</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип16.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип16</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип17.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип17</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип18.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип18</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип19.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип19</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип20.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип20</h2>',
        '<h2><img src=\'/wp-content/themes/mesmerize-child/assets/img/Окна/Шпросы/Шпрос Тип21.jpg\' alt=\'\' class=\'scale\' style=\'width: 80px; height: auto;\'>Тип21</h2>',
    ],
    'Конфигурация': ['---', 'Есть', 'О12'],
    'КонфигурацияББ': ['---', 'Есть', 'О12'],
    'БалконДоп': ['---', 'Крыша', 'Освещение', 'Шкаф', 'Подоконник', 'Теплый пол', 'Отделка стен'],
    'ЗамерныйЛист': ['---', 'Новый-предварительный', 'Перемер(после сварки)', 'В работу(договор)'],
    'Прайс': ['Эконом', 'Стандарт', 'Стандарт+', 'Комфорт', 'Премиум', 'Люкс'],
    'СтенаЛеваяНаружнаяБалкон': ['---', 'Сайдинг', 'Профлист', 'Гофролист'],
    'СтенаЛеваяЦентрБалкон': ['---', 'Сайдинг', 'Профлист'],
    'СтенаПраваяНаружнаяБалкон': ['---', 'Сайдинг', 'Профлист'],
    'СтенаЛеваяВерхБалкон': ['---', 'ПВХ-панели', 'Профлист', '<input class=\'cb pristine\' type=\'checkbox\'>Утеплитель</input>'],
    'СтенаЦентрВерхБалкон': ['---', 'ПВХ-панели', 'Профлист', '<input class=\'cb pristine\' type=\'checkbox\'>Утеплитель</input>'],
    'СтенаПраваяВерхБалкон': ['---', 'ПВХ-панели', 'Профлист', '<input class=\'cb pristine\' type=\'checkbox\'>Утеплитель</input>'],
    'СтенаЛеваяНизБалкон': ['---', 'ПВХ-панели', 'Профлист', '<input class=\'cb pristine\' type=\'checkbox\'>Утеплитель</input>'],
    'ПарапетВнутрБалкон': ['---', 'Деревянная вагонка', 'Пластиковая панель', 'Пластиковая вагонка', 'Ламинированная панель', 'ППУ/Polynor', 'Пенеплэкс 20мм', 'Пенеплэкс 30мм', 'Пенеплэкс 50мм', 'ПВХ-панели', 'Гипсокартон', 'ГВЛ', 'Профлист', '<input class=\'cb pristine\' type=\'checkbox\'>Утеплитель</input>'],
    'ПарапетВнешБалкон': ['---', 'Кладка пеноблока', 'Б/Каркас', 'Экран', 'Сайдинг', '7,5', '10', '30х40', '70х50', '100х50', 'Профлист', 'Фартук', 'Фальш стена', 'Торцевой короб', 'Устройство выноса'],
    'СтенаПраваяНизБалкон': ['---', 'ПВХ-панели', 'Профлист', '<input class=\'cb pristine\' type=\'checkbox\'>Утеплитель</input>'],
    'ПолБалкон': ['---', 'Ламинат', 'Линолеум', 'Плитка', 'Стяжка/Выравнивание пола', 'Подем пола', 'Доска пола'],
    'ПолПлинтусБалкон': ['---', 'Пластик', 'Дерево'],
    'ПДКЛевоБалкон': [
        '---',
        'Пластик',
        'Дерево',
        '<input class=\'cb pristine\' type=\'checkbox\'>Заглушка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Соединитель</input>',
    ],
    'ПДКЦентрБалкон': [
        '---',
        'Пластик',
        'Дерево',
        '<input class=\'cb pristine\' type=\'checkbox\'>Заглушка</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Соединитель</input>'
    ],
    'ПДКПравоБалкон': ['---', 'Пластик', 'Дерево', '<input class=\'cb pristine\' type=\'checkbox\'>Заглушка</input>', '<input class=\'cb pristine\' type=\'checkbox\'>Соединитель</input>'],
    'ПотолокБалкон': ['---', 'Сушилка', 'ПВХ-панели', 'Профлист', '<input class=\'cb pristine\' type=\'checkbox\'>Утеплитель</input>', '<input class=\'cb pristine\' type=\'checkbox\'>Светильник</input>'],
    'ШкафВСтене': ['---', 'Ламинат', 'Линолеум'],
    'ШкафБалконный': ['---', 'Распашной', 'Купе', 'Тумба'],
    'Холодильник': ['---', 'Ламинат', 'Линолеум'],
    angleE: ['100', '90', '60', '45', '120'],
    angleF: ['100', '90', '60', '45', '120'],
    angleG: ['150', '90', '60', '45', '120'],
    winA: ['10', '15', '20', '25', '30'],
    ralwin: [
        '◻️9003 Белый',
        '<input class=\'cb pristine\' type=\'checkbox\'>Каширование</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'>Ламинирование</input>',
        '9016 Транспортный белый', '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Ral/1000.jpg\' style=\'width: 50px; height: auto;\' />1000-Зелёно-бежевый',
        '1001-Бежевый',
        '🟨1003-Сигнальный жёлтый',
        '1004-Жёлто-золотой',
        '1004-Жёлто-золотой',
        '1006-Кукурузно-жёлтый',
        '1007 Нарциссово-жёлтый',
        '1011 Коричнево-бежевый',
        '1012 Лимонно-жёлтый',
        '1013 Жемчужно-белый',
        '1014 Слоновая кость',
        '1015 Светлая слоновая кость',
        '1016 Жёлтая сера',
        '1017 Шафраново-жёлтый',
        '1018 Цинково-жёлтый',
        '1019 Серо-бежевый',
        '1020 Оливково-жёлтый',
        '1021 Рапсово-жёлтый',
        '1023 Транспортно-жёлтый',
        '1024 Охра жёлтая',
        '1026 Люминесцентный жёлтый',
        '1027 Карри жёлтый',
        '1028 Дынно-жёлтый',
        '1032 Жёлтый ракитник',
        '1033 Георгиново-жёлтый',
        '1034 Пастельно-жёлтый',
        '1035 Перламутрово-бежевый',
        '1036 Перламутрово-золотой',
        '1037 Солнечно-жёлтый',
        '2000 Жёлто-оранжевый',
        '2001 Красно-оранжевый',
        '2002 Алый',
        '2003 Пастельно-оранжевый',
        '🟧2004 Оранжевый',
        '2005 Люминесцентный оранжевый',
        '2007 Люминесцентный ярко-оранжевый',
        '2008 Ярко-красно-оранжевый',
        '2009 Транспортный оранжевый',
        '2010 Сигнальный оранжевый',
        '2011 Насыщенный оранжевый',
        '2012 Лососёво-оранжевый',
        '2013 Перламутрово-оранжевый',
        '🟥3000 Огненно-красный',
        '3001 Сигнальный красный',
        '3002 Карминно-красный',
        '3003 Рубиново-красный',
        '3004 Пурпурно-красный',
        '3005 Винно-красный',
        '3007 Чёрно-красный',
        '3009 Оксид красный',
        '3011 Коричнево-красный',
        '3012 Бежево-красный',
        '3013 Томатно-красный',
        '3014 Розовый антик',
        '3015 Светло-розовый',
        '3016 Кораллово-красный',
        '3017 Розовый',
        '3018 Клубнично-красный',
        '3020 Транспортный красный',
        '3022 Лососёво-красный',
        '3024 Люминесцентный красный',
        '3026 Люминесцентный ярко-красный',
        '3027 Малиново-красный',
        '3028 Красный', '3031 Ориент красный',
        '3032 Перламутрово-рубиновый',
        '3033 Перламутрово-розовый',
        '4001 Красно-сиреневый',
        '4002 Красно-фиолетовый',
        '4003 Вересково-фиолетовый',
        '4004 Бордово-фиолетовый',
        '4005 Сине-сиреневый',
        '4006 Транспортный пурпурный',
        '4007 Пурпурно-фиолетовый',
        '🟪4008 Сигнальный фиолетовый',
        '4009 Пастельно-фиолетовый',
        '4010 Телемагента',
        '4011 Перламутрово-фиолетовый',
        '4012 Перламутрово-ежевичный',
        '5000 Фиолетово-синий',
        '5001 Зелёно-синий',
        '5002 Ультрамариново-синий',
        '5003 Сапфирово-синий',
        '5004 Чёрно-синий',
        '🟦5005 Сигнальный синий',
        '5007 Бриллиантово-синий',
        '5008 Серо-синий',
        '5009 Лазурно-синий',
        '5010 Горечавково-синий',
        '5011 Стально-синий',
        '5012 Голубой',
        '5013 Кобальтово-синий',
        '5014 Голубино-синий',
        '5015 Небесно-синий',
        '5017 Транспортный синий',
        '5018 Бирюзово-синий',
        '5019 Капри синий',
        '5020 Океанская синь',
        '5021 Водная синь',
        '5022 Ночной синий',
        '5023 Отдалённо-синий',
        '5024 Пастельно-синий',
        '5025 Перламутровый горечавково-синий',
        '5026 Перламутровый ночной синий',
        '6000 Патиново-зелёный',
        '6001 Изумрудно-зелёный',
        '6002 Лиственно-зелёный',
        '6003 Оливково-зелёный',
        '6004 Сине-зелёный',
        '🟩6005 Зелёный мох',
        '6006 Серо-оливковый',
        '6007 Бутылочно-зелёный',
        '6008 Коричнево-зелёный',
        '6009 Пихтовый зелёный',
        '6010 Травяной зелёный',
        '6011 Резедово-зелёный',
        '6012 Чёрно-зелёный',
        '6013 Тростниково-зелёный',
        '6014 Жёлто-оливковый',
        '6015 Чёрно-оливковый',
        '6016 Бирюзово-зелёный',
        '6017 Майский зелёный',
        '6018 Желто-зелёный',
        '6019 Бело-зелёный',
        '6020 Хромовый зелёный',
        '6021 Бледно-зелёный',
        '6022 Коричнево-оливковый',
        '6024 Транспортный зелёный',
        '6025 Папоротниково-зелёный',
        '6026 Опаловый зелёный',
        '6027 Светло-зелёный',
        '6028 Сосновый зелёный',
        '6029 Мятно-зелёный',
        '6032 Сигнальный зелёный',
        '6033 Мятно-бирюзовый',
        '6034 Пастельно-бирюзовый',
        '6035 Перламутрово-зелёный',
        '6036 Перламутровый опаловый зелёный',
        '6037 Зелёный',
        '6038 Люминесцентный зелёный',
        '7000 Серая белка',
        '7001 Серебристо-серый',
        '7002 Оливково-серый',
        '7003 Серый мох',
        '7004 Сигнальный серый',
        '7005 Мышино-серый',
        '7006 Бежево-серый',
        '7008 Серое хаки',
        '7009 Зелёно-серый',
        '7010 Брезентово-серый',
        '7011 Железно-серый',
        '7012 Базальтово-серый',
        '7013 Коричнево-серый',
        '7015 Сланцево-серый',
        '7016 Антрацитово-серый',
        '7021 Чёрно-серый',
        '7022 Серая умбра',
        '7023 Серый бетон',
        '7024 Графитовый серый',
        '7026 Гранитовый серый',
        '7030 Каменно-серый',
        '7031 Сине-серый',
        '7032 Галечный серый',
        '7033 Цементно-серый',
        '7034 Жёлто-серый',
        '7035 Светло-серый',
        '7036 Платиново-серый',
        '7037 Пыльно-серый',
        '7038 Агатовый серый',
        '7039 Кварцевый серый',
        '7040 Серое окно',
        '7042 Транспортный серый A',
        '7043 Транспортный серый B',
        '7044 Серый шёлк',
        '7045 Телегрей 1',
        '7046 Телегрей 2',
        '7047 Телегрей 3',
        '7048 Перламутровый мышино-серый',
        '8000 Зелёно-коричневый',
        '8001 Охра коричневая',
        '🟫8002 Сигнальный коричневый',
        '8003 Глиняный коричневый',
        '8004 Медно-коричневый',
        '8007 Олень коричневый',
        '8008 Оливково-коричневый',
        '8011 Орехово-коричневый',
        '8012 Красно-коричневый',
        '8014 Сепия коричневый',
        '8015 Каштаново-коричневый',
        '8016 Махагон коричневый',
        '8017 Шоколадно-коричневый',
        '8019 Серо-коричневый',
        '8022 Чёрно-коричневый',
        '8023 Оранжево-коричневый',
        '8024 Бежево-коричневый',
        '8025 Бледно-коричневый',
        '8028 Терракотовый',
        '8029 Перламутровый медный',
        '9001 Кремово-белый',
        '9002 Светло-серый',
        '◼️9004 Сигнальный чёрный',
        '9005 Чёрный янтарь',
        '9006 Бело-алюминиевый',
        '9007 Тёмно-алюминиевый',
        '9010 Белый',
        '9011 Графитно-чёрный',
        '9017 Транспортный чёрный',
        '9018 Папирусно-белый',
        '9022 Перламутровый светло-серый',
        '9023 Перламутровый тёмно-серый',
    ],
    ralwinsealer: [
        '◼️9004 Чёрный',
        '◻️9003 Белый',
        '9016 Транспортный белый',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Ral/1000.jpg\' style=\'width: 50px; height: auto;\' />1000-Зелёно-бежевый',
        '1001-Бежевый', '🟨1003-Сигнальный жёлтый',
        '1004-Жёлто-золотой',
        '1004-Жёлто-золотой',
        '1006-Кукурузно-жёлтый',
        '1007 Нарциссово-жёлтый',
        '1011 Коричнево-бежевый',
        '1012 Лимонно-жёлтый',
        '1013 Жемчужно-белый',
        '1014 Слоновая кость',
        '1015 Светлая слоновая кость',
        '1016 Жёлтая сера', '1017 Шафраново-жёлтый',
        '1018 Цинково-жёлтый',
        '1019 Серо-бежевый',
        '1020 Оливково-жёлтый',
        '1021 Рапсово-жёлтый',
        '1023 Транспортно-жёлтый',
        '1024 Охра жёлтая',
        '1026 Люминесцентный жёлтый',
        '1027 Карри жёлтый',
        '1028 Дынно-жёлтый',
        '1032 Жёлтый ракитник',
        '1033 Георгиново-жёлтый',
        '1034 Пастельно-жёлтый',
        '1035 Перламутрово-бежевый',
        '1036 Перламутрово-золотой',
        '1037 Солнечно-жёлтый',
        '2000 Жёлто-оранжевый',
        '2001 Красно-оранжевый',
        '2002 Алый',
        '2003 Пастельно-оранжевый',
        '🟧2004 Оранжевый',
        '2005 Люминесцентный оранжевый',
        '2007 Люминесцентный ярко-оранжевый',
        '2008 Ярко-красно-оранжевый',
        '2009 Транспортный оранжевый',
        '2010 Сигнальный оранжевый',
        '2011 Насыщенный оранжевый',
        '2012 Лососёво-оранжевый',
        '2013 Перламутрово-оранжевый',
        '🟥3000 Огненно-красный',
        '3001 Сигнальный красный',
        '3002 Карминно-красный',
        '3003 Рубиново-красный',
        '3004 Пурпурно-красный',
        '3005 Винно-красный',
        '3007 Чёрно-красный',
        '3009 Оксид красный',
        '3011 Коричнево-красный',
        '3012 Бежево-красный',
        '3013 Томатно-красный',
        '3014 Розовый антик',
        '3015 Светло-розовый',
        '3016 Кораллово-красный',
        '3017 Розовый',
        '3018 Клубнично-красный',
        '3020 Транспортный красный',
        '3022 Лососёво-красный',
        '3024 Люминесцентный красный',
        '3026 Люминесцентный ярко-красный',
        '3027 Малиново-красный',
        '3028 Красный',
        '3031 Ориент красный',
        '3032 Перламутрово-рубиновый',
        '3033 Перламутрово-розовый',
        '4001 Красно-сиреневый',
        '4002 Красно-фиолетовый',
        '4003 Вересково-фиолетовый',
        '4004 Бордово-фиолетовый',
        '4005 Сине-сиреневый',
        '4006 Транспортный пурпурный',
        '4007 Пурпурно-фиолетовый',
        '🟪4008 Сигнальный фиолетовый',
        '4009 Пастельно-фиолетовый',
        '4010 Телемагента',
        '4011 Перламутрово-фиолетовый',
        '4012 Перламутрово-ежевичный',
        '5000 Фиолетово-синий',
        '5001 Зелёно-синий',
        '5002 Ультрамариново-синий',
        '5003 Сапфирово-синий',
        '5004 Чёрно-синий',
        '🟦5005 Сигнальный синий',
        '5007 Бриллиантово-синий',
        '5008 Серо-синий',
        '5009 Лазурно-синий',
        '5010 Горечавково-синий',
        '5011 Стально-синий',
        '5012 Голубой',
        '5013 Кобальтово-синий',
        '5014 Голубино-синий',
        '5015 Небесно-синий',
        '5017 Транспортный синий',
        '5018 Бирюзово-синий',
        '5019 Капри синий',
        '5020 Океанская синь',
        '5021 Водная синь',
        '5022 Ночной синий',
        '5023 Отдалённо-синий',
        '5024 Пастельно-синий',
        '5025 Перламутровый горечавково-синий',
        '5026 Перламутровый ночной синий',
        '6000 Патиново-зелёный',
        '6001 Изумрудно-зелёный',
        '6002 Лиственно-зелёный',
        '6003 Оливково-зелёный',
        '6004 Сине-зелёный',
        '🟩6005 Зелёный мох',
        '6006 Серо-оливковый',
        '6007 Бутылочно-зелёный',
        '6008 Коричнево-зелёный',
        '6009 Пихтовый зелёный',
        '6010 Травяной зелёный',
        '6011 Резедово-зелёный',
        '6012 Чёрно-зелёный',
        '6013 Тростниково-зелёный',
        '6014 Жёлто-оливковый',
        '6015 Чёрно-оливковый',
        '6016 Бирюзово-зелёный',
        '6017 Майский зелёный',
        '6018 Желто-зелёный',
        '6019 Бело-зелёный',
        '6020 Хромовый зелёный',
        '6021 Бледно-зелёный',
        '6022 Коричнево-оливковый',
        '6024 Транспортный зелёный',
        '6025 Папоротниково-зелёный',
        '6026 Опаловый зелёный',
        '6027 Светло-зелёный',
        '6028 Сосновый зелёный',
        '6029 Мятно-зелёный',
        '6032 Сигнальный зелёный',
        '6033 Мятно-бирюзовый',
        '6034 Пастельно-бирюзовый',
        '6035 Перламутрово-зелёный',
        '6036 Перламутровый опаловый зелёный',
        '6037 Зелёный',
        '6038 Люминесцентный зелёный',
        '7000 Серая белка',
        '7001 Серебристо-серый',
        '7002 Оливково-серый',
        '7003 Серый мох',
        '7004 Сигнальный серый',
        '7005 Мышино-серый',
        '7006 Бежево-серый',
        '7008 Серое хаки', '7009 Зелёно-серый',
        '7010 Брезентово-серый',
        '7011 Железно-серый',
        '7012 Базальтово-серый',
        '7013 Коричнево-серый',
        '7015 Сланцево-серый',
        '7016 Антрацитово-серый',
        '7021 Чёрно-серый',
        '7022 Серая умбра',
        '7023 Серый бетон',
        '7024 Графитовый серый',
        '7026 Гранитовый серый',
        '7030 Каменно-серый',
        '7031 Сине-серый',
        '7032 Галечный серый',
        '7033 Цементно-серый',
        '7034 Жёлто-серый',
        '7035 Светло-серый',
        '7036 Платиново-серый',
        '7037 Пыльно-серый',
        '7038 Агатовый серый',
        '7039 Кварцевый серый',
        '7040 Серое окно',
        '7042 Транспортный серый A',
        '7043 Транспортный серый B',
        '7044 Серый шёлк',
        '7045 Телегрей 1',
        '7046 Телегрей 2',
        '7047 Телегрей 3',
        '7048 Перламутровый мышино-серый',
        '8000 Зелёно-коричневый',
        '8001 Охра коричневая',
        '🟫8002 Сигнальный коричневый',
        '8003 Глиняный коричневый',
        '8004 Медно-коричневый',
        '8007 Олень коричневый',
        '8008 Оливково-коричневый',
        '8011 Орехово-коричневый',
        '8012 Красно-коричневый',
        '8014 Сепия коричневый',
        '8015 Каштаново-коричневый',
        '8016 Махагон коричневый',
        '8017 Шоколадно-коричневый',
        '8019 Серо-коричневый',
        '8022 Чёрно-коричневый',
        '8023 Оранжево-коричневый',
        '8024 Бежево-коричневый',
        '8025 Бледно-коричневый',
        '8028 Терракотовый',
        '8029 Перламутровый медный',
        '9001 Кремово-белый',
        '9002 Светло-серый',
        '9005 Чёрный янтарь',
        '9006 Бело-алюминиевый',
        '9007 Тёмно-алюминиевый',
        '9010 Белый',
        '9011 Графитно-чёрный',
        '9017 Транспортный чёрный',
        '9018 Папирусно-белый',
        '9022 Перламутровый светло-серый',
        '9023 Перламутровый тёмно-серый',
    ],
    ralwШтапик: [
        '◼️9004 Чёрный',
        '◻️9003 Белый',
        '9016 Транспортный белый',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Ral/1000.jpg\' style=\'width: 50px; height: auto;\' />1000-Зелёно-бежевый',
        '1001-Бежевый', '🟨1003-Сигнальный жёлтый',
        '1004-Жёлто-золотой',
        '1004-Жёлто-золотой',
        '1006-Кукурузно-жёлтый',
        '1007 Нарциссово-жёлтый',
        '1011 Коричнево-бежевый',
        '1012 Лимонно-жёлтый',
        '1013 Жемчужно-белый',
        '1014 Слоновая кость',
        '1015 Светлая слоновая кость',
        '1016 Жёлтая сера', '1017 Шафраново-жёлтый',
        '1018 Цинково-жёлтый',
        '1019 Серо-бежевый',
        '1020 Оливково-жёлтый',
        '1021 Рапсово-жёлтый',
        '1023 Транспортно-жёлтый',
        '1024 Охра жёлтая',
        '1026 Люминесцентный жёлтый',
        '1027 Карри жёлтый',
        '1028 Дынно-жёлтый',
        '1032 Жёлтый ракитник',
        '1033 Георгиново-жёлтый',
        '1034 Пастельно-жёлтый',
        '1035 Перламутрово-бежевый',
        '1036 Перламутрово-золотой',
        '1037 Солнечно-жёлтый',
        '2000 Жёлто-оранжевый',
        '2001 Красно-оранжевый',
        '2002 Алый',
        '2003 Пастельно-оранжевый',
        '🟧2004 Оранжевый',
        '2005 Люминесцентный оранжевый',
        '2007 Люминесцентный ярко-оранжевый',
        '2008 Ярко-красно-оранжевый',
        '2009 Транспортный оранжевый',
        '2010 Сигнальный оранжевый',
        '2011 Насыщенный оранжевый',
        '2012 Лососёво-оранжевый',
        '2013 Перламутрово-оранжевый',
        '🟥3000 Огненно-красный',
        '3001 Сигнальный красный',
        '3002 Карминно-красный',
        '3003 Рубиново-красный',
        '3004 Пурпурно-красный',
        '3005 Винно-красный',
        '3007 Чёрно-красный',
        '3009 Оксид красный',
        '3011 Коричнево-красный',
        '3012 Бежево-красный',
        '3013 Томатно-красный',
        '3014 Розовый антик',
        '3015 Светло-розовый',
        '3016 Кораллово-красный',
        '3017 Розовый',
        '3018 Клубнично-красный',
        '3020 Транспортный красный',
        '3022 Лососёво-красный',
        '3024 Люминесцентный красный',
        '3026 Люминесцентный ярко-красный',
        '3027 Малиново-красный',
        '3028 Красный',
        '3031 Ориент красный',
        '3032 Перламутрово-рубиновый',
        '3033 Перламутрово-розовый',
        '4001 Красно-сиреневый',
        '4002 Красно-фиолетовый',
        '4003 Вересково-фиолетовый',
        '4004 Бордово-фиолетовый',
        '4005 Сине-сиреневый',
        '4006 Транспортный пурпурный',
        '4007 Пурпурно-фиолетовый',
        '🟪4008 Сигнальный фиолетовый',
        '4009 Пастельно-фиолетовый',
        '4010 Телемагента',
        '4011 Перламутрово-фиолетовый',
        '4012 Перламутрово-ежевичный',
        '5000 Фиолетово-синий',
        '5001 Зелёно-синий',
        '5002 Ультрамариново-синий',
        '5003 Сапфирово-синий',
        '5004 Чёрно-синий',
        '🟦5005 Сигнальный синий',
        '5007 Бриллиантово-синий',
        '5008 Серо-синий',
        '5009 Лазурно-синий',
        '5010 Горечавково-синий',
        '5011 Стально-синий',
        '5012 Голубой',
        '5013 Кобальтово-синий',
        '5014 Голубино-синий',
        '5015 Небесно-синий',
        '5017 Транспортный синий',
        '5018 Бирюзово-синий',
        '5019 Капри синий',
        '5020 Океанская синь',
        '5021 Водная синь',
        '5022 Ночной синий',
        '5023 Отдалённо-синий',
        '5024 Пастельно-синий',
        '5025 Перламутровый горечавково-синий',
        '5026 Перламутровый ночной синий',
        '6000 Патиново-зелёный',
        '6001 Изумрудно-зелёный',
        '6002 Лиственно-зелёный',
        '6003 Оливково-зелёный',
        '6004 Сине-зелёный',
        '🟩6005 Зелёный мох',
        '6006 Серо-оливковый',
        '6007 Бутылочно-зелёный',
        '6008 Коричнево-зелёный',
        '6009 Пихтовый зелёный',
        '6010 Травяной зелёный',
        '6011 Резедово-зелёный',
        '6012 Чёрно-зелёный',
        '6013 Тростниково-зелёный',
        '6014 Жёлто-оливковый',
        '6015 Чёрно-оливковый',
        '6016 Бирюзово-зелёный',
        '6017 Майский зелёный',
        '6018 Желто-зелёный',
        '6019 Бело-зелёный',
        '6020 Хромовый зелёный',
        '6021 Бледно-зелёный',
        '6022 Коричнево-оливковый',
        '6024 Транспортный зелёный',
        '6025 Папоротниково-зелёный',
        '6026 Опаловый зелёный',
        '6027 Светло-зелёный',
        '6028 Сосновый зелёный',
        '6029 Мятно-зелёный',
        '6032 Сигнальный зелёный',
        '6033 Мятно-бирюзовый',
        '6034 Пастельно-бирюзовый',
        '6035 Перламутрово-зелёный',
        '6036 Перламутровый опаловый зелёный',
        '6037 Зелёный',
        '6038 Люминесцентный зелёный',
        '7000 Серая белка',
        '7001 Серебристо-серый',
        '7002 Оливково-серый',
        '7003 Серый мох',
        '7004 Сигнальный серый',
        '7005 Мышино-серый',
        '7006 Бежево-серый',
        '7008 Серое хаки', '7009 Зелёно-серый',
        '7010 Брезентово-серый',
        '7011 Железно-серый',
        '7012 Базальтово-серый',
        '7013 Коричнево-серый',
        '7015 Сланцево-серый',
        '7016 Антрацитово-серый',
        '7021 Чёрно-серый',
        '7022 Серая умбра',
        '7023 Серый бетон',
        '7024 Графитовый серый',
        '7026 Гранитовый серый',
        '7030 Каменно-серый',
        '7031 Сине-серый',
        '7032 Галечный серый',
        '7033 Цементно-серый',
        '7034 Жёлто-серый',
        '7035 Светло-серый',
        '7036 Платиново-серый',
        '7037 Пыльно-серый',
        '7038 Агатовый серый',
        '7039 Кварцевый серый',
        '7040 Серое окно',
        '7042 Транспортный серый A',
        '7043 Транспортный серый B',
        '7044 Серый шёлк',
        '7045 Телегрей 1',
        '7046 Телегрей 2',
        '7047 Телегрей 3',
        '7048 Перламутровый мышино-серый',
        '8000 Зелёно-коричневый',
        '8001 Охра коричневая',
        '🟫8002 Сигнальный коричневый',
        '8003 Глиняный коричневый',
        '8004 Медно-коричневый',
        '8007 Олень коричневый',
        '8008 Оливково-коричневый',
        '8011 Орехово-коричневый',
        '8012 Красно-коричневый',
        '8014 Сепия коричневый',
        '8015 Каштаново-коричневый',
        '8016 Махагон коричневый',
        '8017 Шоколадно-коричневый',
        '8019 Серо-коричневый',
        '8022 Чёрно-коричневый',
        '8023 Оранжево-коричневый',
        '8024 Бежево-коричневый',
        '8025 Бледно-коричневый',
        '8028 Терракотовый',
        '8029 Перламутровый медный',
        '9001 Кремово-белый',
        '9002 Светло-серый',
        '9005 Чёрный янтарь',
        '9006 Бело-алюминиевый',
        '9007 Тёмно-алюминиевый',
        '9010 Белый',
        '9011 Графитно-чёрный',
        '9017 Транспортный чёрный',
        '9018 Папирусно-белый',
        '9022 Перламутровый светло-серый',
        '9023 Перламутровый тёмно-серый',
    ],
    osnastka: ['---', 'Свой инструмент', 'Инструмент работодателя'],
    addosnastka: ['---', 'Допуск эл.безоп.3гр.', 'Допуск эл.безоп.4гр.', 'Допуск высотные работы'],
    perehod: ['Прямоуг.-Прямоуг.', 'Прямоуг.-Круг'],
    prtroynik: ['ППП', 'ПКП'],
    crtroynik: ['ККК', 'КПК', 'Штанообразный'],
    typec: ['1-Центр.', '2-Одностор.', '3-Смещ.'],
    vrezkazont: ['1шт.', '2шт.', '3шт.', '4шт.'],
    types: ['Спирально-навивной', 'Прямошовный'],
    zont: [
        'Островной',
        'Пристенный',
        'Приточно-вытяжной пристенный',
        'для мангала, барбекю',
        'Лабораторный зонт',
        'Промышленный',
        'Панель равномерного всасывания',
        'Зонт для сварочного участка',
        'для помещений с низким потолком',
    ],
    zontfilter: [
        '---',
        'Фланец (оц.-ш20/у65)',
        'Фланец (оц.-ш20/у95)',
        'Фланец (оц.-ш30/у105)',
        'Фланец (оц.-ш30К/у105)',
        'Фланец (оц.-ш15/у53)',
        'Фланец (оц.-ш15/у60)',
        'Фланец (AISI430-ш20/у65)',
        'Фланец (AISI430-ш20/у95)',
        'Фланец (AISI430-ш30/у105)',
        'Фланец (AISI304-ш20/у65)',
        'Фланец (AISI304-ш20/у95)',
        'Фланец (AISI304-ш30/у105)',
        'TDC/TDF 20 AISI430',
        'TDC/TDF 30 AISI430',
        'TDC/TDF 20 оц.',
        'TDC/TDF 30 оц.',
        'TDC/TDF 20 AISI304',
        'TDC/TDF 30 AISI304',
        'Рейка-оц.',
        'Рейка AISI430',
        'Рейка AISI304',
    ],
    zontosnastka: [
        '---',
        '<input class="cb pristine" type="checkbox">Конденсатосборник</input>',
        '<input class="cb pristine" type="checkbox">Жироуловитель лабиринтный оцинкованный</input>',
        '<input class="cb pristine" type="checkbox">Жироуловитель лабиринтный нержавеющий</input>',
        '<input class="cb pristine" type="checkbox">Жироуловитель сетчатый оцинкованный</input>',
        '<input class="cb pristine" type="checkbox">Жироуловитель сетчатый нержавеющий</input>',
        '<input class="cb pristine" type="checkbox">С фильтром</input>',
        '<input class="cb pristine" type="checkbox">Кран сливной</input>',
        '<input class="cb pristine" type="checkbox">Бокс для сбора жира</input>',
        '<input class="cb pristine" type="checkbox">Светильник+выключатель</input>',
        '<input class="cb pristine" type="checkbox">Запуск вытяжки при включении подсветки</input>',
        '<input class="cb pristine" type="checkbox">Гидро-затвор</input>',
        '<input class="cb pristine" type="checkbox">Приточный бокс</input>',
    ],
    suspension: [
        '---',
        '<input class=\'cb pristine\' type=\'checkbox\' checked><img src=\'/wp-content/uploads/2022/03/vozduhovod/Прямоугольные/Suspension/Проушины.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Заводские проушины</input>',
        '<h4><a href=\'#popmake-6462\'><img src=\'/wp-content/uploads/2022/03/spilka.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>Шпилька М8</h4>',
        '<h4><a href=\'#popmake-6462\'><img src=\'/wp-content/uploads/2022/03/spilka.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>Шпилька М10</h4>',
        '<h4><a href=\'#popmake-6462\'><img src=\'/wp-content/uploads/2022/03/spilka.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a>Шпилька М12</h4>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/vozduhovod/Прямоугольные/Suspension/Трос.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Трос</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/vozduhovod/Прямоугольные/Suspension/Рым-болт.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Рым-болт</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/vozduhovod/Прямоугольные/Suspension/Талреп.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Талреп</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/vozduhovod/Прямоугольные/Suspension/Зажим.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Зажим</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/vozduhovod/Прямоугольные/Suspension/Карабин.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Карабин</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/krepezh_s_vibroizolyatorom_l_obraznyy.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' /> L</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/krepezh_s_vibroizolyatorom_z_obraznyy.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Z</input>',
        '<input class=\'cb pristine\' type=\'checkbox\'><img src=\'/wp-content/uploads/2022/03/vozduhovod/Прямоугольные/Suspension/Цепь.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /> Цепь</input>'
    ],
    gal: [
        'Фланец (оц.-ш20/у65)',
        'Фланец (оц.-ш30/у105)',
        'Фланец (оц.-ш20/у95)',
        'Фланец (оц.-ш30К/у105)',
        'Фланец (оц.-ш15/у53)',
        'Фланец (оц.-ш15/у60)',
        'Уголок 25х25х4',
        'Уголок 32х32х4',
        'Уголок 40х40х4',
        'Уголок 50х50х5',
    ],
    roof: [
        '<h4><img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange20.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш30/у105</h4>',
        'Фланец (оц.-ш20/у95)',
        'Фланец (оц.-ш30К/у105)',
        'Фланец (оц.-ш15/у53)',
        'Фланец (оц.-ш15/у60)',
        'TDC/TDF 20 AISI430',
        'TDC/TDF 30 AISI430',
        'TDC/TDF 20 оц.',
        'TDC/TDF 30 оц.',
        'TDC/TDF 20 AISI304',
        'TDC/TDF 30 AISI304',
        'Фланец свободный (СВ-оц.-ш20/у65)',
        'Фланец свободный (СВ-оц.-ш20/у95)',
        'Фланец свободный (СВ-оц.-ш30/у105)',
        'Фланец свободный (СВ-оц.-ш15/у53)',
        'Фланец свободный (СВ-оц.-ш15/у60)',
        'Фланец свободный (СВ-оц.-ш30К/у105)',
        'Отбортовка 15', 'Отбортовка 30',
        'Рейка-оц.', 'Рейка AISI430',
        'Рейка AISI304',
        'Фланец свободный углер.ст.Уголок 25х25х4',
        'Фланец свободный углер.ст.Уголок 32х32х4',
        'Фланец свободный углер.ст.Уголок 40х40х4',
        'Фланец свободный углер.ст.Уголок 50х50х5',
        'Фланец приварной углер.ст.Уголок 25х25х4',
        'Фланец приварной углер.ст.Уголок 32х32х4',
        'Фланец приварной углер.ст.Уголок 40х40х4',
        'Фланец приварной углер.ст.Уголок 50х50х5',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.5',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 2.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 3.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 4.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 6.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.5',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 2.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 3.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 4.0',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 6.0',
        'Фланец (AISI430-ш20/у65)',
        'Фланец (AISI430-ш20/у95)',
        'Фланец (AISI430-ш30/у105)',
        'Фланец (AISI304-ш20/у65)',
        'Фланец (AISI304-ш20/у95)',
        'Фланец (AISI304-ш30/у105)',
        'Фланец свободный (СВ-AISI430-ш20/у65)',
        'Фланец свободный (СВ-AISI430-ш20/у95)',
        'Фланец свободный (СВ-AISI430-ш30/у105)',
        'Фланец свободный (СВ-AISI304-ш20/у65)',
        'Фланец свободный (СВ-AISI304-ш20/у95)',
        'Фланец свободный (СВ-AISI304-ш30/у105)',
        '---',
    ],
    flangezont: ['<h4><img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange20.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20/у65</h4>',
        '<h4><img onmouseover=\'new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/flange30.mp3`).play();\' src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш30/у105</h4>',
        '<h4>---</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш20/у65)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш20/у95)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш30/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш15/у53)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш15/у60)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />свободный(оц.ш30К/у105)</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 5х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 12.5х12.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Отбортовка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Отбортовка 15</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Отбортовка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Отбортовка 30</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Уголок.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />свободный углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Полоса.webp\' class=\'scale\' style=\'width: 100px; height: auto;\' />приварной углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI430-ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI430-ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI430-ш30/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI304-ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI304-ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />AISI304-ш30/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI430-ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI430-ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI430-ш30/у105</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI304-ш20/у65</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI304-ш20/у95</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />свободный AISI304-ш30/у105</h4>'],
    wangle: ['--', '45°гр.'],
    vrezkapr: ['-в круг', '-в прямоуг.'],
    nalog: ['ОСН', 'УСН', 'ИП', 'Патент'],
    plen: [
        'Врезка сверху круг',
        'Врезка сбоку круг',
        '---',
        'Врезка сверху прямоуг.',
        'Врезка сбоку прямоуг.',
    ],
    cflange: ['---',
        '<h4><img title=\'Ниппель оцинкованный\' src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' > оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' />Бандаж оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' />Ниппель AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' />Ниппель AISI304</h4>',
        '<h4>Выброс <a href=\'#popmake-6453\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/3. Прямой скошенный.png\' alt=\'1-1-1\' class=\'scale\' style=\'width: 60px; height: auto;\'></a> горизонтальный</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/grid.png\' style=\'width: 50px; height: auto;\' />Сетка 5х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/grid.png\' style=\'width: 50px; height: auto;\' />Сетка 12.5х12.5</h4>',
        '<h4>Отбортовка 30</h4>', '<h4>Отбортовка 15</h4>', '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец свободный углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец свободный углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец свободный углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец свободный углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец приварной углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец приварной углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец приварной углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец приварной углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' />Бандаж AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' />Бандаж AISI304</h4>',
        '<h4>Резинка уплотнительная',
    ],
    systemfasteners: [
        '<h4>---</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/траверса.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' />Траверса и высота до 1м <a href=\'#popmake-6462\'><img src=\'/wp-content/uploads/2022/03/spilka.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a></h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/траверса.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' />Траверса и высота до 2м <a href=\'#popmake-6462\'><img src=\'/wp-content/uploads/2022/03/spilka.png\' class=\'scale\' style=\'width: 40px; height: auto;\' /></a></h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/перфолента.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Перфолента до 1м 230кг</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/krepezh_s_vibroizolyatorom_l_obraznyy.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' />L-крепеж и высота до 1м</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/krepezh_s_vibroizolyatorom_z_obraznyy.png\' class=\'scale\' style=\'width: 40px; height: auto;\' />Z-крепеж и высота до 1м</h4>',
        '<h4><img src=\'/wp-content/uploads/2022/03/krepezh_s_vibroizolyatorom_v_obraznyy.webp\' class=\'scale\' style=\'width: 40px; height: auto;\' />V-крепеж и высота до 1м</h4>',
        '<h4>Улица вертикально</h4>',
        '<h4>Улица горизонтально</h4>',
    ],
    systemfastenersround: [
        '<h4>---</h4>',
        'Хомут и высота до 1м',
        'Хомут и высота до 2м',
        '<h4><img src=\'/wp-content/uploads/2022/03/перфолента.png\' class=\'scale\' style=\'width: 100px; height: auto;\' />Перфолента и высота до 1м</h4>',
        '<h4>Улица вертикально</h4>',
    ],
    sflange: ['<h4>---</h4>',
        '<h4><img title=\'Ниппель оцинкованный\' src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' class=\'scale\' style=\'width: 50px; height: auto;\' > оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' class=\'scale\' alt=\'12-1-1\' />Ниппель оц.резинка</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' class=\'scale\' alt=\'12-1-1\' />Ниппель AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' class=\'scale\' alt=\'12-1-1\' />Ниппель AISI304</h4>',
        '<h4>Выброс горизонтальный <a href=\'#popmake-6453\'><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/3. Прямой скошенный.png\' alt=\'1-1-1\' class=\'scale\' style=\'width: 60px; height: auto;\'></a></h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 5х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/grid.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Сетка 12.5х12.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Отбортовка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Отбортовка 15</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Отбортовка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Отбортовка 30</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/раструб.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />➕Раструб мама</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/раструб.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />➖Раструб папа</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' class=\'scale\' style=\'width: 50px; height: auto;\' />Муфта оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' class=\'scale\' style=\'width: 50px; height: auto;\' />Муфта AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' class=\'scale\' style=\'width: 50px; height: auto;\' />Муфта AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' class=\'scale\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' class=\'scale\' />Бандаж оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' class=\'scale\' />Бандаж оц.Бутерпол 14791-79</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' class=\'scale\' />Бандаж AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' class=\'scale\' />Бандаж AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Резинка уплотнительная.png\' alt=\'12-1-2\' class=\'scale\' />Резинка уплотнительная</h4>',
        '<h4>Решетка + Сетка 5х5</h4>', '<h4>Решетка + Сетка 12.5х12.5</h4>'],
    sf: [
        '---',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' />Ниппель оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' />Ниппель AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' />Ниппель AISI304</h4>',
        '<h4>Отбортовка 30</h4>',
        '<h4>Отбортовка 15</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' />Бандаж оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' />Бандаж AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-2.png\' alt=\'12-1-2\' />Бандаж AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' />Муфта оц.</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' />Муфта AISI430</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-1.png\' alt=\'12-1-1\' />Муфта AISI304</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/12-1-3.png\' alt=\'12-1-3\' />Фланец свободный углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 1.5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 2.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 3.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 4.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Полоса.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Полоса 6.0</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' style=\'width: 50px; height: auto;\' />Фланец свободный углер.ст.Уголок 50х50х5</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Уголок 25х25х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Уголок 32х32х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Уголок 40х40х4</h4>',
        '<h4><img src=\'/wp-content/themes/mesmerize-child/assets/img/Круглый/Уголок.png\' style=\'width: 50px; height: auto;\' />Фланец приварной углер.ст.Уголок 50х50х5</h4>',
        '<h4>Резинка уплотнительная</h4>',
    ],
    floor: [
        '---',
        'цоколь',
        'подвал',
        '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟',
        '-1️⃣', '-2️⃣', '-3️⃣', '-4️⃣', '-5️⃣', '1️⃣1️⃣', '1️⃣2️⃣', '1️⃣3️⃣', '1️⃣4', '1️⃣5', '1️⃣6', '1️⃣7', '1️⃣8', '1️⃣9',
        '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33',
        '34', '35', '36', '37', '38', '39', '40', 'тех. этаж', 'кровля', 'Отм.-1000',
        'Отм.-2000', 'Отм.-3000', 'Отм.-4000', 'Отм.-5000', 'Отм.-6000', 'Отм.-7000',
        'Отм.-8000', 'Отм.-9000', 'Отм.-10000', 'Отм.0', 'Отм.+1000', 'Отм.+2000',
        'Отм.+3000', 'Отм.+4000', 'Отм.+5000', 'Отм.+6000', 'Отм.+7000', 'Отм.+8000',
        'Отм.+9000', 'Отм.+10000', 'Отм.+11000', 'Отм.+12000', 'Отм.+13000',
        'Отм.+14000', 'Отм.+15000', 'Отм.+16000', 'Отм.+17000', 'Отм.+18000',
        'Отм.+19000', 'Отм.+20000', 'Отм.+21000', 'Отм.+22000', 'Отм.+23000',
        'Отм.+24000', 'Отм.+25000', 'Отм.+26000', 'Отм.+27000', 'Отм.+28000',
        'Отм.+29000', 'Отм.+30000', 'Отм.+31000', 'Отм.+32000', 'Отм.+33000',
        'Отм.+34000', 'Отм.+35000', 'Отм.+36000', 'Отм.+37000', 'Отм.+38000',
        'Отм.+39000', 'Отм.+40000',
    ],
    df: [
        '---', 'В1️⃣', 'В1️⃣Резерв', 'В2', 'В3', 'В4', 'В5', 'В6', 'В7', 'В8', 'В9', 'В🔟',
        'В11', 'В12', 'В13', 'В14', 'В15', 'В16', 'В17', 'В18', 'В19', 'В20', 'В21', 'В22',
        'В23', 'В24', 'В25', 'В26', 'В27', 'В28', 'В29', 'В30', 'В31', 'В32', 'В33', 'В34',
        'В35', 'В36', 'В37', 'В38', 'В39', 'В40', 'В41',
        'В42', 'В43', 'В44', 'В45', 'В46', 'В47', 'В48', 'В49', 'В50', 'В51', 'В52', 'В53',
        'В54', 'В55', 'В56', 'В57', 'В58', 'В59', 'В50', 'В51', 'В52', 'В53', 'В54', 'В55',
        'В56', 'В57', 'В58', 'В59', 'В60', 'ВЕ1', 'ВЕ2', 'ВЕ3', 'ВЕ4', 'ВЕ5', 'ВЕ6', 'ВЕ7',
        'ВЕ8', 'ВЕ9', 'ВЕ10', 'ВЕ11', 'ВЕ12', 'ВЕ13', 'ВЕ14', 'ВЕ15', 'ВЕ16', 'ВЕ17',
        'ВЕ18', 'ВЕ19', 'ВЕ20', 'ВЕ21', 'ВЕ22', 'ВЕ23', 'ВЕ24', 'ВЕ25', 'ВЕ26', 'ВЕ27',
        'ВЕ28', 'ВЕ29', 'ВЕ30',
    ],
    vz: [
        '---', 'В1️⃣', 'В2', 'В3', 'В4', 'В5', 'В6', 'В7', 'В8', 'В9', 'В🔟', 'В11',
        'В12', 'В13', 'В14', 'В15', 'В16', 'В17', 'В18', 'В19', 'В20', 'В21', 'В22',
        'В23', 'В24', 'В25', 'В26', 'В27', 'В28', 'В29', 'В30', 'В31', 'В32', 'В33',
        'В34', 'В35', 'В36', 'В37', 'В38', 'В39', 'В40', 'В41', 'В42', 'В43', 'В44',
        'В45', 'В46', 'В47', 'В48', 'В49', 'В50', 'В51', 'В52', 'В53', 'В54', 'В55',
        'В56', 'В57', 'В58', 'В59', 'В60', 'В61', 'В62', 'В63', 'В64', 'В65', 'В66',
        'В67', 'В68', 'В69', 'В70',
    ],
    p: [
        '---', 'П1️⃣', 'П1️⃣Резерв', 'П2', 'П2Резерв', 'П3', 'П4', 'П5', 'П6', 'П7',
        'П8', 'П9', 'П🔟', 'П11', 'П12', 'П13', 'П14', 'П15', 'П16', 'П17', 'П18',
        'П19', 'П20', 'П21', 'П22', 'П23', 'П24', 'П25', 'П26', 'П27', 'П28', 'П29',
        'П30', 'П31', 'П32', 'П33', 'П34', 'П35', 'П36', 'П37', 'П38', 'П39', 'П40',
        'П41', 'П42', 'П43', 'П44', 'П45', 'П46', 'П47', 'П48', 'П49', 'П50', 'П51',
        'П52', 'П53', 'П54', 'П55', 'П56', 'П57', 'П58', 'П59', 'П60', 'П61', 'П62',
        'П63', 'П64', 'П65', 'П66', 'П67', 'П68', 'П69', 'П70', 'ПЕ1', 'ПЕ2', 'ПЕ3',
        'ПЕ4', 'ПЕ5', 'ПЕ6', 'ПЕ7', 'ПЕ8', 'ПЕ9', 'ПЕ10', 'ПЕ11', 'ПЕ12', 'ПЕ13',
        'ПЕ14', 'ПЕ15', 'ПЕ16', 'ПЕ17', 'ПЕ18', 'ПЕ19', 'ПЕ20', 'ПЕ21', 'ПЕ22',
        'ПЕ23', 'ПЕ24', 'ПЕ25', 'ПЕ26', 'ПЕ27', 'ПЕ28', 'ПЕ29', 'ПЕ30', 'ВЕ1',
        'ВЕ2', 'ВЕ3', 'ВЕ4', 'ВЕ5', 'ВЕ6', 'ВЕ7', 'ВЕ8', 'ВЕ9', 'ВЕ10', 'ВЕ11',
        'ВЕ12', 'ВЕ13', 'ВЕ14', 'ВЕ15', 'ВЕ16', 'ВЕ17', 'ВЕ18', 'ВЕ19', 'ВЕ20',
        'ВЕ21', 'ВЕ22', 'ВЕ23', 'ВЕ24', 'ВЕ25', 'ВЕ26', 'ВЕ27', 'ВЕ28', 'ВЕ29',
        'ВЕ30', 'В1', 'В1Резерв', 'В2', 'В2Резерв', 'В3', 'В4', 'В5', 'В6', 'В7',
        'В8', 'В9', 'В10', 'В11', 'В12', 'В13', 'В14', 'В15', 'В16', 'В17', 'В18',
        'В19', 'В20', 'В21', 'В22', 'В23', 'В24', 'В25', 'В26', 'В27', 'В28', 'В29',
        'В30', 'В31', 'В32', 'В33', 'В34', 'В35', 'В36', 'В37', 'В38', 'В39', 'В40',
        'В41', 'В42', 'В43', 'В44', 'В45', 'В46', 'В47', 'В48', 'В49', 'В50', 'В51',
        'В52', 'В53', 'В54', 'В55', 'В56', 'В57', 'В58', 'В59', 'В50', 'В51', 'В52',
        'В53', 'В54', 'В55', 'В56', 'В57', 'В58', 'В59', 'В60', 'ПВ1', 'ПВ1Резерв',
        'ПВ2', 'ПВ2Резерв', 'ПВ3', 'ПВ4', 'ПВ5', 'ПВ6', 'ПВ7', 'ПВ8', 'ПВ9', 'ПВ10',
        'ПВ11', 'ПВ12', 'ПВ13', 'ПВ14', 'ПВ15', 'ПВ16', 'ПВ17', 'ПВ18', 'ПВ19', 'ПВ20',
        'ПВ21', 'ПВ22', 'ПВ23', 'ПВ24', 'ПВ25', 'ПВ26', 'ПВ27', 'ПВ28', 'ПВ29', 'ПВ30',
        'ПВ31', 'ПВ32', 'ПВ33', 'ПВ34', 'ПВ35', 'ПВ36', 'ПВ37', 'ПВ38', 'ПВ39', 'ПВ40',
        'ПВ41', 'ПВ42', 'ПВ43', 'ПВ44', 'ПВ45', 'ПВ46', 'ПВ47', 'ПВ48', 'ПВ49', 'ПВ50',
        'ПВ51', 'ПВ52', 'ПВ53', 'ПВ54', 'ПВ55', 'ПВ56', 'ПВ57', 'ПВ58', 'ПВ59', 'ПВ50',
        'ПВ51', 'ПВ52', 'ПВ53', 'ПВ54', 'ПВ55', 'ПВ56', 'ПВ57', 'ПВ58', 'ПВ59', 'ПВ60',
        'ПД1', 'ПД2', 'ПД3', 'ПД4', 'ПД5', 'ПД6', 'ПД7', 'ПД8', 'ПД9', 'ПД10', 'ПД11',
        'ПД12', 'ПД13', 'ПД14', 'ПД15', 'ПД16', 'ПД17', 'ПД18', 'ПД19', 'ПД20', 'ПД21',
        'ПД22', 'ПД23', 'ПД24', 'ПД25', 'ПД26', 'ПД27', 'ПД28', 'ПД29', 'ПД30', 'ПД31',
        'ПД32', 'ПД33', 'ПД34', 'ПД35', 'ПД36', 'ПД37', 'ПД38', 'ПД39', 'ПД40', 'ПД41',
        'ПД42', 'ПД43', 'ПД44', 'ПД45', 'ПД46', 'ПД47', 'ПД48', 'ПД49', 'ПД50', 'ПД51',
        'ПД52', 'ПД53', 'ПД54', 'ПД55', 'ПД56', 'ПД57', 'ПД58', 'ПД59', 'ПД60', 'ПД61',
        'ПД62', 'ПД63', 'ПД64', 'ПД65', 'ПД66', 'ПД67', 'ПД68', 'ПД69', 'ПД70', 'ПДЕ1',
        'ПДЕ2', 'ПДЕ3', 'ПДЕ4', 'ПДЕ5', 'ПДЕ6', 'ПДЕ7', 'ПДЕ8', 'ПДЕ9', 'ПДЕ10', 'ПДЕ11',
        'ПДЕ12', 'ПДЕ13', 'ПДЕ14', 'ПДЕ15', 'ПДЕ16', 'ПДЕ17', 'ПДЕ18', 'ПДЕ19', 'ПДЕ20',
        'ПДЕ21', 'ПДЕ22', 'ПДЕ23', 'ПДЕ24', 'ПДЕ25', 'ПДЕ26', 'ПДЕ27', 'ПДЕ28', 'ПДЕ29',
        'ПДЕ30', 'ВД1', 'ВД2', 'ВД3', 'ВД4', 'ВД5', 'ВД6', 'ВД7', 'ВД8', 'ВД9', 'ВД10',
        'ВД11', 'ВД12', 'ВД13', 'ВД14', 'ВД15', 'ВД16', 'ВД17', 'ВД18', 'ВД19', 'ВД20',
        'ВД21', 'ВД22', 'ВД23', 'ВД24', 'ВД25', 'ВД26', 'ВД27', 'ВД28', 'ВД29', 'ВД30',
        'ВД31', 'ВД32', 'ВД33', 'ВД34', 'ВД35', 'ВД36', 'ВД37', 'ВД38', 'ВД39', 'ВД40',
        'ВД41', 'ВД42', 'ВД43', 'ВД44', 'ВД45', 'ВД46', 'ВД47', 'ВД48', 'ВД49', 'ВД50',
        'ВД51', 'ВД52', 'ВД53', 'ВД54', 'ВД55', 'ВД56', 'ВД57', 'ВД58', 'ВД59', 'ВД60',
        'ВД61', 'ВД62', 'ВД63', 'ВД64', 'ВД65', 'ВД66', 'ВД67', 'ВД68', 'ВД69', 'ВД70',
        'К1', 'К2', 'К3', 'К4', 'К5', 'К6', 'К7', 'К8', 'К9', 'К10', 'К11', 'К12', 'К13',
        'К14', 'К15', 'К16', 'К17', 'К18', 'К19', 'К20', 'К21', 'К22', 'К23', 'К24',
        'К25', 'К26', 'К27', 'К28', 'К29', 'К30', 'У1', 'У2', 'У3', 'У4', 'У5', 'У6', 'У7',
        'У8', 'У9', 'У10', 'У11', 'У12', 'У13', 'У14', 'У15', 'У16', 'У17', 'У18', 'У19',
        'У20', 'У21', 'У22', 'У23', 'У24', 'У25', 'У26', 'У27', 'У28', 'У29', 'У30',
    ],
    ral: [
        '---',
        '<img src=\'/wp-content/themes/mesmerize-child/assets/img/Ral/1000.jpg\' class=\'scale\' style=\'width: 50px; height: auto;\' />1000-Зелёно-бежевый',
        '1001-Бежевый',
        '🟨1003-Сигнальный жёлтый',
        '1004-Жёлто-золотой', '1004-Жёлто-золотой', '1006-Кукурузно-жёлтый',
        '1007 Нарциссово-жёлтый', '1011 Коричнево-бежевый',
        '1012 Лимонно-жёлтый', '1013 Жемчужно-белый', '1014 Слоновая кость',
        '1015 Светлая слоновая кость', '1016 Жёлтая сера',
        '1017 Шафраново-жёлтый',
        '1018 Цинково-жёлтый', '1019 Серо-бежевый', '1020 Оливково-жёлтый',
        '1021 Рапсово-жёлтый', '1023 Транспортно-жёлтый', '1024 Охра жёлтая',
        '1026 Люминесцентный жёлтый', '1027 Карри жёлтый',
        '1028 Дынно-жёлтый', '1032 Жёлтый ракитник',
        '1033 Георгиново-жёлтый', '1034 Пастельно-жёлтый',
        '1035 Перламутрово-бежевый',
        '1036 Перламутрово-золотой',
        '1037 Солнечно-жёлтый',
        '2000 Жёлто-оранжевый',
        '2001 Красно-оранжевый',
        '2002 Алый', '2003 Пастельно-оранжевый',
        '🟧2004 Оранжевый',
        '2005 Люминесцентный оранжевый',
        '2007 Люминесцентный ярко-оранжевый',
        '2008 Ярко-красно-оранжевый',
        '2009 Транспортный оранжевый',
        '2010 Сигнальный оранжевый',
        '2011 Насыщенный оранжевый',
        '2012 Лососёво-оранжевый',
        '2013 Перламутрово-оранжевый',
        '🟥3000 Огненно-красный',
        '3001 Сигнальный красный',
        '3002 Карминно-красный',
        '3003 Рубиново-красный',
        '3004 Пурпурно-красный',
        '3005 Винно-красный',
        '3007 Чёрно-красный',
        '3009 Оксид красный',
        '3011 Коричнево-красный',
        '3012 Бежево-красный',
        '3013 Томатно-красный',
        '3014 Розовый антик',
        '3015 Светло-розовый',
        '3016 Кораллово-красный',
        '3017 Розовый',
        '3018 Клубнично-красный',
        '3020 Транспортный красный',
        '3022 Лососёво-красный',
        '3024 Люминесцентный красный',
        '3026 Люминесцентный ярко-красный',
        '3027 Малиново-красный',
        '3028 Красный',
        '3031 Ориент красный',
        '3032 Перламутрово-рубиновый',
        '3033 Перламутрово-розовый',
        '4001 Красно-сиреневый',
        '4002 Красно-фиолетовый',
        '4003 Вересково-фиолетовый',
        '4004 Бордово-фиолетовый',
        '4005 Сине-сиреневый',
        '4006 Транспортный пурпурный',
        '4007 Пурпурно-фиолетовый',
        '🟪4008 Сигнальный фиолетовый',
        '4009 Пастельно-фиолетовый',
        '4010 Телемагента',
        '4011 Перламутрово-фиолетовый',
        '4012 Перламутрово-ежевичный',
        '5000 Фиолетово-синий',
        '5001 Зелёно-синий',
        '5002 Ультрамариново-синий',
        '5003 Сапфирово-синий',
        '5004 Чёрно-синий',
        '🟦5005 Сигнальный синий',
        '5007 Бриллиантово-синий',
        '5008 Серо-синий',
        '5009 Лазурно-синий',
        '5010 Горечавково-синий',
        '5011 Стально-синий',
        '5012 Голубой',
        '5013 Кобальтово-синий',
        '5014 Голубино-синий',
        '5015 Небесно-синий',
        '5017 Транспортный синий',
        '5018 Бирюзово-синий',
        '5019 Капри синий',
        '5020 Океанская синь',
        '5021 Водная синь',
        '5022 Ночной синий',
        '5023 Отдалённо-синий',
        '5024 Пастельно-синий',
        '5025 Перламутровый горечавково-синий',
        '5026 Перламутровый ночной синий',
        '6000 Патиново-зелёный',
        '6001 Изумрудно-зелёный',
        '6002 Лиственно-зелёный',
        '6003 Оливково-зелёный',
        '6004 Сине-зелёный',
        '🟩6005 Зелёный мох',
        '6006 Серо-оливковый',
        '6007 Бутылочно-зелёный',
        '6008 Коричнево-зелёный',
        '6009 Пихтовый зелёный',
        '6010 Травяной зелёный',
        '6011 Резедово-зелёный',
        '6012 Чёрно-зелёный',
        '6013 Тростниково-зелёный',
        '6014 Жёлто-оливковый',
        '6015 Чёрно-оливковый',
        '6016 Бирюзово-зелёный',
        '6017 Майский зелёный',
        '6018 Желто-зелёный',
        '6019 Бело-зелёный',
        '6020 Хромовый зелёный',
        '6021 Бледно-зелёный',
        '6022 Коричнево-оливковый',
        '6024 Транспортный зелёный',
        '6025 Папоротниково-зелёный',
        '6026 Опаловый зелёный',
        '6027 Светло-зелёный',
        '6028 Сосновый зелёный',
        '6029 Мятно-зелёный',
        '6032 Сигнальный зелёный',
        '6033 Мятно-бирюзовый',
        '6034 Пастельно-бирюзовый',
        '6035 Перламутрово-зелёный',
        '6036 Перламутровый опаловый зелёный',
        '6037 Зелёный',
        '6038 Люминесцентный зелёный',
        '7000 Серая белка',
        '7001 Серебристо-серый',
        '7002 Оливково-серый',
        '7003 Серый мох',
        '7004 Сигнальный серый',
        '7005 Мышино-серый',
        '7006 Бежево-серый',
        '7008 Серое хаки',
        '7009 Зелёно-серый',
        '7010 Брезентово-серый',
        '7011 Железно-серый',
        '7012 Базальтово-серый',
        '7013 Коричнево-серый',
        '7015 Сланцево-серый',
        '7016 Антрацитово-серый',
        '7021 Чёрно-серый',
        '7022 Серая умбра',
        '7023 Серый бетон',
        '7024 Графитовый серый',
        '7026 Гранитовый серый',
        '7030 Каменно-серый',
        '7031 Сине-серый',
        '7032 Галечный серый',
        '7033 Цементно-серый',
        '7034 Жёлто-серый',
        '7035 Светло-серый',
        '7036 Платиново-серый',
        '7037 Пыльно-серый',
        '7038 Агатовый серый',
        '7039 Кварцевый серый',
        '7040 Серое окно',
        '7042 Транспортный серый A',
        '7043 Транспортный серый B',
        '7044 Серый шёлк',
        '7045 Телегрей 1',
        '7046 Телегрей 2',
        '7047 Телегрей 3',
        '7048 Перламутровый мышино-серый',
        '8000 Зелёно-коричневый',
        '8001 Охра коричневая',
        '🟫8002 Сигнальный коричневый',
        '8003 Глиняный коричневый',
        '8004 Медно-коричневый',
        '8007 Олень коричневый',
        '8008 Оливково-коричневый',
        '8011 Орехово-коричневый',
        '8012 Красно-коричневый',
        '8014 Сепия коричневый',
        '8015 Каштаново-коричневый',
        '8016 Махагон коричневый',
        '8017 Шоколадно-коричневый',
        '8019 Серо-коричневый',
        '8022 Чёрно-коричневый',
        '8023 Оранжево-коричневый',
        '8024 Бежево-коричневый',
        '8025 Бледно-коричневый',
        '8028 Терракотовый',
        '8029 Перламутровый медный',
        '9001 Кремово-белый',
        '9002 Светло-серый',
        '◻️9003 Сигнальный белый',
        '◼️9004 Сигнальный чёрный',
        '9005 Чёрный янтарь',
        '9006 Бело-алюминиевый',
        '9007 Тёмно-алюминиевый',
        '9010 Белый',
        '9011 Графитно-чёрный',
        '9016 Транспортный белый',
        '9017 Транспортный чёрный',
        '9018 Папирусно-белый',
        '9022 Перламутровый светло-серый',
        '9023 Перламутровый тёмно-серый',
        'НАНЕСЕНИЕ ЖАРОСТОЙКОГО ПОКРЫТИЯ',
        'Грунтовка ФЛ-03К',
        'Грунтовка ГФ-021 серый',
        'Грунтовка ГФ-021 красно-коричневая ТУ',
    ],
    angle: ['90', '45', '30', '60', '15', '130'],
    anglea: ['45', '30', '60', '15', '90', '130'],
};
